var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankGuarantee(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2475 1650",
    style: {
      enableBackground: "new 0 0 2475 1650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 2475,
    height: 1650
  })), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.5315,
    y1: 800.3384,
    x2: 2338.8762,
    y2: 800.3384
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2275.344,867.901c-38.929-38.207-84.965-75.471-96.971-127.346 c-20.774-89.766,68.055-166.307,97.134-253.978c20.107-60.621,9.733-129.643-27.434-182.536 c-37.167-52.893-100.373-88.585-167.157-94.39c-114.91-9.99-227.365,63.377-340.558,42.13 c-90.634-17.013-162.256-92.063-254.261-100.103c-108.264-9.46-198.091,75.221-301.477,107.104 c-123.661,38.136-257.733-1.719-379.312-45.454c-121.579-43.735-249.495-92.531-377.651-71.599 c-142.653,23.3-262.258,141.078-281.338,277.041c-18.909,134.744,139.674,242.908,4.682,404.699 c-42.185,50.56-70.244,120.954-51.596,182.936c18.12,60.223,95.227,98.313,95.788,160.933 c0.442,49.435-48.75,88.769-52.712,138.063c-3.401,42.311,28.714,81.427,68.183,101.479 c39.468,20.052,85.261,24.956,129.787,29.501l-13.125,13.369c224.274,19.075,449.944,14.829,675.075,10.567 c355.033-6.722,710.066-13.444,1065.1-20.166c36.488-0.691,73.863-1.541,107.861-14.113s64.491-39.483,69.669-73.713 c8.813-58.255-55.451-108.811-49.512-167.391c7.583-74.803,118.751-103.661,139.905-176.087 C2350.372,957.663,2314.273,906.108,2275.344,867.901z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2336.38,636.628c-5.151,50.678-47.169,344.368-329.846,354.442 c0,0-46.066-209.458,323.774-358.806C2333.394,631.018,2336.717,633.317,2336.38,636.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE5FE"
    },
    d: "M2302.063,674.551c-8.892,15.134-18.319,29.896-27.959,44.535 c-9.672,14.614-19.64,29.032-29.884,43.253c-10.236,14.227-20.785,28.231-31.637,41.998 c-10.868,13.753-21.952,27.346-33.483,40.56c-2.829,3.35-5.802,6.575-8.698,9.867l-4.371,4.915 c-1.464,1.632-2.968,3.228-4.45,4.844c-2.984,3.213-5.927,6.466-8.945,9.648l-9.115,9.491c-1.506,1.594-3.057,3.146-4.616,4.689 l-4.66,4.647l-4.66,4.647c-1.567,1.535-3.172,3.032-4.757,4.55c-3.19,3.014-6.333,6.078-9.563,9.05l-9.766,8.835l-2.448,2.202 l-2.502,2.141l-5.005,4.283l-5.005,4.283c-1.685,1.408-3.415,2.763-5.12,4.147c-3.438,2.735-6.811,5.553-10.303,8.221 l-10.539,7.925c-14.23,10.331-28.989,19.966-44.385,28.553c-1.096,0.611-2.48,0.218-3.091-0.878 c-0.611-1.096-0.218-2.48,0.878-3.091l0.012-0.007l0.025-0.014c15.248-8.381,29.913-17.822,44.081-27.973l10.5-7.794 c3.481-2.624,6.847-5.402,10.276-8.095c1.701-1.364,3.427-2.698,5.109-4.086l4.999-4.224l4.999-4.224l2.5-2.112l2.447-2.173 l9.765-8.723c3.23-2.935,6.375-5.965,9.568-8.943c1.586-1.5,3.192-2.979,4.761-4.497l4.667-4.596l4.667-4.597 c1.561-1.527,3.115-3.062,4.625-4.64l9.136-9.394c3.026-3.15,5.978-6.372,8.971-9.555c1.487-1.601,2.994-3.182,4.464-4.799 l4.386-4.871c2.906-3.263,5.89-6.458,8.73-9.779c11.576-13.1,22.713-26.587,33.64-40.238 c10.911-13.666,21.524-27.574,31.828-41.708c10.312-14.128,20.352-28.458,30.097-42.985 c9.709-14.545,19.227-29.248,28.169-44.253l0.009-0.014c0.272-0.457,0.863-0.606,1.32-0.334 C2302.181,673.507,2302.331,674.095,2302.063,674.551z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178202452552468922650000015342843256457815947_",
    gradientUnits: "userSpaceOnUse",
    x1: 1860.924,
    y1: 1177.2559,
    x2: 1460.924,
    y2: 1551.2563
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178202452552468922650000015342843256457815947_)"
    },
    d: "M2086.959,940.677 c-0.181-5.667-8.038-10.331-17.668-10.331h-364.014c-9.76,0-19.345,4.907-19.345,10.651v513.44c0,2.764,2.705,5.413,6.029,7.365 c3.325,1.951,8.25,3.044,12.945,3.036l266.597,2.389c4.736-0.008,9.372-1.134,12.685-3.126c3.313-1.992,5.18-4.746,5.091-7.533 L2086.959,940.677z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.24
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1818.882,990.848 1715.183,990.766 1714.36,959.481 1818.16,959.481  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1935.118,990.833 1831.522,990.75 1830.813,959.481 1934.509,959.481  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "2051.237,990.817 1947.745,990.735 1947.148,959.481 2050.74,959.481  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1820.178,1047.004 1716.659,1047.043 1715.839,1015.962 1819.459,1015.937  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1936.211,1046.961 1832.796,1047 1832.089,1015.934 1935.604,1015.909  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "2052.128,1046.917 1948.817,1046.956 1948.222,1015.906 2051.633,1015.881  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1821.47,1102.775 1718.131,1102.839 1717.314,1071.865 1820.753,1071.815  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1937.301,1102.703 1834.066,1102.767 1833.361,1071.809 1936.696,1071.759  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "2053.016,1102.631 1949.884,1102.695 1949.292,1071.753 2052.523,1071.703  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1822.757,1158.352 1719.597,1158.441 1718.783,1127.574 1822.042,1127.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1938.387,1158.253 1835.331,1158.341 1834.629,1127.49 1937.784,1127.416  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "2053.902,1158.153 1950.948,1158.242 1950.358,1127.406 2053.41,1127.332  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1824.039,1213.737 1721.059,1213.85 1720.248,1183.091 1823.327,1182.991  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1939.469,1213.61 1836.592,1213.723 1835.892,1182.979 1938.868,1182.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "2054.784,1213.484 1952.009,1213.597 1951.42,1182.868 2054.294,1182.768  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1825.317,1268.931 1722.515,1269.069 1721.707,1238.415 1824.608,1238.291  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1940.548,1268.777 1837.848,1268.915 1837.15,1238.276 1939.949,1238.152  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "2055.663,1268.623 1953.066,1268.76 1952.479,1238.137 2055.175,1238.014  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1826.591,1323.935 1723.967,1324.097 1723.161,1293.549 1825.884,1293.401  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1941.622,1323.754 1839.1,1323.916 1838.405,1293.383 1941.026,1293.235  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "2056.539,1323.573 1954.119,1323.734 1953.534,1293.217 2056.053,1293.069  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1827.86,1378.75 1725.413,1378.936 1724.61,1348.493 1827.156,1348.321  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1942.693,1378.542 1840.348,1378.728 1839.655,1348.3 1942.099,1348.128  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "2057.412,1378.334 1955.168,1378.519 1954.586,1348.106 2056.927,1347.935  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1829.125,1433.377 1726.854,1433.586 1726.054,1403.248 1828.423,1403.052  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1943.761,1433.142 1841.591,1433.351 1840.901,1403.028 1943.168,1402.832  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M675.452,1307.321c-2.178,8.301-14.063,8.165-16.013-0.193 c-18.854-80.801-74.929-291.125-170.485-405.65C333.368,715.004,237.44,419.148,348.869,273.053 C348.869,273.053,912.747,402.851,675.452,1307.321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE5FE"
    },
    d: "M662.345,1192.612l-0.048-0.734l-0.081-0.841l-0.185-1.693l-0.411-3.399l-0.904-6.802 c-0.625-4.533-1.282-9.064-1.964-13.592c-1.354-9.056-2.762-18.105-4.24-27.143c-2.958-18.076-6.146-36.114-9.519-54.117 c-6.698-36.014-14.05-71.905-22.128-107.628c-4.025-17.865-8.262-35.681-12.63-53.463c-4.343-17.788-8.864-35.532-13.564-53.227 c-4.687-17.699-9.62-35.332-14.706-52.918c-5.083-17.587-10.378-35.112-15.906-52.563 c-11.065-34.895-22.75-69.597-35.56-103.885c-12.763-34.303-26.619-68.196-41.607-101.578 c-7.493-16.69-15.207-33.286-23.395-49.647c-8.175-16.365-16.579-32.624-25.533-48.58 c-8.917-15.972-18.056-31.833-27.805-47.321c-2.383-3.906-4.925-7.71-7.38-11.571l-3.718-5.769l-3.828-5.696l-3.814-5.707 l-1.907-2.854l-1.965-2.813l-7.861-11.257l-0.007-0.009c-0.304-0.435-0.197-1.034,0.238-1.338c0.426-0.297,1.01-0.2,1.319,0.212 c22.003,29.385,41.906,60.328,60.191,92.17c9.158,15.917,17.767,32.142,26.148,48.478c8.394,16.333,16.314,32.902,24.014,49.57 c7.734,16.655,14.916,33.557,21.968,50.506c7.052,16.951,13.727,34.055,20.218,51.225c6.505,17.166,12.676,34.455,18.67,51.803 c6.03,17.337,11.681,34.802,17.153,52.319c5.488,17.513,10.742,35.097,15.784,52.741c5.044,17.643,9.934,35.329,14.577,53.081 c4.656,17.748,9.132,35.541,13.428,53.378c4.278,17.841,8.31,35.74,12.191,53.669c7.732,35.865,14.857,71.86,21.1,108.01 c3.105,18.078,6.023,36.187,8.711,54.331c1.335,9.073,2.632,18.153,3.818,27.248c0.59,4.548,1.157,9.1,1.69,13.657l0.768,6.842 l0.345,3.432l0.153,1.727l0.066,0.871c0.022,0.293,0.025,0.657,0.032,0.982c0.012,0.527-0.404,0.964-0.931,0.977 c-0.513,0.012-0.941-0.383-0.975-0.89L662.345,1192.612z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2371.194,849.807c-315.889-16.883-578.369,314.118-684.843,577.805h334.571 C2200.798,1299.38,2433.318,1058.342,2371.194,849.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE5FE"
    },
    d: "M1857.107,1392.163c16.306-21.059,32.879-41.909,49.521-62.71 c16.699-20.756,33.642-41.315,50.77-61.73c8.579-10.195,17.193-20.362,25.917-30.436c8.734-10.064,17.532-20.074,26.396-30.026 c17.735-19.89,35.64-39.614,53.87-59.077c18.198-19.486,36.867-38.537,55.83-57.284c9.499-9.356,19.096-18.612,28.791-27.763 c9.698-9.148,19.44-18.249,29.341-27.178c19.792-17.867,39.925-35.356,60.465-52.356c10.291-8.475,20.724-16.777,31.261-24.943 c5.269-4.082,10.571-8.122,15.898-12.125c5.34-3.988,10.749-7.879,16.118-11.822c0.447-0.328,1.076-0.232,1.404,0.215 c0.322,0.438,0.236,1.051-0.189,1.384l-0.01,0.008c-10.478,8.206-20.939,16.42-31.238,24.835 c-10.314,8.396-20.469,16.984-30.57,25.632c-20.223,17.273-40.032,35.025-59.493,53.148 c-38.982,36.186-76.733,73.676-113.145,112.441c-18.235,19.35-36.111,39.076-53.995,58.775 c-8.914,9.872-17.764,19.802-26.551,29.789c-8.802,9.973-17.565,19.983-26.256,30.055 c-17.395,20.135-34.518,40.513-51.585,60.939c-17.118,20.386-33.996,40.976-50.981,61.484c-0.354,0.427-0.987,0.487-1.414,0.133 C1856.843,1393.205,1856.778,1392.59,1857.107,1392.163z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093864930273459080960000003830447405544137659_",
    gradientUnits: "userSpaceOnUse",
    x1: 1578.5958,
    y1: 957.5315,
    x2: 2034.5958,
    y2: 905.5315
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093864930273459080960000003830447405544137659_)"
    },
    d: "M1817.708,463.804 c-0.142-6.929-6.36-12.505-13.982-12.505h-462.253c-7.723,0-15.927,5.747-15.927,12.771v981.036 c0,5.242,3.266,10.269,7.348,13.972c4.082,3.702,10.102,5.774,15.867,5.76l467.316-1.16c5.815-0.014,11.501-2.151,15.569-5.93 c4.068-3.779,6.357-8.898,6.248-14.186L1817.708,463.804z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1552.243,520.823 1401.029,520.348 1401.086,503.143 1552.13,503.577  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1552.657,584.195 1400.822,583.565 1400.879,566.219 1552.544,566.806  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1553.075,648.091 1400.613,647.304 1400.671,629.814 1552.961,630.558  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1553.497,712.517 1400.402,711.571 1400.46,693.937 1553.381,694.839  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1553.922,777.48 1400.19,776.372 1400.249,758.591 1553.805,759.654  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1554.782,909.043 1399.76,907.603 1399.819,889.523 1554.664,890.916  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1556.101,1110.587 1399.101,1108.628 1399.162,1090.085 1555.979,1091.995  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1554.35,842.986 1399.976,841.714 1400.035,823.784 1554.233,825.011  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1555.218,975.658 1399.542,974.048 1399.602,955.815 1555.099,957.378  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1555.658,1042.837 1399.323,1041.054 1399.383,1022.666 1555.537,1024.402  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1556.548,1178.916 1398.878,1176.779 1398.939,1158.077 1556.425,1160.165  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1556.999,1247.832 1398.652,1245.513 1398.714,1226.651 1556.875,1228.919  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1557.454,1317.343 1398.425,1314.839 1398.488,1295.814 1557.329,1298.267  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1557.912,1387.455 1398.196,1384.763 1398.259,1365.574 1557.786,1368.214  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1750.495,521.448 1598.333,520.969 1598.168,503.709 1750.16,504.146  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1751.73,585.021 1598.938,584.387 1598.772,566.985 1751.391,567.577  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1752.974,649.122 1599.547,648.33 1599.38,630.784 1752.633,631.533  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1754.229,713.758 1600.162,712.806 1599.993,695.114 1753.884,696.022  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1755.494,778.933 1600.782,777.818 1600.612,759.978 1755.147,761.048  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1758.057,910.931 1602.037,909.482 1601.864,891.341 1757.704,892.743  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1761.983,1113.155 1603.96,1111.184 1603.783,1092.577 1761.621,1094.499  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1756.77,844.654 1601.407,843.374 1601.235,825.385 1756.42,826.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1759.355,977.769 1602.673,976.148 1602.499,957.855 1758.999,959.427  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1760.663,1045.174 1603.314,1043.38 1603.138,1024.931 1760.304,1026.677  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1763.314,1181.719 1604.613,1179.568 1604.434,1160.802 1762.949,1162.903  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1764.657,1250.873 1605.27,1248.539 1605.089,1229.611 1764.288,1231.895  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1766.011,1320.627 1605.933,1318.106 1605.751,1299.015 1765.639,1301.484  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1767.377,1390.985 1606.603,1388.275 1606.419,1369.018 1767.002,1371.676  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126307996022746877700000008239416696758376094_",
    gradientUnits: "userSpaceOnUse",
    x1: 706.0015,
    y1: 960.5951,
    x2: -25.9996,
    y2: 1412.5964
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126307996022746877700000008239416696758376094_)"
    },
    d: "M698.115,740.438 c-0.088-5.161-2.19-10.071-5.835-13.63c-3.645-3.559-8.53-5.47-13.56-5.305l-407.06,13.341 c-10.361,0.34-18.498,9.217-18.19,19.845l20.085,691.443c0.305,10.493,8.738,18.807,18.973,18.705l401.577-1.279 c5.01-0.05,7.095-4.849,10.589-8.532c3.495-3.683,5.411-8.645,5.324-13.783L698.115,740.438z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.57
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "323.171,801.349 322.536,784.052 454.943,777.976 455.535,795.314  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "324.952,849.811 324.318,832.545 456.605,826.582 457.196,843.887  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "326.73,898.183 326.097,880.95 458.264,875.097 458.854,892.37  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "328.504,946.463 327.873,929.262 459.92,923.521 460.509,940.762  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "330.276,994.656 329.645,977.486 461.573,971.855 462.161,989.063  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "333.808,1090.769 333.18,1073.664 464.87,1068.253 465.456,1085.397  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "339.082,1234.272 338.458,1217.262 469.792,1212.177 470.375,1229.226  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "332.043,1042.757 331.415,1025.619 463.223,1020.099 463.81,1037.276  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "335.569,1138.692 334.943,1121.618 466.514,1116.318 467.098,1133.43  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "337.328,1186.526 336.702,1169.484 468.154,1164.292 468.738,1181.372  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "340.834,1281.928 340.211,1264.95 471.427,1259.975 472.008,1276.992  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "342.583,1329.498 341.96,1312.551 473.058,1307.682 473.638,1324.668  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "344.328,1376.979 343.707,1360.062 474.687,1355.303 475.266,1372.257  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "346.069,1424.371 345.45,1407.486 476.313,1402.834 476.891,1419.757  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "495.868,793.474 495.289,776.124 628.455,770.014 628.991,787.404  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "497.493,842.082 496.915,824.765 629.959,818.766 630.494,836.123  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "499.114,890.598 498.537,873.313 631.46,867.428 631.994,884.752  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "500.733,939.025 500.157,921.772 632.959,915.997 633.492,933.289  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "502.348,987.36 501.773,970.139 634.455,964.477 634.986,981.737  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "505.57,1083.761 504.997,1066.604 637.438,1061.163 637.968,1078.359  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "510.38,1227.689 509.811,1210.628 641.892,1205.516 642.418,1222.616  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "503.961,1035.604 503.387,1018.416 635.948,1012.864 636.478,1030.092  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "507.177,1131.826 506.605,1114.701 638.925,1109.37 639.454,1126.534  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "508.78,1179.802 508.209,1162.71 640.41,1157.488 640.938,1174.619  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "511.978,1275.488 511.409,1258.459 643.371,1253.454 643.897,1270.522  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "513.572,1323.197 513.005,1306.199 644.847,1301.305 645.372,1318.341  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "515.164,1370.818 514.597,1353.851 646.32,1349.065 646.844,1366.069  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "516.753,1418.351 516.187,1401.416 647.791,1396.736 648.314,1413.709  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M189.653,871.969c8.712,85.721,79.786,582.497,557.932,599.537 c0,0,37.399-339.09-547.662-606.918C194.806,862.245,189.084,866.369,189.653,871.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE5FE"
    },
    d: "M250.516,934.48c15.126,25.381,31.225,50.252,47.648,74.854 c16.485,24.573,33.467,48.812,50.91,72.71c17.429,23.908,35.381,47.433,53.837,70.549l6.911,8.676l7.019,8.588 c4.695,5.712,9.313,11.489,14.115,17.111l14.3,16.955l14.557,16.732l3.639,4.183l3.709,4.121l7.419,8.239l7.419,8.239 c2.485,2.735,5.036,5.409,7.55,8.117c5.063,5.384,10.055,10.834,15.174,16.163l15.454,15.891 c1.293,1.319,2.564,2.66,3.875,3.961l3.947,3.888l7.894,7.775l7.894,7.775c2.654,2.568,5.371,5.069,8.053,7.607l8.071,7.587 l4.035,3.793c1.339,1.271,2.689,2.53,4.077,3.747l16.517,14.756c1.381,1.224,2.742,2.471,4.139,3.676l4.228,3.573l8.456,7.145 l8.455,7.145c2.845,2.349,5.764,4.604,8.642,6.911l8.663,6.884l4.331,3.442l2.167,1.719l2.22,1.648l17.761,13.184 c23.966,17.172,48.771,33.14,74.563,47.317l0.042,0.023c1.86,1.023,2.539,3.36,1.517,5.22c-1.023,1.86-3.36,2.54-5.22,1.517 l-0.021-0.011c-26.043-14.525-51.007-30.821-75.077-48.296l-17.827-13.406l-2.228-1.676l-2.173-1.745l-4.342-3.495l-8.684-6.989 c-2.885-2.342-5.811-4.633-8.661-7.016l-8.467-7.245l-8.466-7.244l-4.233-3.622c-1.398-1.221-2.76-2.484-4.141-3.724 l-16.52-14.945c-1.388-1.233-2.738-2.507-4.076-3.793l-4.033-3.838l-8.066-7.677c-2.68-2.567-5.396-5.099-8.046-7.696 l-7.883-7.861l-7.882-7.861l-3.941-3.93c-1.309-1.315-2.577-2.669-3.867-4.002l-15.419-16.053 c-5.106-5.382-10.083-10.884-15.131-16.319c-2.507-2.733-5.05-5.434-7.527-8.194l-7.394-8.313l-7.393-8.313l-3.695-4.158 l-3.625-4.219l-14.497-16.875l-14.235-17.093c-4.781-5.668-9.375-11.489-14.046-17.245l-6.984-8.654l-6.874-8.741 c-18.357-23.288-36.2-46.975-53.514-71.04c-17.328-24.054-34.189-48.442-50.549-73.161 c-16.307-24.761-32.253-49.732-47.293-75.331c-0.455-0.775-0.196-1.773,0.579-2.228c0.772-0.454,1.765-0.198,2.223,0.57 L250.516,934.48z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013873486349764856310000003852145279452928934_",
    gradientUnits: "userSpaceOnUse",
    x1: 1454.0355,
    y1: 765.1024,
    x2: 750.0358,
    y2: 1165.103
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013873486349764856310000003852145279452928934_)"
    },
    d: "M1379.082,570.958 c-0.127-5.482-3.933-10.7-10.553-14.471c-6.622-3.77-15.497-5.773-24.611-5.554l-692.552,16.689 c-11.887,0.286-21.194,6.25-20.913,13.398l35.155,889.881l700.269-5.136c8.977-0.066,17.541-2.274,23.806-6.14 c6.265-3.865,9.716-9.068,9.591-14.464L1379.082,570.958z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.58
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "819.416,709.655 717.084,709.635 711.992,620.726 814.98,620.726  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "978.883,709.418 881.533,709.39 877.495,620.726 975.467,620.726  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1141.894,709.175 1040.669,709.154 1037.646,620.726 1139.514,620.726  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1304.012,708.934 1203.34,708.912 1201.35,620.726 1302.657,620.726  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "826.64,854.291 725.378,854.687 720.391,767.779 822.296,767.529  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "984.448,853.674 888.11,854.05 884.155,767.378 981.102,767.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1145.772,853.043 1045.593,853.434 1042.632,766.989 1143.44,766.742  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1306.22,852.416 1206.584,852.805 1204.634,766.592 1304.893,766.346  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "833.717,995.636 733.503,996.266 728.617,911.133 829.462,910.643  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "989.9,994.655 894.553,995.254 890.678,910.346 986.622,909.88  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1149.57,993.652 1050.417,994.274 1047.516,909.584 1147.286,909.099  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1308.384,992.654 1209.762,993.273 1207.851,908.805 1307.083,908.323  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "840.651,1134.125 741.463,1134.979 736.676,1051.566 836.481,1050.846  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "995.242,1132.794 900.865,1133.607 897.069,1050.409 992.029,1049.724  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1153.293,1131.433 1055.144,1132.278 1052.301,1049.29 1151.054,1048.578  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1310.505,1130.079 1212.876,1130.92 1211.004,1048.146 1309.229,1047.437  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "847.446,1269.843 749.263,1270.913 744.572,1189.167 843.36,1188.227  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1000.477,1268.177 907.052,1269.194 903.331,1187.656 997.329,1186.761  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1156.941,1266.472 1059.777,1267.531 1056.991,1186.193 1154.747,1185.263  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1312.583,1264.777 1215.929,1265.83 1214.093,1184.698 1311.333,1183.772  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "854.107,1402.872 756.909,1404.148 752.31,1324.022 850.101,1322.87  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1005.609,1400.883 913.116,1402.098 909.469,1322.17 1002.522,1321.074  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1160.518,1398.85 1064.318,1400.113 1061.587,1320.378 1158.366,1319.238  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7D97F4"
    },
    points: "1314.62,1396.827 1218.921,1398.083 1217.122,1318.545 1313.395,1317.411  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2017.056,1468.568H868.879c-2.485,0-4.5-2.015-4.5-4.5v-125.132c0-2.485,2.015-4.5,4.5-4.5 h1148.177c2.485,0,4.5,2.015,4.5,4.5v125.132C2021.556,1466.553,2019.541,1468.568,2017.056,1468.568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2061.588,1488.613H789.349c-8.771,0-15.881-7.11-15.881-15.88v-26.265 c0-8.771,7.11-15.881,15.881-15.881h1272.239c8.771,0,15.881,7.11,15.881,15.881v26.265 C2077.469,1481.503,2070.359,1488.613,2061.588,1488.613z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025445241871071053370000004826517277183156395_",
    gradientUnits: "userSpaceOnUse",
    x1: 876.7218,
    y1: 699.9153,
    x2: 2002.8829,
    y2: 699.9153
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025445241871071053370000004826517277183156395_)"
    },
    d: "M1987.94,822.752H891.665 c-16.479,0-20.801-22.776-5.468-28.814l548.138-215.821c3.514-1.383,7.422-1.383,10.936,0l548.138,215.821 C2008.741,799.975,2004.419,822.752,1987.94,822.752z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147212333506950427990000000834817020933385368_",
    gradientUnits: "userSpaceOnUse",
    x1: 927.9156,
    y1: 1070.9465,
    x2: 951.4238,
    y2: 1070.9465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 927.916,
    y: 854.673,
    style: {
      fill: "url(#SVGID_00000147212333506950427990000000834817020933385368_)"
    },
    width: 23.508,
    height: 432.547
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087408352103190488850000014587824259430948017_",
    gradientUnits: "userSpaceOnUse",
    x1: 963.1776,
    y1: 1070.9465,
    x2: 986.6855,
    y2: 1070.9465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 963.178,
    y: 854.673,
    style: {
      fill: "url(#SVGID_00000087408352103190488850000014587824259430948017_)"
    },
    width: 23.508,
    height: 432.547
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018224070982910677920000001072930786796763814_",
    gradientUnits: "userSpaceOnUse",
    x1: 998.4397,
    y1: 1070.9465,
    x2: 1021.9476,
    y2: 1070.9465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 998.44,
    y: 854.673,
    style: {
      fill: "url(#SVGID_00000018224070982910677920000001072930786796763814_)"
    },
    width: 23.508,
    height: 432.547
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094607155323190604920000008632028730960689297_",
    gradientUnits: "userSpaceOnUse",
    x1: 902.0569,
    y1: 839.3926,
    x2: 1047.8065,
    y2: 839.3926
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000094607155323190604920000008632028730960689297_)"
    },
    points: "1047.807,831.165  902.057,831.165 902.057,837.494 923.214,847.62 1026.649,847.62 1047.807,837.494  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100353097619042990900000004588324601614772891_",
    gradientUnits: "userSpaceOnUse",
    x1: 903.2321,
    y1: 1308.3772,
    x2: 1048.9817,
    y2: 1308.3772
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000100353097619042990900000004588324601614772891_)"
    },
    points: "1048.982,1324.833  903.232,1324.833 903.232,1302.048 924.389,1291.922 1027.825,1291.922 1048.982,1302.048  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016076981550581787140000013105815590189749944_",
    gradientUnits: "userSpaceOnUse",
    x1: 1113.6289,
    y1: 1070.9465,
    x2: 1137.1368,
    y2: 1070.9465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1113.629,
    y: 854.673,
    style: {
      fill: "url(#SVGID_00000016076981550581787140000013105815590189749944_)"
    },
    width: 23.508,
    height: 432.547
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081621870794135505390000003118422654064256673_",
    gradientUnits: "userSpaceOnUse",
    x1: 1148.8909,
    y1: 1070.9465,
    x2: 1172.3989,
    y2: 1070.9465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1148.891,
    y: 854.673,
    style: {
      fill: "url(#SVGID_00000081621870794135505390000003118422654064256673_)"
    },
    width: 23.508,
    height: 432.547
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039118236869188147830000005036575440440480668_",
    gradientUnits: "userSpaceOnUse",
    x1: 1184.153,
    y1: 1070.9465,
    x2: 1207.6609,
    y2: 1070.9465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1184.153,
    y: 854.673,
    style: {
      fill: "url(#SVGID_00000039118236869188147830000005036575440440480668_)"
    },
    width: 23.508,
    height: 432.547
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130641956936540966150000015992599226172411532_",
    gradientUnits: "userSpaceOnUse",
    x1: 1087.7699,
    y1: 839.3926,
    x2: 1233.5195,
    y2: 839.3926
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000130641956936540966150000015992599226172411532_)"
    },
    points: "1233.52,831.165  1087.77,831.165 1087.77,837.494 1108.927,847.62 1212.362,847.62 1233.52,837.494  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127009938661844563910000012444561225084050328_",
    gradientUnits: "userSpaceOnUse",
    x1: 1088.9454,
    y1: 1308.3772,
    x2: 1234.6949,
    y2: 1308.3772
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000127009938661844563910000012444561225084050328_)"
    },
    points: "1234.695,1324.833  1088.945,1324.833 1088.945,1302.048 1110.103,1291.922 1213.538,1291.922 1234.695,1302.048  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018202747144445926710000006400577477615835547_",
    gradientUnits: "userSpaceOnUse",
    x1: 1299.3419,
    y1: 1070.9465,
    x2: 1322.8502,
    y2: 1070.9465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1299.342,
    y: 854.673,
    style: {
      fill: "url(#SVGID_00000018202747144445926710000006400577477615835547_)"
    },
    width: 23.508,
    height: 432.547
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145019272338595102890000002152754492589392541_",
    gradientUnits: "userSpaceOnUse",
    x1: 1334.604,
    y1: 1070.9465,
    x2: 1358.1122,
    y2: 1070.9465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1334.604,
    y: 854.673,
    style: {
      fill: "url(#SVGID_00000145019272338595102890000002152754492589392541_)"
    },
    width: 23.508,
    height: 432.547
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101819595700610455240000003079827066865347477_",
    gradientUnits: "userSpaceOnUse",
    x1: 1369.866,
    y1: 1070.9465,
    x2: 1393.374,
    y2: 1070.9465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1369.866,
    y: 854.673,
    style: {
      fill: "url(#SVGID_00000101819595700610455240000003079827066865347477_)"
    },
    width: 23.508,
    height: 432.547
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070104476196792108230000017073821953425941428_",
    gradientUnits: "userSpaceOnUse",
    x1: 1273.4833,
    y1: 839.3926,
    x2: 1419.2329,
    y2: 839.3926
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000070104476196792108230000017073821953425941428_)"
    },
    points: "1419.233,831.165  1273.483,831.165 1273.483,837.494 1294.641,847.62 1398.076,847.62 1419.233,837.494  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070077764123154062130000016135389959350219668_",
    gradientUnits: "userSpaceOnUse",
    x1: 1274.6588,
    y1: 1308.3772,
    x2: 1420.4084,
    y2: 1308.3772
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000070077764123154062130000016135389959350219668_)"
    },
    points: "1420.408,1324.833  1274.659,1324.833 1274.659,1302.048 1295.816,1291.922 1399.251,1291.922 1420.408,1302.048  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120559753772857643840000002624246965655408257_",
    gradientUnits: "userSpaceOnUse",
    x1: 1485.0553,
    y1: 1070.9465,
    x2: 1508.5632,
    y2: 1070.9465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1485.055,
    y: 854.673,
    style: {
      fill: "url(#SVGID_00000120559753772857643840000002624246965655408257_)"
    },
    width: 23.508,
    height: 432.547
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080176438539681172440000011644532746032266640_",
    gradientUnits: "userSpaceOnUse",
    x1: 1520.3173,
    y1: 1070.9465,
    x2: 1543.8252,
    y2: 1070.9465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1520.317,
    y: 854.673,
    style: {
      fill: "url(#SVGID_00000080176438539681172440000011644532746032266640_)"
    },
    width: 23.508,
    height: 432.547
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097465427618071094480000015629677583407760309_",
    gradientUnits: "userSpaceOnUse",
    x1: 1555.5793,
    y1: 1070.9465,
    x2: 1579.0873,
    y2: 1070.9465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1555.579,
    y: 854.673,
    style: {
      fill: "url(#SVGID_00000097465427618071094480000015629677583407760309_)"
    },
    width: 23.508,
    height: 432.547
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177456070629185765700000009877553667835364771_",
    gradientUnits: "userSpaceOnUse",
    x1: 1459.1963,
    y1: 839.3926,
    x2: 1604.9459,
    y2: 839.3926
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000177456070629185765700000009877553667835364771_)"
    },
    points: "1604.946,831.165  1459.196,831.165 1459.196,837.494 1480.354,847.62 1583.789,847.62 1604.946,837.494  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046334931551454987010000017887514202658281116_",
    gradientUnits: "userSpaceOnUse",
    x1: 1460.3718,
    y1: 1308.3772,
    x2: 1606.1215,
    y2: 1308.3772
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000046334931551454987010000017887514202658281116_)"
    },
    points: "1606.121,1324.833  1460.372,1324.833 1460.372,1302.048 1481.529,1291.922 1584.964,1291.922 1606.121,1302.048  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137130708452433228690000005415965949451849659_",
    gradientUnits: "userSpaceOnUse",
    x1: 1670.7686,
    y1: 1070.9465,
    x2: 1694.2765,
    y2: 1070.9465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1670.769,
    y: 854.673,
    style: {
      fill: "url(#SVGID_00000137130708452433228690000005415965949451849659_)"
    },
    width: 23.508,
    height: 432.547
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003811446773446472490000005172801050643884712_",
    gradientUnits: "userSpaceOnUse",
    x1: 1706.0303,
    y1: 1070.9465,
    x2: 1729.5386,
    y2: 1070.9465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1706.03,
    y: 854.673,
    style: {
      fill: "url(#SVGID_00000003811446773446472490000005172801050643884712_)"
    },
    width: 23.508,
    height: 432.547
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141457884944407084260000014137906116336878470_",
    gradientUnits: "userSpaceOnUse",
    x1: 1741.2924,
    y1: 1070.9465,
    x2: 1764.8003,
    y2: 1070.9465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1741.292,
    y: 854.673,
    style: {
      fill: "url(#SVGID_00000141457884944407084260000014137906116336878470_)"
    },
    width: 23.508,
    height: 432.547
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049917114394260855270000001530599607126620832_",
    gradientUnits: "userSpaceOnUse",
    x1: 1644.9097,
    y1: 839.3926,
    x2: 1790.6592,
    y2: 839.3926
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000049917114394260855270000001530599607126620832_)"
    },
    points: "1790.659,831.165  1644.91,831.165 1644.91,837.494 1666.067,847.62 1769.502,847.62 1790.659,837.494  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148648828532456716560000013597439154842180492_",
    gradientUnits: "userSpaceOnUse",
    x1: 1646.0852,
    y1: 1308.3772,
    x2: 1791.8347,
    y2: 1308.3772
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000148648828532456716560000013597439154842180492_)"
    },
    points: "1791.835,1324.833  1646.085,1324.833 1646.085,1302.048 1667.242,1291.922 1770.677,1291.922 1791.835,1302.048  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153668225211901480810000013975938853778063022_",
    gradientUnits: "userSpaceOnUse",
    x1: 1856.4816,
    y1: 1070.9465,
    x2: 1879.9895,
    y2: 1070.9465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1856.482,
    y: 854.673,
    style: {
      fill: "url(#SVGID_00000153668225211901480810000013975938853778063022_)"
    },
    width: 23.508,
    height: 432.547
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019651453033868829350000013703120201208989868_",
    gradientUnits: "userSpaceOnUse",
    x1: 1891.7437,
    y1: 1070.9465,
    x2: 1915.2516,
    y2: 1070.9465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1891.744,
    y: 854.673,
    style: {
      fill: "url(#SVGID_00000019651453033868829350000013703120201208989868_)"
    },
    width: 23.508,
    height: 432.547
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183941046981992184180000006672503924441488563_",
    gradientUnits: "userSpaceOnUse",
    x1: 1927.0057,
    y1: 1070.9465,
    x2: 1950.5135,
    y2: 1070.9465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1927.006,
    y: 854.673,
    style: {
      fill: "url(#SVGID_00000183941046981992184180000006672503924441488563_)"
    },
    width: 23.508,
    height: 432.547
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075853365399699846210000008727167265152133052_",
    gradientUnits: "userSpaceOnUse",
    x1: 1830.623,
    y1: 839.3926,
    x2: 1976.3726,
    y2: 839.3926
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000075853365399699846210000008727167265152133052_)"
    },
    points: "1976.373,831.165  1830.623,831.165 1830.623,837.494 1851.78,847.62 1955.215,847.62 1976.373,837.494  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022536052560957324410000016122818317630532485_",
    gradientUnits: "userSpaceOnUse",
    x1: 1831.7982,
    y1: 1308.3772,
    x2: 1977.5479,
    y2: 1308.3772
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000022536052560957324410000016122818317630532485_)"
    },
    points: "1977.548,1324.833  1831.798,1324.833 1831.798,1302.048 1852.955,1291.922 1956.391,1291.922 1977.548,1302.048  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074424196244489386540000007679406970559590322_",
    gradientUnits: "userSpaceOnUse",
    x1: 864.3727,
    y1: 1347.1761,
    x2: 2022.5938,
    y2: 1347.1761
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074424196244489386540000007679406970559590322_)"
    },
    d: "M2018.692,1359.796H868.274 c-2.155,0-3.901-1.747-3.901-3.901v-17.437c0-2.155,1.747-3.901,3.901-3.901h1150.418c2.155,0,3.901,1.747,3.901,3.901v17.437 C2022.594,1358.049,2020.847,1359.796,2018.692,1359.796z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107567120411721643740000002998105428027942313_",
    gradientUnits: "userSpaceOnUse",
    x1: 563.7353,
    y1: 1316.7345,
    x2: 653.5004,
    y2: 1316.7345
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2B3582"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#150E42"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107567120411721643740000002998105428027942313_)"
    },
    d: "M566.008,1364.57 c-0.018-0.43,0.033-0.933,0.181-1.412c0.073-0.239,0.168-0.47,0.277-0.683c0.096-0.197,0.277-0.471,0.26-0.44l0.319-0.449 l0.625-0.852l1.196-1.555l2.39-3.016l4.809-5.944l9.684-11.789l19.473-23.459l39.126-46.749c1.851-2.211,5.142-2.503,7.353-0.653 c2.211,1.85,2.503,5.142,0.652,7.353c-0.036,0.044-0.073,0.086-0.111,0.128l-0.03,0.033l-40.792,45.249l-20.299,22.702 l-10.083,11.394l-4.987,5.72l-2.448,2.866l-1.18,1.422l-0.527,0.663l-0.247,0.317c-0.067,0.092,0.08-0.11,0.137-0.238 c0.07-0.143,0.127-0.305,0.162-0.474c0.072-0.34,0.047-0.703-0.048-0.995c0.238,1.628-0.889,3.139-2.516,3.377 C567.757,1367.323,566.245,1366.197,566.008,1364.57z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075845729246699961200000015662757628452522884_",
    gradientUnits: "userSpaceOnUse",
    x1: 14988.1133,
    y1: -1667.1896,
    x2: 15044.8574,
    y2: -1667.1896,
    gradientTransform: "matrix(0.955 0.2967 -0.2967 0.955 -14001.1914 -1444.7861)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075845729246699961200000015662757628452522884_)"
    },
    d: "M824.09,1427.276 c12.438,4.501,24.766,7.932,33.051,10.047c-5.783-7.592-19.316-24.406-32.208-33.432l-9.644-3.641 c0,0-4.903,4.029-9.692,15.249C806.595,1418.036,810.474,1422.349,824.09,1427.276z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059275205160307176810000001131865203543063220_",
    gradientUnits: "userSpaceOnUse",
    x1: 14988.1133,
    y1: -1656.9869,
    x2: 15044.8574,
    y2: -1656.9869,
    gradientTransform: "matrix(0.955 0.2967 -0.2967 0.955 -14001.1914 -1444.7861)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059275205160307176810000001131865203543063220_)"
    },
    d: "M857.221,1437.427 c-0.025-0.033-0.054-0.07-0.079-0.104c-8.286-2.115-20.613-5.545-33.051-10.047c-13.616-4.928-17.495-9.24-18.492-11.778 c-0.221,0.517-0.442,1.03-0.661,1.577c-0.994,2.48,0.2,5.299,2.684,6.282c10.092,3.993,35.165,13.724,47.724,16.915 C857,1440.694,858.255,1438.787,857.221,1437.427z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173852255844245707850000017184672343188259972_",
    gradientUnits: "userSpaceOnUse",
    x1: 14991.001,
    y1: -1686.4938,
    x2: 15005.3691,
    y2: -1686.4938,
    gradientTransform: "matrix(0.955 0.2967 -0.2967 0.955 -14001.1914 -1444.7861)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173852255844245707850000017184672343188259972_)"
    },
    d: "M817.451,1386.474 c1.378,0.381-2.734,6.876-2.834,14.485c-0.023,1.716,0.769,3.315,2.402,3.845c1.058,0.344,2.323,0.714,3.632,1.009 c1.97,0.443,3.977-0.568,4.752-2.432l7.294-17.549L817.451,1386.474z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018206106429318267530000018074467210542243233_",
    gradientUnits: "userSpaceOnUse",
    x1: 15448.7178,
    y1: 1439.2302,
    x2: 15505.4629,
    y2: 1439.2302,
    gradientTransform: "matrix(1 0.0053 -0.0053 1 -14780.7988 -32.2438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018206106429318267530000018074467210542243233_)"
    },
    d: "M681.564,1500.328 c13.211,0.678,26.003,0.363,34.545-0.03c-7.746-5.575-25.595-17.711-40.559-22.584l-7.12-0.464 c-2.026-0.132-3.925,1.027-4.686,2.909c-1.117,2.763-2.563,7.434-3.304,14.297 C662.135,1496.593,667.103,1499.586,681.564,1500.328z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097490095160385408400000005356475839964041611_",
    gradientUnits: "userSpaceOnUse",
    x1: 15448.7178,
    y1: 1449.3425,
    x2: 15505.4629,
    y2: 1449.3425,
    gradientTransform: "matrix(1 0.0053 -0.0053 1 -14780.7988 -32.2438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097490095160385408400000005356475839964041611_)"
    },
    d: "M716.215,1500.374 c-0.034-0.024-0.072-0.051-0.106-0.076c-8.542,0.394-21.334,0.708-34.545,0.03c-14.461-0.742-19.43-3.735-21.124-5.872 c-0.06,0.558-0.122,1.113-0.172,1.701c-0.228,2.662,1.737,5.01,4.399,5.226c10.817,0.875,37.639,2.87,50.582,2.26 C716.957,1503.563,717.601,1501.373,716.215,1500.374z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183945983422756337960000004819228509196977281_",
    gradientUnits: "userSpaceOnUse",
    x1: 15455.3564,
    y1: 1422.1807,
    x2: 15473.4209,
    y2: 1422.1807,
    gradientTransform: "matrix(1 0.0053 -0.0053 1 -14780.7988 -32.2438)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183945983422756337960000004819228509196977281_)"
    },
    d: "M669.446,1463.353 c1.429-0.038-2.422,8.556-2.466,16.082c-0.01,1.716,1.703,2.946,3.419,2.977c1.112,0.02,2.43,0.006,3.769-0.094 c2.013-0.151,3.639-1.704,3.836-3.713l7.138-17.206L669.446,1463.353z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044858058268530841500000004327714853379882404_",
    gradientUnits: "userSpaceOnUse",
    x1: 701.4645,
    y1: 1578.1968,
    x2: 730.3686,
    y2: 1491.4843
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044858058268530841500000004327714853379882404_)"
    },
    d: "M666.075,1468.73 c5.403-22.158,43.406-175.389,69.206-209.142l35.396,5.192l4.22-5.192c0,0,86.573,25.349,96.466,34.859 c8.117,7.805-38.435,102.37-38.435,102.37s-9.664,3.667-18.754-4.147l14.695-66.034c0.603-2.707-1.117-5.386-3.83-5.966 l-65.691-14.035c-2.555-0.546-5.145,0.734-6.256,3.098c-13.89,29.542-61.63,132.117-69.906,163.794 c-0.235,0.899-1.047,1.518-1.975,1.469c-2.73-0.143-8.444-0.633-12.982-2.301C666.604,1472.1,665.665,1470.411,666.075,1468.73z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039095699669998431730000008713572162918064016_",
    gradientUnits: "userSpaceOnUse",
    x1: 15583.4912,
    y1: 1257.0951,
    x2: 15524.6807,
    y2: 1333.1287,
    gradientTransform: "matrix(1 0 0 1 -14789.8076 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039095699669998431730000008713572162918064016_)"
    },
    d: "M756.89,1304.347 c-0.212,0-0.424-0.08-0.587-0.24c-0.332-0.324-0.338-0.856-0.013-1.188l8.57-8.764c0.324-0.332,0.856-0.337,1.188-0.013 c0.332,0.324,0.337,0.856,0.013,1.188l-8.571,8.764C757.326,1304.263,757.108,1304.347,756.89,1304.347z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141416989651396993340000003626508577908380855_",
    gradientUnits: "userSpaceOnUse",
    x1: 703.6797,
    y1: 1118.5314,
    x2: 683.6797,
    y2: 1200.5314
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141416989651396993340000003626508577908380855_)"
    },
    d: "M679.848,1209.934 c-11.284,16.943-21.565,34.43-28.965,50.998l10.553,4.497c0,0,14.803-19.144,34.539-41.245 C691.164,1216.46,684.878,1212.228,679.848,1209.934z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116937855889142633320000011223194921731838643_",
    gradientUnits: "userSpaceOnUse",
    x1: 812.5157,
    y1: 1070.8964,
    x2: 654.5157,
    y2: 1268.896
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116937855889142633320000011223194921731838643_)"
    },
    d: "M761.175,1164.571l6.294-52.958 c0,0-53.225,46.677-87.62,98.321c5.03,2.294,11.316,6.526,16.127,14.25C716.063,1201.691,741.26,1176.134,761.175,1164.571z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176037916398030824450000001695544981761607326_",
    gradientUnits: "userSpaceOnUse",
    x1: 685.1239,
    y1: 1114.0057,
    x2: 665.1238,
    y2: 1196.0059
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176037916398030824450000001695544981761607326_)"
    },
    d: "M654.407,1260.932 c0,0-17.18-0.368-19.382,4.497c-2.203,4.865,4.405,14.997,6.607,15.878c2.203,0.881,12.334-1.762,12.775-6.608 c0.441-4.846,5.247-2.241,7.029-9.27S654.407,1260.932,654.407,1260.932z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148626662320747845170000009784623581486394245_",
    gradientUnits: "userSpaceOnUse",
    x1: 1377.5861,
    y1: 1060.4191,
    x2: 1323.4335,
    y2: 1047.0598,
    gradientTransform: "matrix(0.9989 -0.0462 0.0462 0.9989 -577.1973 108.5346)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148626662320747845170000009784623581486394245_)"
    },
    d: "M833.391,1074.952 c0,0-34.21,22.489-47.317,34.575l28.913,14.423c0,0,14.417-18.298,28.588-26.3L833.391,1074.952z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155854849432390696340000001950510849795958436_",
    gradientUnits: "userSpaceOnUse",
    x1: 823.4292,
    y1: 1513.7806,
    x2: 665.4206,
    y2: 1711.7911,
    gradientTransform: "matrix(0.9778 -0.2093 0.2093 0.9778 -271.6348 -176.4127)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155854849432390696340000001950510849795958436_)"
    },
    d: "M715.216,1271.587 c9.961,15.356,45.392,6.787,80.252-4.974c0.696-0.235,0.99-8.367,1.126-9.089c1.654-8.823,13.587-59.162,23.098-80.879 c0.516-1.177,1.981-1.585,3.035-0.849c8.673,6.06,45.66,28.81,97.715,17.173c0.866-0.194,1.508-0.932,1.588-1.816l0.448-4.958 c0.099-1.092-0.68-2.069-1.767-2.211c-9.884-1.293-54.938-8.427-77.719-33.345c-25.68-28.09-8.845-36.643-23.314-44.649 c-7.943-4.395-13.106-7.607-16.147-9.609c-0.833-0.548-3.455-0.495-7.374,0.208c-17.859,3.206-32.548,17.197-32.548,17.197 c-37.257,35.487-47.647,122.412-50.439,145.773C712.873,1262.054,712.335,1267.144,715.216,1271.587z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110467745550323978690000015984864451536041645_",
    gradientUnits: "userSpaceOnUse",
    x1: 876.6537,
    y1: 1583.7507,
    x2: 928.0459,
    y2: 1583.7507,
    gradientTransform: "matrix(0.9778 -0.2093 0.2093 0.9778 -271.6348 -176.4127)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110467745550323978690000015984864451536041645_)"
    },
    d: "M915.875,1183.269l4.836,0.716 l20.216-6.766c2.367-1.11,5.078-1.229,7.534-0.331l20.182,7.383l-49.755,8.488 C918.03,1191.242,917.712,1185.121,915.875,1183.269z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008836707499022024240000002902152111621816490_",
    gradientUnits: "userSpaceOnUse",
    x1: 1395.0612,
    y1: 1029.0183,
    x2: 1337.3303,
    y2: 1052.874,
    gradientTransform: "matrix(0.9989 -0.0462 0.0462 0.9989 -577.1973 108.5346)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008836707499022024240000002902152111621816490_)"
    },
    d: "M867.015,1058.065 c0.13,0.677-6.913,45.721-6.913,45.721l-25.634-4.568l0.332-43.684C834.801,1055.534,864.84,1046.727,867.015,1058.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M840.956,1064.98l-1.976,22.982c-0.026,0.295-0.012,0.584,0.043,0.875 c0.339,1.779,1.953,7.813,8.025,5.785c5.51-1.84,10.567-3.437,14.153-2.519c1.61,0.412,2.642,1.976,2.385,3.618 c-0.641,4.092-2.256,13.288-4.878,21.062c-0.532,1.578-2.192,2.47-3.81,2.078c-4.876-1.18-15.091-3.957-22.785-8.116 c-1.043-0.564-1.698-1.639-1.702-2.824c-0.023-5.778-0.16-23.338-0.954-28.225c-0.746-4.587-6.534-7.089-9.039-7.966 c-0.821-0.287-1.483-0.893-1.842-1.686c-1.271-2.801-3.146-9.333,5.051-12.423c1.716-0.647,2.547-2.567,1.848-4.262 c-1.391-3.374-2.153-8.587,4.152-11.77c6.408-3.235,11.457,0.027,14.226,2.74c1.12,1.097,2.84,1.193,4.125,0.295 c0.732-0.511,1.695-0.712,2.902-0.035c1.626,0.911,3.689,0.143,4.427-1.568c1.419-3.289,4.453-6.882,10.91-6.081 c11.458,1.421,13.328,13.959,10.67,21.479c-2.658,7.521-14.992,5.273-21.287,1.835c-4.786-2.614-10.688,0.63-13.242,2.336 C841.55,1063.131,841.039,1064.011,840.956,1064.98z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031170733040281893640000015586797534596048266_",
    gradientUnits: "userSpaceOnUse",
    x1: 1376.2711,
    y1: 1017.4738,
    x2: 1349.4335,
    y2: 1040.2559,
    gradientTransform: "matrix(0.9989 -0.0462 0.0462 0.9989 -577.1973 108.5346)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031170733040281893640000015586797534596048266_)"
    },
    d: "M830.037,1087.513 c0,0,2.852-12.744-2.097-15.727c-4.95-2.983-11.984-0.99-9.98,8.418C820.453,1091.907,830.037,1087.513,830.037,1087.513z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023250121104900220270000017786527987310992022_",
    gradientUnits: "userSpaceOnUse",
    x1: 466.6775,
    y1: 1229.5114,
    x2: 372.0106,
    y2: 1527.5114
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000023250121104900220270000017786527987310992022_)"
    },
    cx: 391.25,
    cy: 1466.948,
    r: 44.962
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002373937964137512820000014254772133577869235_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.5997,
    y1: 1469.2649,
    x2: 423.8999,
    y2: 1469.2649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000002373937964137512820000014254772133577869235_)"
    },
    cx: 391.25,
    cy: 1469.265,
    r: 32.65
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003788038001821222620000000557204239753993914_",
    gradientUnits: "userSpaceOnUse",
    x1: 380.8198,
    y1: 1466.9484,
    x2: 401.6798,
    y2: 1466.9484
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003788038001821222620000000557204239753993914_)"
    },
    d: "M401.68,1466.948 c0,5.76-4.67,10.43-10.43,10.43c-5.76,0-10.43-4.67-10.43-10.43c0-5.76,4.67-10.43,10.43-10.43 C397.01,1456.518,401.68,1461.188,401.68,1466.948z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065776577138526748150000013030992266924869512_",
    gradientUnits: "userSpaceOnUse",
    x1: 574.9183,
    y1: 1263.8961,
    x2: 480.2515,
    y2: 1561.896
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000065776577138526748150000013030992266924869512_)"
    },
    cx: 510.414,
    cy: 1466.948,
    r: 44.962
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041293518589873328250000009717216136214063796_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.7636,
    y1: 1469.2649,
    x2: 543.064,
    y2: 1469.2649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000041293518589873328250000009717216136214063796_)"
    },
    cx: 510.414,
    cy: 1469.265,
    r: 32.65
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159471270595713662540000005250500111310164380_",
    gradientUnits: "userSpaceOnUse",
    x1: 499.9837,
    y1: 1466.9484,
    x2: 520.8439,
    y2: 1466.9484
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159471270595713662540000005250500111310164380_)"
    },
    d: "M520.844,1466.948 c0,5.76-4.67,10.43-10.43,10.43c-5.76,0-10.43-4.67-10.43-10.43c0-5.76,4.67-10.43,10.43-10.43 C516.174,1456.518,520.844,1461.188,520.844,1466.948z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106833542883554764650000009440171185145075607_",
    gradientUnits: "userSpaceOnUse",
    x1: 494.6627,
    y1: 1352.558,
    x2: 307.6097,
    y2: 1513.4784
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106833542883554764650000009440171185145075607_)"
    },
    d: "M313.39,1385.182l9.216,28.918 c1.651,5.181,7.093,8.749,13.266,8.7l228.349-2.905c5.985-0.048,11.235-3.488,12.944-8.483l10.807-31.572 c2.634-7.694-4.077-15.399-13.296-15.266l-248.372,5.559C317.382,1370.263,311.004,1377.695,313.39,1385.182z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052814697584774505240000017730734979225706679_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.4719,
    y1: 1394.4752,
    x2: 574.9595,
    y2: 1394.4752
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052814697584774505240000017730734979225706679_)"
    },
    d: "M329.802,1396.84l241.614-11.593 c2.462-0.076,4.201,2.388,3.304,4.682l-1.916,4.904c-0.507,1.296-1.746,2.159-3.137,2.184l-239.698,6.69 c-1.559,0.028-2.94-0.998-3.365-2.497l0,0C325.995,1399.058,327.569,1396.908,329.802,1396.84z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054980734503986803230000006539811312539813044_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.7546,
    y1: 1211.8627,
    x2: 445.592,
    y2: 1072.7657
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000054980734503986803230000006539811312539813044_)"
    },
    cx: 448.013,
    cy: 1069.956,
    r: 89.343
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121966577453848611840000017920084255304275385_",
    gradientUnits: "userSpaceOnUse",
    x1: 513.308,
    y1: 971.3134,
    x2: 158.9453,
    y2: 1506.6545
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000121966577453848611840000017920084255304275385_)"
    },
    cx: 448.013,
    cy: 1069.956,
    r: 86.373
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M376.789,1036.065c-0.301,0-0.607-0.069-0.894-0.214 c-0.98-0.495-1.374-1.69-0.879-2.67c13.993-27.723,41.964-44.943,72.996-44.943c4.955,0,9.914,0.446,14.741,1.326 c1.08,0.196,1.796,1.231,1.599,2.312c-0.197,1.08-1.231,1.801-2.311,1.599c-4.592-0.837-9.312-1.262-14.028-1.262 c-29.523,0-56.134,16.385-69.447,42.76C378.216,1035.665,377.515,1036.065,376.789,1036.065z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.2757 -0.9612 0.9612 0.2757 -704.4366 1208.8113)",
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    cx: 449.895,
    cy: 1071.838,
    rx: 73.104,
    ry: 73.104
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079480876948488375290000016716111634133862303_",
    gradientUnits: "userSpaceOnUse",
    x1: 502.737,
    y1: 986.6526,
    x2: 314.0461,
    y2: 1303.4333
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079480876948488375290000016716111634133862303_)"
    },
    d: "M442.721,1126.184v-7.953 c-8.291-0.332-16.492-2.289-22.316-4.839c-2.08-0.91-3.14-3.245-2.543-5.435l2.021-7.408 c0.741-2.718,3.697-4.124,6.295-3.035c5.778,2.422,12.912,4.339,20.605,4.339c7.986,0,13.941-2.707,13.941-8.257 c0-5.007-4.602-7.985-15.701-10.963c-15.836-4.331-27.206-11.235-27.206-25.176c0-12.588,9.205-22.198,25.176-24.769v-7.954 c0-2.559,2.075-4.634,4.634-4.634h4.673c2.559,0,4.634,2.075,4.634,4.634v7.142c7.672,0.307,13.257,1.619,17.689,3.176 c2.271,0.798,3.512,3.244,2.882,5.567l-1.858,6.851c-0.716,2.642-3.54,4.089-6.1,3.121c-4.081-1.543-9.85-3.15-17.349-3.15 c-9.475,0-12.181,3.925-12.181,7.444c0,4.331,5.684,7.309,18.001,11.099c17.596,5.279,24.905,12.588,24.905,25.717 c0,12.046-8.933,22.875-26.258,25.582v8.901c0,2.559-2.075,4.634-4.634,4.634h-4.673 C444.796,1130.818,442.721,1128.744,442.721,1126.184z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090978514403948470510000005091431717913265577_",
    gradientUnits: "userSpaceOnUse",
    x1: 499.9908,
    y1: 1103.7987,
    x2: 369.4898,
    y2: 1313.0704
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090978514403948470510000005091431717913265577_)"
    },
    d: "M534.682,1202.777H361.343 c-2.338,0-4.234-1.896-4.234-4.234v-22.784c0-2.339,1.896-4.234,4.234-4.234h173.338c2.339,0,4.234,1.896,4.234,4.234v22.784 C538.916,1200.881,537.02,1202.777,534.682,1202.777z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109003251990496518520000000554420994248884137_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.1685,
    y1: 1174.3851,
    x2: 354.1815,
    y2: 1206.4364
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109003251990496518520000000554420994248884137_)"
    },
    d: "M367.171,1197.169h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.42,0.939,0.939v18.158 C368.11,1196.749,367.69,1197.169,367.171,1197.169z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106859761374405902140000008347683792201778090_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.8027,
    y1: 1174.3851,
    x2: 367.8157,
    y2: 1206.4364
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106859761374405902140000008347683792201778090_)"
    },
    d: "M380.805,1197.169h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.42,0.939,0.939v18.158 C381.745,1196.749,381.324,1197.169,380.805,1197.169z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150815131277028218620000015012697482437579427_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.4369,
    y1: 1174.3851,
    x2: 381.4499,
    y2: 1206.4364
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150815131277028218620000015012697482437579427_)"
    },
    d: "M394.439,1197.169h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.42,0.939,0.939v18.158 C395.379,1196.749,394.958,1197.169,394.439,1197.169z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021806273230645185490000005896236914405896345_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.071,
    y1: 1174.385,
    x2: 395.0839,
    y2: 1206.4365
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021806273230645185490000005896236914405896345_)"
    },
    d: "M408.074,1197.169h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.42,0.939,0.939v18.158 C409.013,1196.749,408.592,1197.169,408.074,1197.169z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021110675098384864940000012407272480685061526_",
    gradientUnits: "userSpaceOnUse",
    x1: 428.705,
    y1: 1174.3851,
    x2: 408.718,
    y2: 1206.4364
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021110675098384864940000012407272480685061526_)"
    },
    d: "M421.707,1197.169h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.42,0.939,0.939v18.158 C422.647,1196.749,422.226,1197.169,421.707,1197.169z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057122003787043296830000008200000133673984443_",
    gradientUnits: "userSpaceOnUse",
    x1: 442.3392,
    y1: 1174.3851,
    x2: 422.3522,
    y2: 1206.4364
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057122003787043296830000008200000133673984443_)"
    },
    d: "M435.342,1197.169h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.42,0.939,0.939v18.158 C436.281,1196.749,435.861,1197.169,435.342,1197.169z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126317267305135877970000012412477464163538078_",
    gradientUnits: "userSpaceOnUse",
    x1: 455.9734,
    y1: 1174.3851,
    x2: 435.9864,
    y2: 1206.4364
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126317267305135877970000012412477464163538078_)"
    },
    d: "M448.976,1197.169h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.42,0.939,0.939v18.158 C449.915,1196.749,449.495,1197.169,448.976,1197.169z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129915892823382790940000003168453869470114709_",
    gradientUnits: "userSpaceOnUse",
    x1: 469.6076,
    y1: 1174.385,
    x2: 449.6204,
    y2: 1206.4365
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129915892823382790940000003168453869470114709_)"
    },
    d: "M462.61,1197.169h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.42,0.939,0.939v18.158 C463.549,1196.749,463.129,1197.169,462.61,1197.169z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150796668972577237360000016140598701588066474_",
    gradientUnits: "userSpaceOnUse",
    x1: 483.2416,
    y1: 1174.3851,
    x2: 463.2546,
    y2: 1206.4364
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150796668972577237360000016140598701588066474_)"
    },
    d: "M476.244,1197.169h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.42,0.939,0.939v18.158 C477.184,1196.749,476.763,1197.169,476.244,1197.169z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019638351911350579950000000837762598159853194_",
    gradientUnits: "userSpaceOnUse",
    x1: 496.8758,
    y1: 1174.3851,
    x2: 476.8888,
    y2: 1206.4364
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019638351911350579950000000837762598159853194_)"
    },
    d: "M489.878,1197.169h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.42,0.939,0.939v18.158 C490.818,1196.749,490.397,1197.169,489.878,1197.169z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091710147193208459850000002043727354381264000_",
    gradientUnits: "userSpaceOnUse",
    x1: 510.5099,
    y1: 1174.3851,
    x2: 490.5229,
    y2: 1206.4364
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091710147193208459850000002043727354381264000_)"
    },
    d: "M503.512,1197.169h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.42,0.939,0.939v18.158 C504.452,1196.749,504.031,1197.169,503.512,1197.169z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133528065183582665490000003899108333110162570_",
    gradientUnits: "userSpaceOnUse",
    x1: 524.1441,
    y1: 1174.385,
    x2: 504.1569,
    y2: 1206.4365
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000133528065183582665490000003899108333110162570_)"
    },
    d: "M517.147,1197.169h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.42,0.939,0.939v18.158 C518.086,1196.749,517.666,1197.169,517.147,1197.169z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165915060910931992860000010593176264031896708_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.7781,
    y1: 1174.3851,
    x2: 517.7911,
    y2: 1206.4364
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165915060910931992860000010593176264031896708_)"
    },
    d: "M530.781,1197.169h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.42,0.939,0.939v18.158 C531.72,1196.749,531.299,1197.169,530.781,1197.169z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077310985041854396230000013111327860966496685_",
    gradientUnits: "userSpaceOnUse",
    x1: 499.9908,
    y1: 1138.5066,
    x2: 369.4898,
    y2: 1347.7783
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000077310985041854396230000013111327860966496685_)"
    },
    d: "M534.682,1237.485H361.343 c-2.338,0-4.234-1.896-4.234-4.234v-22.784c0-2.339,1.896-4.234,4.234-4.234h173.338c2.339,0,4.234,1.896,4.234,4.234v22.784 C538.916,1235.589,537.02,1237.485,534.682,1237.485z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087371995697640629760000008491357495310296984_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.1685,
    y1: 1209.0929,
    x2: 354.1815,
    y2: 1241.1443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087371995697640629760000008491357495310296984_)"
    },
    d: "M367.171,1231.877h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C368.11,1231.457,367.69,1231.877,367.171,1231.877z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152952388883282944350000003426624016896393863_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.8028,
    y1: 1209.0929,
    x2: 367.8156,
    y2: 1241.1443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152952388883282944350000003426624016896393863_)"
    },
    d: "M380.805,1231.877h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.158 C381.745,1231.457,381.324,1231.877,380.805,1231.877z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127753176415291145360000000422578726138350753_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.437,
    y1: 1209.0929,
    x2: 381.4499,
    y2: 1241.1443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127753176415291145360000000422578726138350753_)"
    },
    d: "M394.439,1231.877h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C395.379,1231.457,394.958,1231.877,394.439,1231.877z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163045186569131187540000000817046269627640756_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.0711,
    y1: 1209.0929,
    x2: 395.0839,
    y2: 1241.1444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163045186569131187540000000817046269627640756_)"
    },
    d: "M408.074,1231.877h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.94-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.158 C409.013,1231.457,408.592,1231.877,408.074,1231.877z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178917276873949496880000002498912892121749164_",
    gradientUnits: "userSpaceOnUse",
    x1: 428.7051,
    y1: 1209.0929,
    x2: 408.718,
    y2: 1241.1443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178917276873949496880000002498912892121749164_)"
    },
    d: "M421.707,1231.877h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C422.647,1231.457,422.226,1231.877,421.707,1231.877z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030478172160180909730000006367728703529575349_",
    gradientUnits: "userSpaceOnUse",
    x1: 442.3393,
    y1: 1209.0929,
    x2: 422.3521,
    y2: 1241.1443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000030478172160180909730000006367728703529575349_)"
    },
    d: "M435.342,1231.877h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.158 C436.281,1231.457,435.861,1231.877,435.342,1231.877z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121268342004498723900000007229616453277456803_",
    gradientUnits: "userSpaceOnUse",
    x1: 455.9734,
    y1: 1209.0929,
    x2: 435.9864,
    y2: 1241.1443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121268342004498723900000007229616453277456803_)"
    },
    d: "M448.976,1231.877h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C449.915,1231.457,449.495,1231.877,448.976,1231.877z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119817136366050885150000004548635789580693412_",
    gradientUnits: "userSpaceOnUse",
    x1: 469.6076,
    y1: 1209.0929,
    x2: 449.6204,
    y2: 1241.1444
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119817136366050885150000004548635789580693412_)"
    },
    d: "M462.61,1231.877h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.157 C463.549,1231.457,463.129,1231.877,462.61,1231.877z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070102583182334276330000009642883749139846283_",
    gradientUnits: "userSpaceOnUse",
    x1: 483.2416,
    y1: 1209.0929,
    x2: 463.2545,
    y2: 1241.1443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070102583182334276330000009642883749139846283_)"
    },
    d: "M476.244,1231.877h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.158 C477.184,1231.457,476.763,1231.877,476.244,1231.877z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157278947172076844830000011392967937430880441_",
    gradientUnits: "userSpaceOnUse",
    x1: 496.8759,
    y1: 1209.0929,
    x2: 476.8887,
    y2: 1241.1443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157278947172076844830000011392967937430880441_)"
    },
    d: "M489.878,1231.877h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C490.818,1231.457,490.397,1231.877,489.878,1231.877z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010991312904114856650000013187950307450091699_",
    gradientUnits: "userSpaceOnUse",
    x1: 510.51,
    y1: 1209.0929,
    x2: 490.5229,
    y2: 1241.1443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010991312904114856650000013187950307450091699_)"
    },
    d: "M503.512,1231.877h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C504.452,1231.457,504.031,1231.877,503.512,1231.877z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078760802442891939660000004807456973587488154_",
    gradientUnits: "userSpaceOnUse",
    x1: 524.144,
    y1: 1209.0929,
    x2: 504.1569,
    y2: 1241.1443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078760802442891939660000004807456973587488154_)"
    },
    d: "M517.146,1231.877h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.157c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.94,0.421,0.94,0.939v18.157 C518.086,1231.456,517.665,1231.877,517.146,1231.877z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106113277472299134450000016827150434588198795_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.7781,
    y1: 1209.0929,
    x2: 517.7911,
    y2: 1241.1443
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106113277472299134450000016827150434588198795_)"
    },
    d: "M530.781,1231.877h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C531.72,1231.457,531.299,1231.877,530.781,1231.877z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111185973161914954420000008634875643277238918_",
    gradientUnits: "userSpaceOnUse",
    x1: 499.9908,
    y1: 1173.2145,
    x2: 369.4898,
    y2: 1382.4861
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111185973161914954420000008634875643277238918_)"
    },
    d: "M534.682,1272.193H361.343 c-2.338,0-4.234-1.896-4.234-4.234v-22.784c0-2.339,1.896-4.234,4.234-4.234h173.338c2.339,0,4.234,1.896,4.234,4.234v22.784 C538.916,1270.297,537.02,1272.193,534.682,1272.193z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151509703149181134810000010339232637256994976_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.1685,
    y1: 1243.8008,
    x2: 354.1815,
    y2: 1275.8521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151509703149181134810000010339232637256994976_)"
    },
    d: "M367.171,1266.585h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C368.11,1266.164,367.69,1266.585,367.171,1266.585z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070819194608193274950000009581063245427265420_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.8028,
    y1: 1243.8008,
    x2: 367.8156,
    y2: 1275.8521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070819194608193274950000009581063245427265420_)"
    },
    d: "M380.805,1266.585h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.158 C381.745,1266.164,381.324,1266.585,380.805,1266.585z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128460260754123315450000005448216132332336573_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.437,
    y1: 1243.8008,
    x2: 381.4499,
    y2: 1275.8521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128460260754123315450000005448216132332336573_)"
    },
    d: "M394.439,1266.585h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C395.379,1266.164,394.958,1266.585,394.439,1266.585z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057115908538188476810000011265486151306286241_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.0711,
    y1: 1243.8007,
    x2: 395.0839,
    y2: 1275.8523
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057115908538188476810000011265486151306286241_)"
    },
    d: "M408.074,1266.585h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.158 C409.013,1266.164,408.592,1266.585,408.074,1266.585z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082345310357491314330000010975906944996593844_",
    gradientUnits: "userSpaceOnUse",
    x1: 428.7051,
    y1: 1243.8008,
    x2: 408.718,
    y2: 1275.8522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082345310357491314330000010975906944996593844_)"
    },
    d: "M421.707,1266.585h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C422.647,1266.164,422.226,1266.585,421.707,1266.585z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045588805881791202580000008989119284674258336_",
    gradientUnits: "userSpaceOnUse",
    x1: 442.3393,
    y1: 1243.8008,
    x2: 422.3521,
    y2: 1275.8521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045588805881791202580000008989119284674258336_)"
    },
    d: "M435.342,1266.585h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.158 C436.281,1266.164,435.861,1266.585,435.342,1266.585z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176763326685294320210000005512039322487233194_",
    gradientUnits: "userSpaceOnUse",
    x1: 455.9734,
    y1: 1243.8008,
    x2: 435.9864,
    y2: 1275.8521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176763326685294320210000005512039322487233194_)"
    },
    d: "M448.976,1266.585h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C449.915,1266.164,449.495,1266.585,448.976,1266.585z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029741170341152676290000000156790777241373340_",
    gradientUnits: "userSpaceOnUse",
    x1: 469.6076,
    y1: 1243.8007,
    x2: 449.6204,
    y2: 1275.8522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029741170341152676290000000156790777241373340_)"
    },
    d: "M462.61,1266.585h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.158 C463.549,1266.164,463.129,1266.585,462.61,1266.585z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052789396884408681350000002115982862210761897_",
    gradientUnits: "userSpaceOnUse",
    x1: 483.2416,
    y1: 1243.8008,
    x2: 463.2545,
    y2: 1275.8521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052789396884408681350000002115982862210761897_)"
    },
    d: "M476.244,1266.585h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.158 C477.184,1266.164,476.763,1266.585,476.244,1266.585z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150812267357785589530000001798324363588619419_",
    gradientUnits: "userSpaceOnUse",
    x1: 496.8759,
    y1: 1243.8008,
    x2: 476.8887,
    y2: 1275.8522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150812267357785589530000001798324363588619419_)"
    },
    d: "M489.878,1266.585h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C490.818,1266.164,490.397,1266.585,489.878,1266.585z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005235761941069422110000015974251293818098337_",
    gradientUnits: "userSpaceOnUse",
    x1: 510.51,
    y1: 1243.8008,
    x2: 490.5229,
    y2: 1275.8522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005235761941069422110000015974251293818098337_)"
    },
    d: "M503.512,1266.585h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C504.452,1266.164,504.031,1266.585,503.512,1266.585z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067931296696817513860000010848326677018346658_",
    gradientUnits: "userSpaceOnUse",
    x1: 524.1441,
    y1: 1243.8007,
    x2: 504.1569,
    y2: 1275.8522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067931296696817513860000010848326677018346658_)"
    },
    d: "M517.147,1266.585h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.158 C518.086,1266.164,517.666,1266.585,517.147,1266.585z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139975723118129901060000017697106277271141813_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.7781,
    y1: 1243.8008,
    x2: 517.7911,
    y2: 1275.8521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000139975723118129901060000017697106277271141813_)"
    },
    d: "M530.781,1266.585h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C531.72,1266.164,531.299,1266.585,530.781,1266.585z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033346893984966610090000005482025581434001795_",
    gradientUnits: "userSpaceOnUse",
    x1: 499.9909,
    y1: 1207.9222,
    x2: 369.4897,
    y2: 1417.1943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033346893984966610090000005482025581434001795_)"
    },
    d: "M534.682,1306.901H361.343 c-2.338,0-4.234-1.896-4.234-4.234v-22.784c0-2.338,1.896-4.234,4.234-4.234h173.338c2.339,0,4.234,1.896,4.234,4.234v22.784 C538.916,1305.005,537.02,1306.901,534.682,1306.901z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086651874759703677640000012894286496404263059_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.1686,
    y1: 1278.5087,
    x2: 354.1814,
    y2: 1310.5602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086651874759703677640000012894286496404263059_)"
    },
    d: "M367.171,1301.293h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C368.11,1300.872,367.69,1301.293,367.171,1301.293z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010992017270750366270000015870013198663860143_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.8028,
    y1: 1278.5087,
    x2: 367.8156,
    y2: 1310.5602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010992017270750366270000015870013198663860143_)"
    },
    d: "M380.805,1301.293h-1.926 c-0.519,0-0.94-0.421-0.94-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.158 C381.745,1300.872,381.324,1301.293,380.805,1301.293z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134238821572793131420000006928515707864249749_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.437,
    y1: 1278.5087,
    x2: 381.4498,
    y2: 1310.5602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134238821572793131420000006928515707864249749_)"
    },
    d: "M394.439,1301.293h-1.926 c-0.519,0-0.94-0.421-0.94-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C395.379,1300.872,394.958,1301.293,394.439,1301.293z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160180708597858250260000017527528073230245283_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.0711,
    y1: 1278.5085,
    x2: 395.0838,
    y2: 1310.5603
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160180708597858250260000017527528073230245283_)"
    },
    d: "M408.073,1301.293h-1.926 c-0.519,0-0.94-0.421-0.94-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.158 C409.013,1300.872,408.592,1301.293,408.073,1301.293z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167368303236820508450000006388046837757775495_",
    gradientUnits: "userSpaceOnUse",
    x1: 428.7051,
    y1: 1278.5085,
    x2: 408.7179,
    y2: 1310.5602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167368303236820508450000006388046837757775495_)"
    },
    d: "M421.707,1301.293h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C422.647,1300.872,422.226,1301.293,421.707,1301.293z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080177239978142525270000006328480193201538962_",
    gradientUnits: "userSpaceOnUse",
    x1: 442.3393,
    y1: 1278.5087,
    x2: 422.3521,
    y2: 1310.5602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080177239978142525270000006328480193201538962_)"
    },
    d: "M435.342,1301.293h-1.926 c-0.519,0-0.94-0.421-0.94-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.158 C436.281,1300.872,435.861,1301.293,435.342,1301.293z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060748119146815067630000009057570787815884941_",
    gradientUnits: "userSpaceOnUse",
    x1: 455.9735,
    y1: 1278.5087,
    x2: 435.9863,
    y2: 1310.5602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060748119146815067630000009057570787815884941_)"
    },
    d: "M448.976,1301.293h-1.926 c-0.519,0-0.94-0.421-0.94-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C449.915,1300.872,449.495,1301.293,448.976,1301.293z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010285975447271881090000010223082123785205661_",
    gradientUnits: "userSpaceOnUse",
    x1: 469.6076,
    y1: 1278.5085,
    x2: 449.6203,
    y2: 1310.5603
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010285975447271881090000010223082123785205661_)"
    },
    d: "M462.61,1301.293h-1.926 c-0.519,0-0.94-0.421-0.94-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.158 C463.549,1300.872,463.129,1301.293,462.61,1301.293z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077301749236257906420000016511295198500232580_",
    gradientUnits: "userSpaceOnUse",
    x1: 483.2417,
    y1: 1278.5087,
    x2: 463.2545,
    y2: 1310.5602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000077301749236257906420000016511295198500232580_)"
    },
    d: "M476.244,1301.293h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.158 C477.184,1300.872,476.763,1301.293,476.244,1301.293z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095330404181867291940000013395032661113581232_",
    gradientUnits: "userSpaceOnUse",
    x1: 496.8759,
    y1: 1278.5087,
    x2: 476.8886,
    y2: 1310.5602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095330404181867291940000013395032661113581232_)"
    },
    d: "M489.878,1301.293h-1.926 c-0.519,0-0.94-0.421-0.94-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C490.818,1300.872,490.397,1301.293,489.878,1301.293z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017506543304400259220000003978153209980074671_",
    gradientUnits: "userSpaceOnUse",
    x1: 510.51,
    y1: 1278.5085,
    x2: 490.5228,
    y2: 1310.5602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017506543304400259220000003978153209980074671_)"
    },
    d: "M503.512,1301.293h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C504.452,1300.872,504.031,1301.293,503.512,1301.293z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037661203148901786900000007951891416306328974_",
    gradientUnits: "userSpaceOnUse",
    x1: 524.1442,
    y1: 1278.5085,
    x2: 504.1568,
    y2: 1310.5603
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037661203148901786900000007951891416306328974_)"
    },
    d: "M517.146,1301.293h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.158 C518.086,1300.872,517.665,1301.293,517.146,1301.293z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037658630131908143190000004670154955586189995_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.7782,
    y1: 1278.5087,
    x2: 517.791,
    y2: 1310.5602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037658630131908143190000004670154955586189995_)"
    },
    d: "M530.781,1301.293h-1.926 c-0.519,0-0.94-0.421-0.94-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C531.72,1300.872,531.299,1301.293,530.781,1301.293z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147927172073977287500000010979723049249550212_",
    gradientUnits: "userSpaceOnUse",
    x1: 499.9908,
    y1: 1242.6301,
    x2: 369.4897,
    y2: 1451.9021
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147927172073977287500000010979723049249550212_)"
    },
    d: "M534.682,1341.609H361.344 c-2.339,0-4.234-1.896-4.234-4.234v-22.784c0-2.339,1.896-4.234,4.234-4.234h173.338c2.339,0,4.234,1.896,4.234,4.234v22.784 C538.916,1339.713,537.02,1341.609,534.682,1341.609z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050653670116670951780000012611031330546036653_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.1686,
    y1: 1313.2164,
    x2: 354.1814,
    y2: 1345.2681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050653670116670951780000012611031330546036653_)"
    },
    d: "M367.171,1336.001h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.94,0.421,0.94,0.939v18.158 C368.11,1335.58,367.69,1336.001,367.171,1336.001z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102535993012445802040000002980877510841105327_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.8028,
    y1: 1313.2164,
    x2: 367.8156,
    y2: 1345.2681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102535993012445802040000002980877510841105327_)"
    },
    d: "M380.805,1336.001h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C381.745,1335.58,381.324,1336.001,380.805,1336.001z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101798084341863723230000013600906933527320989_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.437,
    y1: 1313.2164,
    x2: 381.4498,
    y2: 1345.2681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101798084341863723230000013600906933527320989_)"
    },
    d: "M394.439,1336.001h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.94,0.421,0.94,0.939v18.158 C395.379,1335.58,394.958,1336.001,394.439,1336.001z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056406377756944511760000012278362553016025515_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.0711,
    y1: 1313.2164,
    x2: 395.0838,
    y2: 1345.2682
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056406377756944511760000012278362553016025515_)"
    },
    d: "M408.074,1336.001h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.94-0.939h1.926c0.519,0,0.94,0.421,0.94,0.939v18.158 C409.013,1335.58,408.592,1336.001,408.074,1336.001z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132069263532441976050000013271782367526517931_",
    gradientUnits: "userSpaceOnUse",
    x1: 428.7051,
    y1: 1313.2164,
    x2: 408.7179,
    y2: 1345.2681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132069263532441976050000013271782367526517931_)"
    },
    d: "M421.707,1336.001h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.94,0.421,0.94,0.939v18.158 C422.647,1335.58,422.226,1336.001,421.707,1336.001z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150086434800679910590000013511683431002151838_",
    gradientUnits: "userSpaceOnUse",
    x1: 442.3393,
    y1: 1313.2164,
    x2: 422.3521,
    y2: 1345.2681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150086434800679910590000013511683431002151838_)"
    },
    d: "M435.342,1336.001h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.94-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C436.281,1335.58,435.861,1336.001,435.342,1336.001z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054985521503350232030000014635534722504916107_",
    gradientUnits: "userSpaceOnUse",
    x1: 455.9735,
    y1: 1313.2164,
    x2: 435.9863,
    y2: 1345.2681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054985521503350232030000014635534722504916107_)"
    },
    d: "M448.976,1336.001h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.94-0.939h1.926c0.519,0,0.94,0.421,0.94,0.939v18.158 C449.915,1335.58,449.495,1336.001,448.976,1336.001z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084520361860938604710000010300475785111063989_",
    gradientUnits: "userSpaceOnUse",
    x1: 469.6077,
    y1: 1313.2164,
    x2: 449.6203,
    y2: 1345.2682
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084520361860938604710000010300475785111063989_)"
    },
    d: "M462.61,1336.001h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.94-0.939h1.926c0.519,0,0.94,0.421,0.94,0.939v18.158 C463.549,1335.58,463.129,1336.001,462.61,1336.001z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120542648934231606890000008783942270181489081_",
    gradientUnits: "userSpaceOnUse",
    x1: 483.2417,
    y1: 1313.2164,
    x2: 463.2545,
    y2: 1345.2681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120542648934231606890000008783942270181489081_)"
    },
    d: "M476.244,1336.001h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C477.184,1335.58,476.763,1336.001,476.244,1336.001z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113325951257886305560000005491925845795315075_",
    gradientUnits: "userSpaceOnUse",
    x1: 496.8759,
    y1: 1313.2166,
    x2: 476.8887,
    y2: 1345.2681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000113325951257886305560000005491925845795315075_)"
    },
    d: "M489.878,1336.001h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.94-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C490.818,1335.58,490.397,1336.001,489.878,1336.001z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108299240073189451900000010490234271408298635_",
    gradientUnits: "userSpaceOnUse",
    x1: 510.51,
    y1: 1313.2164,
    x2: 490.5228,
    y2: 1345.2681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108299240073189451900000010490234271408298635_)"
    },
    d: "M503.512,1336.001h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.94,0.421,0.94,0.939v18.158 C504.452,1335.58,504.031,1336.001,503.512,1336.001z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011020011499640054810000015082201895013436349_",
    gradientUnits: "userSpaceOnUse",
    x1: 524.1442,
    y1: 1313.2164,
    x2: 504.1568,
    y2: 1345.2682
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011020011499640054810000015082201895013436349_)"
    },
    d: "M517.147,1336.001h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.94,0.421,0.94,0.94v18.158 C518.086,1335.58,517.666,1336.001,517.147,1336.001z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041976512030858016800000011593808373149117568_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.7782,
    y1: 1313.2164,
    x2: 517.791,
    y2: 1345.2681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041976512030858016800000011593808373149117568_)"
    },
    d: "M530.781,1336.001h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C531.72,1335.58,531.299,1336.001,530.781,1336.001z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173851214713110903860000007332560686613077636_",
    gradientUnits: "userSpaceOnUse",
    x1: 499.9908,
    y1: 1277.3381,
    x2: 369.4898,
    y2: 1486.61
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173851214713110903860000007332560686613077636_)"
    },
    d: "M534.682,1376.317H361.343 c-2.338,0-4.234-1.896-4.234-4.234v-22.784c0-2.338,1.896-4.234,4.234-4.234h173.338c2.339,0,4.234,1.896,4.234,4.234v22.784 C538.916,1374.421,537.02,1376.317,534.682,1376.317z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051341556712038953580000003084427414155731355_",
    gradientUnits: "userSpaceOnUse",
    x1: 398.6277,
    y1: 1246.7195,
    x2: 350.1276,
    y2: 1417.2196
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051341556712038953580000003084427414155731355_)"
    },
    d: "M367.171,1370.709h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C368.11,1370.288,367.69,1370.709,367.171,1370.709z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125561058642888050030000011701404724889258379_",
    gradientUnits: "userSpaceOnUse",
    x1: 411.2412,
    y1: 1250.3076,
    x2: 362.7412,
    y2: 1420.8076
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125561058642888050030000011701404724889258379_)"
    },
    d: "M380.805,1370.709h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.158 C381.745,1370.288,381.324,1370.709,380.805,1370.709z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037680252062953865480000008004140773265512623_",
    gradientUnits: "userSpaceOnUse",
    x1: 423.8547,
    y1: 1253.8956,
    x2: 375.3547,
    y2: 1424.3958
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037680252062953865480000008004140773265512623_)"
    },
    d: "M394.439,1370.709h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C395.379,1370.288,394.958,1370.709,394.439,1370.709z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160886459751316209490000003677261047990552468_",
    gradientUnits: "userSpaceOnUse",
    x1: 436.4682,
    y1: 1257.4836,
    x2: 387.9682,
    y2: 1427.9838
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160886459751316209490000003677261047990552468_)"
    },
    d: "M408.074,1370.709h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.157c0-0.519,0.421-0.94,0.94-0.94h1.927c0.519,0,0.939,0.421,0.939,0.939v18.158 C409.013,1370.288,408.592,1370.709,408.074,1370.709z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085964924929595059800000016511922504585640069_",
    gradientUnits: "userSpaceOnUse",
    x1: 449.0816,
    y1: 1261.0715,
    x2: 400.5816,
    y2: 1431.5717
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085964924929595059800000016511922504585640069_)"
    },
    d: "M421.707,1370.709h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C422.647,1370.288,422.226,1370.709,421.707,1370.709z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056427768506303346140000013194879135115733944_",
    gradientUnits: "userSpaceOnUse",
    x1: 461.6951,
    y1: 1264.6597,
    x2: 413.1951,
    y2: 1435.1597
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056427768506303346140000013194879135115733944_)"
    },
    d: "M435.342,1370.709h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.158 C436.281,1370.288,435.861,1370.709,435.342,1370.709z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056404126966394885230000003791910114913605003_",
    gradientUnits: "userSpaceOnUse",
    x1: 474.3087,
    y1: 1268.2476,
    x2: 425.8087,
    y2: 1438.7476
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056404126966394885230000003791910114913605003_)"
    },
    d: "M448.976,1370.709h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C449.915,1370.288,449.495,1370.709,448.976,1370.709z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165932579488440849690000003795518268162643095_",
    gradientUnits: "userSpaceOnUse",
    x1: 486.9222,
    y1: 1271.8356,
    x2: 438.4221,
    y2: 1442.3357
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165932579488440849690000003795518268162643095_)"
    },
    d: "M462.61,1370.709h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.157 C463.549,1370.288,463.129,1370.709,462.61,1370.709z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029008490421932156700000006222177932733822628_",
    gradientUnits: "userSpaceOnUse",
    x1: 499.5356,
    y1: 1275.4237,
    x2: 451.0356,
    y2: 1445.9237
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029008490421932156700000006222177932733822628_)"
    },
    d: "M476.244,1370.709h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.939,0.421,0.939,0.939v18.158 C477.184,1370.288,476.763,1370.709,476.244,1370.709z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154391684542652590090000013311596894807845820_",
    gradientUnits: "userSpaceOnUse",
    x1: 512.1492,
    y1: 1279.0115,
    x2: 463.6492,
    y2: 1449.5116
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154391684542652590090000013311596894807845820_)"
    },
    d: "M489.878,1370.709h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C490.818,1370.288,490.397,1370.709,489.878,1370.709z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179648081715329696760000010546412371087157685_",
    gradientUnits: "userSpaceOnUse",
    x1: 524.7627,
    y1: 1282.5996,
    x2: 476.2627,
    y2: 1453.0997
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179648081715329696760000010546412371087157685_)"
    },
    d: "M503.512,1370.709h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C504.452,1370.288,504.031,1370.709,503.512,1370.709z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170279689799435644210000001924316700606006414_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.3762,
    y1: 1286.1875,
    x2: 488.8761,
    y2: 1456.6877
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170279689799435644210000001924316700606006414_)"
    },
    d: "M517.146,1370.709h-1.927 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.927c0.519,0,0.94,0.421,0.94,0.94v18.157 C518.086,1370.288,517.665,1370.709,517.146,1370.709z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089533772795784546720000008632548286388605070_",
    gradientUnits: "userSpaceOnUse",
    x1: 549.9896,
    y1: 1289.7755,
    x2: 501.4896,
    y2: 1460.2756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089533772795784546720000008632548286388605070_)"
    },
    d: "M530.781,1370.709h-1.926 c-0.519,0-0.939-0.421-0.939-0.939v-18.158c0-0.519,0.421-0.939,0.939-0.939h1.926c0.519,0,0.939,0.421,0.939,0.939v18.158 C531.72,1370.288,531.299,1370.709,530.781,1370.709z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122707712695923450590000005840462011589669523_",
    gradientUnits: "userSpaceOnUse",
    x1: 1871.0717,
    y1: 616.4526,
    x2: 2059.4419,
    y2: 1587.0807
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122707712695923450590000005840462011589669523_)"
    },
    d: "M1961.329,1240.643 c-1.363,0.273,10.423,200.815,19.456,245.981l18.761-1.39l4.169-202.9h6.949l10.423,199.425h15.287l14.592-243.202 C2050.967,1238.558,1992.598,1234.389,1961.329,1240.643z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082334768176899349870000004974745001576710796_",
    gradientUnits: "userSpaceOnUse",
    x1: 1927.4077,
    y1: 1421.6288,
    x2: 2067.4304,
    y2: 1579.4156
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082334768176899349870000004974745001576710796_)"
    },
    d: "M1980.786,1499.826 c0,0,15.287,2.084,24.32,0c0,0,2.779-7.644-5.559-14.592s-18.761,1.39-18.761,1.39V1499.826z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111881991725587409020000011563045849375644049_",
    gradientUnits: "userSpaceOnUse",
    x1: 1955.814,
    y1: 1396.4204,
    x2: 2095.8369,
    y2: 1554.2074
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111881991725587409020000011563045849375644049_)"
    },
    d: "M2021.088,1481.76 c0,0-0.695,11.118,0,16.677c0,0,29.185,0.973,45.23,0.884c2.947-0.016,3.774-4.031,1.079-5.223 c-5.161-2.281-14.417-9.878-31.021-12.337H2021.088z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109741280305988001450000012562454512074530964_",
    gradientUnits: "userSpaceOnUse",
    x1: 2019.9297,
    y1: 1045.0752,
    x2: 2000.8826,
    y2: 1315.4009
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109741280305988001450000012562454512074530964_)"
    },
    d: "M1967.583,1078.74 c0,0,40.302-13.202,72.266-1.39l15.982,167.462c0,0-71.571-2.085-95.891,3.474L1967.583,1078.74z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034810356496362397120000007957734003254958267_",
    gradientUnits: "userSpaceOnUse",
    x1: 1926.6375,
    y1: 1128.2408,
    x2: 2199.9941,
    y2: 1370.2073
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034810356496362397120000007957734003254958267_)"
    },
    d: "M1932.145,1092.637 c0,0,23.625-13.202,45.861-16.677l-6.666,169.976c-0.166,4.232-3.209,7.798-7.361,8.629l-2.368,0.474 c-2.277,0.455-4.386-1.325-4.319-3.647l2.08-71.749c0.375-12.925-1.979-25.783-6.909-37.737L1932.145,1092.637z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118378599090804325980000014787701939514795409_",
    gradientUnits: "userSpaceOnUse",
    x1: 1965.2841,
    y1: 1084.5807,
    x2: 2238.6414,
    y2: 1326.5474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118378599090804325980000014787701939514795409_)"
    },
    d: "M2028.731,1074.571 c0,0,34.743,2.78,54.894,20.846l-15.662,44.224c-5.27,14.88-7.963,30.549-7.963,46.334l-3.297,63.75 c-0.099,1.92-1.685,3.426-3.607,3.426l0,0c-4.746,0-8.706-3.622-9.13-8.349L2028.731,1074.571z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091727987297065061170000004965201561677131392_",
    gradientUnits: "userSpaceOnUse",
    x1: 2000.5616,
    y1: 1104.2303,
    x2: 2005.2571,
    y2: 1064.0588
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091727987297065061170000004965201561677131392_)"
    },
    d: "M1989.819,1053.725l-0.6,19.796 c-0.059,1.957,1.155,3.721,3.002,4.373c5.061,1.786,15.54,4.5,25.47,0.944c2.003-0.717,3.209-2.768,2.899-4.873l-2.976-20.24 H1989.819z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008151471767569544300000009645706439885646519_",
    gradientUnits: "userSpaceOnUse",
    x1: 2006.7231,
    y1: 1059.265,
    x2: 2004.9272,
    y2: 1007.5084
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008151471767569544300000009645706439885646519_)"
    },
    d: "M1981.48,1017.592 c0,0,3.474,35.438,11.118,44.471c0,0,22.93,2.085,31.269-2.779c0,0,5.906-17.719,5.211-41.344c0,0,1.139-21.499-22.583-23.278 C1978.701,992.577,1981.48,1017.592,1981.48,1017.592z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101806038345532577410000000356888598898997168_",
    gradientUnits: "userSpaceOnUse",
    x1: 2030.9811,
    y1: 1058.4238,
    x2: 2029.1851,
    y2: 1006.6664
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101806038345532577410000000356888598898997168_)"
    },
    d: "M2026.646,1028.71 c0,0,2.084-6.254,5.559-6.254c3.474,0-0.695,16.677-5.559,16.677V1028.71z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169546902586048178010000011766948868116951467_",
    gradientUnits: "userSpaceOnUse",
    x1: 1982.5942,
    y1: 1060.1023,
    x2: 1980.7982,
    y2: 1008.3461
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169546902586048178010000011766948868116951467_)"
    },
    d: "M1984.642,1030.352 c0,0-2.909-5.916-6.351-5.447c-3.443,0.468,2.938,16.43,7.757,15.775L1984.642,1030.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1983.879,1036.289c0,0,0.779,21.168,10.09,31.904c0.854,0.985,2.09,1.558,3.393,1.621 c4.752,0.229,16.901,0.637,23.75-0.728c1.705-0.34,3.108-1.542,3.67-3.187c1.684-4.937,4.607-12.723,3.602-30.588l-5.588,13.316 c-4.14,11.004-6.387-2.354-8.309-2.198h-12.508c-1.318,0.106-2.779,8.338-7.664,5.926L1983.879,1036.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2019.698,1009.254c0,0-17.704,18.208-36.994,18.137c0,0-10.952-29.255,10.589-34.119 c21.541-4.864,22.235,1.39,22.235,1.39s25.189-6.186,13.984,29.565L2019.698,1009.254z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053503082365609645300000006982019424842379958_",
    gradientUnits: "userSpaceOnUse",
    x1: 2009.738,
    y1: 1260.2623,
    x2: 2017.2393,
    y2: 1496.1334
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053503082365609645300000006982019424842379958_)"
    },
    d: "M2012.749,1504.69 c-1.151,0-2.085-0.933-2.085-2.084v-295.316c0-1.152,0.933-2.084,2.085-2.084c1.151,0,2.085,0.933,2.085,2.084v295.316 C2014.834,1503.757,2013.9,1504.69,2012.749,1504.69z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064328959973562500400000004011735861638615171_",
    gradientUnits: "userSpaceOnUse",
    x1: 1968.613,
    y1: 1080.8202,
    x2: 2241.9697,
    y2: 1322.7865
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064328959973562500400000004011735861638615171_)"
    },
    d: "M2021.782,1203.12 c0,0,39.607,22.236,49.335-6.254c9.728-28.489-8.338-46.556-8.338-46.556l20.846-54.894c0,0,39.607,72.961,11.813,117.432 c-26.041,41.666-72.266,3.474-72.266,3.474L2021.782,1203.12z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101097173492220410430000015089593344989678758_",
    gradientUnits: "userSpaceOnUse",
    x1: 1911.2509,
    y1: 1145.6237,
    x2: 2184.6074,
    y2: 1387.59
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101097173492220410430000015089593344989678758_)"
    },
    d: "M1932.145,1092.637 c0,0-37.522,125.075,0,141.752c37.523,16.677,68.792-23.625,68.792-23.625l-4.169-11.813c0,0-34.048,19.456-45.166,9.728 c-11.118-9.728,7.644-66.706,7.644-66.706L1932.145,1092.637z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019638483216725032460000011824264077310224561_",
    gradientUnits: "userSpaceOnUse",
    x1: 2006.0858,
    y1: 1208.3074,
    x2: 2023.1722,
    y2: 1208.3074
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019638483216725032460000011824264077310224561_)"
    },
    d: "M2023.172,1216.323 c0,0-7.644,0.695-11.813-3.474c-4.169-4.169-8.338-11.813-2.084-12.508c6.254-0.695,12.507,2.78,12.507,2.78L2023.172,1216.323z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039836275166906092670000010699847626977689235_",
    gradientUnits: "userSpaceOnUse",
    x1: 2022.4592,
    y1: 1199.799,
    x2: 1987.8285,
    y2: 1217.1145
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039836275166906092670000010699847626977689235_)"
    },
    d: "M2025.952,1203.12 c0,0-18.066-11.118-29.184-4.169c0,0-2.085,8.338,4.169,11.813c0,0,11.118,7.644,20.151,3.474 C2030.121,1210.069,2025.952,1203.12,2025.952,1203.12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026131969267670111040000010825631454159447989_",
    gradientUnits: "userSpaceOnUse",
    x1: 2066.8806,
    y1: 1147.8152,
    x2: 2070.1326,
    y2: 1185.5565
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026131969267670111040000010825631454159447989_)"
    },
    d: "M2084.917,1171.505 c0,0,0.336-3.266-1.168-6.901c-1.504-3.635-9.903-4.262-12.16-6.895c-2.256-2.633-2.758,2.131-1.504,3.259 c1.254,1.128-12.912-0.251-14.667-3.635c0,0-3.823-4.199-3.823,0.439c0,4.638,10.906,10.718,15.293,11.157 c4.387,0.439,7.456,2.93,7.677,4.098C2076.729,1173.942,2084.917,1171.505,2084.917,1171.505z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034785238308899496800000003700470005301318788_",
    gradientUnits: "userSpaceOnUse",
    x1: 2315.6472,
    y1: 1257.9569,
    x2: 1611.6469,
    y2: 995.9568
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034785238308899496800000003700470005301318788_)"
    },
    d: "M2118.156,1130.595 c0,0-15.73,20.846-14.727,53.94c1.003,33.094-5.348,19.221-12.034,2.841c-6.686-16.38-6.686-16.38-6.686-16.38l-10.478,2.096 c0,0,13.153,63.2,31.538,59.3c18.385-3.899,20.057-51.368,20.057-60.728C2125.826,1162.305,2118.156,1130.595,2118.156,1130.595 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132087614685271051050000003718544041403552182_",
    gradientUnits: "userSpaceOnUse",
    x1: -2370.0933,
    y1: 2273.2112,
    x2: -2460.4812,
    y2: 2347.4023,
    gradientTransform: "matrix(-1 0 0 1 721.3085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000132087614685271051050000003718544041403552182_)"
    },
    d: " M2157.351,1492.598l1.257,3.086l-0.51,11.111c-0.072,1.562-1.332,2.872-3.03,3.134c-2.318,0.358-5.689,0.719-8.861,0.474 c-2.483-0.192-4.039-2.524-3.067-4.607l3.74-8.014c0.559-1.199,1.581-2.119,2.832-2.551L2157.351,1492.598z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085209021806733611780000008847111963828184221_",
    gradientUnits: "userSpaceOnUse",
    x1: -1439.9564,
    y1: 1444.6752,
    x2: -1417.3817,
    y2: 1444.6752,
    gradientTransform: "matrix(-1 0 0 1 721.3085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000085209021806733611780000008847111963828184221_)"
    },
    d: " M2161.265,1391.85c0,0,0,80.569-3.792,103.264c-0.194,1.165-1.082,2.101-2.246,2.298c-1.064,0.18-2.516,0.14-4.251-0.63 c-0.873-0.387-1.453-1.241-1.57-2.189l-10.715-101.333L2161.265,1391.85z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183937407108628319440000014860275827763375751_",
    gradientUnits: "userSpaceOnUse",
    x1: 3230.6479,
    y1: 2180.8145,
    x2: 3140.2603,
    y2: 2255.0059,
    gradientTransform: "matrix(1 0 0 1 -1881.3085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000183937407108628319440000014860275827763375751_)"
    },
    d: " M2170.823,1492.598l-1.257,3.086l-0.901,11.111c0.072,1.562,1.331,2.872,3.03,3.134c2.318,0.358,7.1,0.719,10.271,0.474 c2.483-0.192,4.039-2.524,3.067-4.607l-3.74-8.014c-0.56-1.199-1.582-2.119-2.833-2.551L2170.823,1492.598z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170986513805261073890000001335683780260039844_",
    gradientUnits: "userSpaceOnUse",
    x1: 4048.2173,
    y1: 1444.6752,
    x2: 4070.7922,
    y2: 1444.6752,
    gradientTransform: "matrix(1 0 0 1 -1881.3085 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "url(#SVGID_00000170986513805261073890000001335683780260039844_)"
    },
    d: " M2166.909,1391.85c0,0,0,81.632,3.885,103.802c0.128,0.728,0.639,1.339,1.343,1.563c1.129,0.36,3.029,0.578,5.434-0.607 c0.625-0.308,1.062-0.913,1.148-1.604l10.766-101.744L2166.909,1391.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173849203834256733390000007096685075783351177_",
    gradientUnits: "userSpaceOnUse",
    x1: 1973.4805,
    y1: 1520.3138,
    x2: 2193.3884,
    y2: 1282.8132
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173849203834256733390000007096685075783351177_)"
    },
    d: "M2128.846,1232.393 c-11.166,25.82-10.181,98.632,5.583,171.669c0,0,39.079,3.489,57.921,0c0,0,25.82-150.734-1.396-171.669H2128.846z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183239757226449799210000013759532130076446882_",
    gradientUnits: "userSpaceOnUse",
    x1: 2324.541,
    y1: 1234.0603,
    x2: 1620.5404,
    y2: 972.0602
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183239757226449799210000013759532130076446882_)"
    },
    d: "M2209.796,1135.392 c0,0-14.655-24.425-45.36-31.403l-16.05-0.698c0,0-23.029,11.166-32.799,32.101l12.561,53.734l0.698,43.266 c0,0,36.986,8.374,62.108,0l5.583-53.036L2209.796,1135.392z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070818853987834567660000016915240020700970907_",
    gradientUnits: "userSpaceOnUse",
    x1: 2155.0212,
    y1: 1072.6042,
    x2: 2161.6877,
    y2: 1188.6041
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070818853987834567660000016915240020700970907_)"
    },
    d: "M2146.99,1083.752v26.446 c0,2.139,1.558,3.96,3.673,4.278c3.504,0.527,8.923,0.936,13.575-0.463c2.143-0.644,3.464-2.79,3.035-4.986l-4.931-25.274 H2146.99z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142155844804344053970000010392293123684324996_",
    gradientUnits: "userSpaceOnUse",
    x1: 2163.5464,
    y1: 1020.2324,
    x2: 2128.2131,
    y2: 1097.5659
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142155844804344053970000010392293123684324996_)"
    },
    d: "M2120.664,1057.619 c0,0-1.646,47.671,20.257,46.03c25.778-1.931,23.242-35.988,23.242-35.988S2123.205,1014.801,2120.664,1057.619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2163.876,1045.73c0,0-14.126-13.637-9.513-22.766c4.614-9.128,18.486-10.45,24.873,2.506 C2185.621,1038.427,2173.024,1059.088,2163.876,1045.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2113.052,1056.275c0.213,3.8,4.423,5.98,7.667,3.99c3.265-2.004,7.374-4.202,11.194-5.322 c25.801-7.568,21.437,12.304,22.326,14.95c1.819,5.411,4.372-4.604,5.289-2.882c1.996,3.747,2.947,16.829,2.947,16.829 s13.911-9.36,17.792-18.646c4.795-11.469-5.451-27.111-11.555-32.201c-5.596-4.666-23.684-8.709-30.738-5.602 C2131.667,1030.169,2111.879,1035.315,2113.052,1056.275z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096052769365609111200000013695651168247065474_",
    gradientUnits: "userSpaceOnUse",
    x1: 2180.042,
    y1: 1027.7694,
    x2: 2144.7087,
    y2: 1105.1024
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096052769365609111200000013695651168247065474_)"
    },
    d: "M2157.776,1072.753 c0,0-1.351-10.589,4.608-10.383c5.959,0.206,0.478,14.564-2.163,17.66L2157.776,1072.753z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154390567982083649780000005697896119957467558_",
    gradientUnits: "userSpaceOnUse",
    x1: 2323.5481,
    y1: 1236.7269,
    x2: 1619.5504,
    y2: 974.7278
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154390567982083649780000005697896119957467558_)"
    },
    d: "M2209.796,1135.392 c0,0,50.942,78.856-7.677,115.144l-5.347-7.604c0,0,27.678-40.547,1.858-76.835L2209.796,1135.392z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114785584932959485460000015190843777984886144_",
    gradientUnits: "userSpaceOnUse",
    x1: 2188.0349,
    y1: 1229.6494,
    x2: 2192.0864,
    y2: 1509.6121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114785584932959485460000015190843777984886144_)"
    },
    d: "M2190.256,1513.274 c-1.349,0-2.442-1.094-2.442-2.442v-255.411c0-1.349,1.094-2.443,2.442-2.443c1.349,0,2.442,1.094,2.442,2.443v255.411 C2192.698,1512.181,2191.605,1513.274,2190.256,1513.274z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016796640623500635210000012569155158336018099_",
    gradientUnits: "userSpaceOnUse",
    x1: 2182.3982,
    y1: 1256.1339,
    x2: 2202.1191,
    y2: 1256.1339
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016796640623500635210000012569155158336018099_)"
    },
    d: "M2196.536,1242.86 c0,0-13.259,4.885-13.957,15.353c-0.698,10.468,0.698,13.259,2.792,9.77c2.094-3.489,4.187-6.978,8.374-9.77 c4.187-2.791,8.374-7.676,8.374-7.676S2201.421,1242.86,2196.536,1242.86z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M978.97,610.311c-27.298,3.483-92.016,5.642-167.872-34.165 c-5.12-2.687-11.412-1.46-15.079,3.011c-10.815,13.186-32.654,40.544-44.397,60.343c-3.442,5.803-1.169,13.288,4.947,16.134 c30.572,14.23,121.679,49.862,202.208,13.124c3.867-1.764,6.983-4.85,8.832-8.677l18.941-39.204 C989.105,615.591,984.794,609.568,978.97,610.311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M866.098,677.17c1.184,0.269,2.459-0.214,3.151-1.295l34.081-53.413 c0.878-1.378,0.474-3.207-0.904-4.088c-1.378-0.882-3.206-0.474-4.087,0.904l-34.081,53.413 c-0.879,1.377-0.474,3.207,0.904,4.088C865.458,676.968,865.774,677.097,866.098,677.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M833.746,675.78c1.071,0.243,2.237-0.122,2.97-1.039l45.643-57.169 c1.019-1.277,0.81-3.14-0.466-4.16c-1.28-1.015-3.14-0.812-4.16,0.466l-45.642,57.169c-1.019,1.277-0.811,3.14,0.466,4.16 C832.916,675.495,833.324,675.684,833.746,675.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M812.599,670.438c1.091,0.248,2.276-0.136,3.003-1.081l46.471-60.446 c0.995-1.296,0.753-3.154-0.543-4.151c-1.299-0.997-3.155-0.752-4.151,0.543l-46.471,60.446 c-0.995,1.296-0.753,3.154,0.543,4.151C811.802,670.169,812.195,670.347,812.599,670.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M796.755,662.958c1.202,0.273,2.496-0.229,3.177-1.337l38.238-62.178 c0.855-1.393,0.421-3.215-0.971-4.072c-1.394-0.854-3.214-0.421-4.071,0.971l-38.238,62.178 c-0.856,1.393-0.422,3.215,0.971,4.072C796.145,662.766,796.446,662.888,796.755,662.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M773.587,656.172c1.164,0.264,2.423-0.197,3.122-1.252l43.96-66.282 c0.904-1.363,0.532-3.199-0.831-4.102c-1.357-0.901-3.198-0.533-4.102,0.831l-43.96,66.282 c-0.904,1.363-0.532,3.199,0.831,4.102C772.914,655.955,773.246,656.094,773.587,656.172z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M724.979,575.449l-36.255,44.933c-2.74,3.396-7.328,4.671-11.433,3.19 c-23.505-8.48-101.379-40.469-151.839-107.619c-3.345-4.451-3.615-10.505-0.779-15.296l51.443-86.944 c3.454-5.839,10.974-7.85,16.843-4.447c16.882,9.788,49.612,33.839,71.394,82.089c13.293,29.445,42.752,54.561,58.476,66.494 C728.382,562.063,729.357,570.022,724.979,575.449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M627.3,590.362c1.047,0.238,2.185-0.104,2.924-0.981l47.836-56.931 c1.052-1.252,0.889-3.119-0.362-4.171c-1.255-1.051-3.118-0.887-4.171,0.362l-47.836,56.931 c-1.052,1.252-0.889,3.119,0.362,4.17C626.427,590.056,626.856,590.261,627.3,590.362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M606.335,580.07c1.009,0.229,2.108-0.077,2.852-0.898l57.296-63.27 c1.098-1.212,1.004-3.084-0.207-4.181c-1.217-1.094-3.084-1.004-4.181,0.207l-57.297,63.27 c-1.097,1.212-1.004,3.084,0.207,4.181C605.397,579.731,605.856,579.961,606.335,580.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M590.23,566.006c1.126,0.256,2.344-0.164,3.061-1.161l27.656-38.501 c0.953-1.328,0.65-3.176-0.678-4.131c-1.328-0.946-3.178-0.65-4.131,0.677l-27.656,38.501c-0.953,1.328-0.65,3.176,0.678,4.131 C589.491,565.76,589.855,565.921,590.23,566.006z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M569.533,545.553c1.156,0.262,2.405-0.191,3.108-1.231l57.301-84.853 c0.915-1.354,0.558-3.195-0.797-4.109c-1.353-0.918-3.193-0.557-4.109,0.797l-57.301,84.853 c-0.915,1.354-0.558,3.194,0.796,4.109C568.845,545.33,569.184,545.474,569.533,545.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M557.346,532.399c1.252,0.284,2.591-0.276,3.244-1.455l52.505-94.925 c0.791-1.43,0.273-3.231-1.157-4.022c-1.426-0.788-3.231-0.274-4.022,1.157l-52.505,94.925 c-0.791,1.43-0.272,3.231,1.157,4.022C556.818,532.239,557.079,532.338,557.346,532.399z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168795997698963585490000011740609251137360014_",
    gradientUnits: "userSpaceOnUse",
    x1: 393.6456,
    y1: 281.1243,
    x2: 604.1641,
    y2: 281.1243,
    gradientTransform: "matrix(0.9936 0.1133 -0.1133 0.9936 49.3654 132.5085)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168795997698963585490000011740609251137360014_)"
    },
    d: "M610.932,531.08 c-9.723,10.425-30.707,34.129-35.431,49.306c-0.812,2.608-3.371,4.237-6.072,3.83c-24.807-3.748-132.04-24.59-162.469-108.066 c-0.553-1.517-0.388-3.2,0.42-4.597c7.495-12.971,46.913-79.923,81.069-113.437c2.771-2.719,7.414-1.747,8.915,1.834 c11.902,28.405,57.839,131.081,112.288,162.628C612.717,524.352,613.347,528.49,610.932,531.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M428.336,487.888c1.437,0.326,2.925-0.464,3.436-1.887 c13.633-37.97,64.328-88.397,64.838-88.902c1.161-1.149,1.172-3.024,0.022-4.186c-1.151-1.158-3.023-1.172-4.186-0.022 c-2.123,2.1-52.158,51.872-66.246,91.111c-0.552,1.537,0.247,3.233,1.786,3.785 C428.102,487.828,428.219,487.862,428.336,487.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M443.598,499.272c1.33,0.302,2.735-0.351,3.335-1.636 c12.508-26.839,58.446-80.701,58.908-81.241c1.063-1.243,0.917-3.111-0.324-4.172c-1.25-1.067-3.113-0.915-4.173,0.324 c-1.91,2.234-46.927,55.016-59.777,82.587c-0.69,1.482-0.048,3.243,1.432,3.934 C443.196,499.158,443.396,499.226,443.598,499.272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M456.664,516.245c1.105,0.251,2.304-0.148,3.025-1.114l20.24-27.032 c0.98-1.308,0.713-3.163-0.595-4.142c-1.306-0.979-3.163-0.715-4.142,0.595l-20.24,27.031c-0.98,1.309-0.714,3.163,0.595,4.142 C455.89,515.984,456.271,516.156,456.664,516.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M472.065,526.583c1.178,0.267,2.449-0.209,3.142-1.283l16.184-25.093 c0.887-1.374,0.491-3.207-0.882-4.092c-1.373-0.891-3.205-0.492-4.091,0.882l-16.185,25.094 c-0.887,1.374-0.491,3.206,0.882,4.092C471.416,526.375,471.737,526.508,472.065,526.583z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057148641847593347220000001271071877235820479_",
    gradientUnits: "userSpaceOnUse",
    x1: 925.9246,
    y1: 358.0843,
    x2: 1110.8905,
    y2: 358.0843,
    gradientTransform: "matrix(0.9936 0.1133 -0.1133 0.9936 49.3654 132.5085)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057148641847593347220000001271071877235820479_)"
    },
    d: "M1112.556,554.763 c-23.733,8.441-94.832,31.264-144.507,21.248c-1.941-0.391-3.91,0.515-4.917,2.219l-39.919,67.581 c-1.783,3.018,0.242,6.856,3.741,7.07c28.454,1.742,129.641,4.763,177.897-35.889c0.781-0.658,1.315-1.562,1.541-2.558 l12.304-54.208C1119.515,556.618,1116.042,553.523,1112.556,554.763z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M944.329,643.74c1.254,0.285,2.596-0.278,3.246-1.461l30.497-55.417 c0.789-1.432,0.267-3.232-1.165-4.02c-1.431-0.793-3.232-0.265-4.02,1.165l-30.497,55.417 c-0.789,1.432-0.267,3.232,1.165,4.019C943.805,643.583,944.065,643.68,944.329,643.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M963.588,645.914c1.319,0.299,2.716-0.339,3.324-1.612l27.197-56.965 c0.704-1.475,0.079-3.241-1.397-3.946c-1.475-0.698-3.242-0.081-3.946,1.397l-27.198,56.965 c-0.704,1.475-0.079,3.241,1.397,3.946C963.169,645.795,963.377,645.866,963.588,645.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M995.245,616.256c1.298,0.296,2.678-0.32,3.299-1.563c4.729-9.46,12.718-25.744,13.097-28.525 c0.221-1.618-0.896-3.083-2.534-3.331c-1.597-0.217-3.069,0.882-3.322,2.465c-0.486,2.018-6.743,15.155-12.536,26.744 c-0.731,1.463-0.138,3.24,1.323,3.971C994.792,616.125,995.016,616.205,995.245,616.256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1066.315,627.606c1.556,0.353,3.121-0.594,3.52-2.15 c13.178-51.314,12.321-53.856,11.997-54.813c-0.523-1.549-2.201-2.381-3.75-1.857c-1.407,0.473-2.222,1.902-1.968,3.322 c-0.049,3.507-6.192,29.21-12.012,51.875c-0.407,1.583,0.547,3.196,2.13,3.603 C1066.26,627.594,1066.288,627.6,1066.315,627.606z M1076.223,572.533c0.001,0.002,0.001,0.002,0.002,0.003 C1076.224,572.535,1076.224,572.535,1076.223,572.533z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137127458217265222370000014652898995265336762_",
    gradientUnits: "userSpaceOnUse",
    x1: 898.1506,
    y1: 301.6659,
    x2: 983.6332,
    y2: 202.4452,
    gradientTransform: "matrix(0.994 0.1094 -0.1094 0.994 56.38 103.7446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000137127458217265222370000014652898995265336762_)"
    },
    cx: 1013.899,
    cy: 410.781,
    r: 63.731
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094610477211151451600000008499011549843980220_",
    gradientUnits: "userSpaceOnUse",
    x1: 1031.9364,
    y1: 130.0771,
    x2: 779.1621,
    y2: 511.947,
    gradientTransform: "matrix(0.994 0.1094 -0.1094 0.994 56.38 103.7446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000094610477211151451600000008499011549843980220_)"
    },
    cx: 1013.899,
    cy: 410.781,
    r: 61.611
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M966.199,382.37c-0.484,0-0.974-0.136-1.41-0.419 c-1.198-0.78-1.537-2.383-0.757-3.581c12.328-18.935,33.925-29.163,56.375-26.693c3.581,0.394,7.132,1.112,10.554,2.133 c1.37,0.409,2.149,1.85,1.74,3.22c-0.409,1.37-1.854,2.147-3.22,1.74c-3.125-0.933-6.369-1.588-9.641-1.948 c-20.487-2.252-40.214,7.083-51.47,24.373C967.874,381.956,967.045,382.37,966.199,382.37z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9641 -0.2656 0.2656 0.9641 -73.0367 284.3998)",
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    cx: 1015.087,
    cy: 412.263,
    rx: 52.147,
    ry: 52.146
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001640928781761320390000007442366207643736731_",
    gradientUnits: "userSpaceOnUse",
    x1: 1024.3965,
    y1: 141.0179,
    x2: 889.7972,
    y2: 366.9879,
    gradientTransform: "matrix(0.994 0.1094 -0.1094 0.994 56.38 103.7446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001640928781761320390000007442366207643736731_)"
    },
    d: "M1005.758,450.236l0.621-5.639 c-5.853-0.883-11.515-2.91-15.445-5.173c-1.404-0.808-1.973-2.546-1.379-4.052l2.011-5.095c0.738-1.869,2.943-2.635,4.7-1.66 c3.908,2.169,8.816,4.084,14.271,4.684c5.662,0.623,10.096-0.831,10.529-4.766c0.391-3.55-2.64-6.021-10.277-8.998 c-10.89-4.307-18.413-10.09-17.325-19.975c0.983-8.926,8.259-15.021,19.784-15.597l0.621-5.64 c0.2-1.815,1.833-3.124,3.648-2.924l3.313,0.365c1.815,0.2,3.124,1.833,2.924,3.647l-0.557,5.064 c5.416,0.817,9.273,2.183,12.294,3.633c1.548,0.743,2.237,2.574,1.609,4.172l-1.852,4.713 c-0.714,1.817-2.829,2.623-4.569,1.736c-2.773-1.412-6.738-3.002-12.055-3.588c-6.718-0.74-8.944,1.832-9.218,4.327 c-0.338,3.071,3.46,5.626,11.897,9.275c12.064,5.116,16.676,10.869,15.651,20.178c-0.94,8.541-8.12,15.522-20.615,16.089 l-0.695,6.311c-0.2,1.815-1.833,3.124-3.648,2.924l-3.314-0.365C1006.867,453.684,1005.558,452.051,1005.758,450.236z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021826882159838111960000012884018457439363252_",
    gradientUnits: "userSpaceOnUse",
    x1: 1006.9045,
    y1: 291.912,
    x2: 1155.715,
    y2: 119.1858,
    gradientTransform: "matrix(0.994 0.1094 -0.1094 0.994 56.38 103.7446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000021826882159838111960000012884018457439363252_)"
    },
    cx: 1195.491,
    cy: 345.511,
    r: 110.944
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171702677880011285590000015040948869479150212_",
    gradientUnits: "userSpaceOnUse",
    x1: 1239.8025,
    y1: -6.7945,
    x2: 799.7661,
    y2: 657.9752,
    gradientTransform: "matrix(0.994 0.1094 -0.1094 0.994 56.38 103.7446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000171702677880011285590000015040948869479150212_)"
    },
    cx: 1195.491,
    cy: 345.511,
    r: 107.255
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M1112.455,294.135c-0.484,0-0.974-0.136-1.41-0.419 c-1.198-0.78-1.537-2.383-0.757-3.581c21.064-32.354,57.969-49.829,96.321-45.609c6.118,0.673,12.186,1.899,18.035,3.644 c1.37,0.409,2.149,1.85,1.74,3.22c-0.409,1.369-1.851,2.148-3.22,1.74c-5.552-1.656-11.313-2.819-17.122-3.459 c-36.4-4.006-71.425,12.58-91.417,43.288C1114.13,293.72,1113.301,294.135,1112.455,294.135z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.243 -0.97 0.97 0.243 568.9404 1425.1935)",
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    cx: 1197.558,
    cy: 348.09,
    rx: 90.778,
    ry: 90.778
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094603883936687466230000003443322817694528643_",
    gradientUnits: "userSpaceOnUse",
    x1: 1226.6769,
    y1: 12.2513,
    x2: 992.3622,
    y2: 405.6268,
    gradientTransform: "matrix(0.994 0.1094 -0.1094 0.994 56.38 103.7446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094603883936687466230000003443322817694528643_)"
    },
    d: "M1181.318,414.195l1.081-9.817 c-10.189-1.536-20.045-5.066-26.888-9.005c-2.444-1.406-3.435-4.431-2.4-7.054l3.501-8.869 c1.284-3.254,5.123-4.587,8.182-2.89c6.802,3.775,15.348,7.109,24.843,8.155c9.857,1.085,17.576-1.447,18.33-8.297 c0.681-6.181-4.595-10.482-17.89-15.665c-18.958-7.498-32.054-17.564-30.159-34.772c1.711-15.538,14.378-26.149,34.44-27.152 l1.081-9.818c0.348-3.159,3.191-5.438,6.35-5.09l5.768,0.635c3.159,0.348,5.438,3.191,5.09,6.35l-0.97,8.815 c9.428,1.422,16.143,3.8,21.401,6.324c2.694,1.293,3.893,4.481,2.8,7.263l-3.225,8.204c-1.243,3.164-4.925,4.566-7.954,3.023 c-4.827-2.459-11.729-5.226-20.986-6.245c-11.695-1.288-15.569,3.189-16.047,7.533c-0.589,5.346,6.023,9.794,20.711,16.146 c21.002,8.907,29.03,18.921,27.245,35.127c-1.637,14.869-14.135,27.02-35.887,28.008l-1.21,10.986 c-0.348,3.159-3.19,5.438-6.35,5.09l-5.768-0.635C1183.249,420.197,1180.97,417.354,1181.318,414.195z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025423542163079472950000005172559492870636445_",
    gradientUnits: "userSpaceOnUse",
    x1: 1087.0599,
    y1: 553.9958,
    x2: 1240.1841,
    y2: 376.2628,
    gradientTransform: "matrix(0.994 0.1094 -0.1094 0.994 56.38 103.7446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000025423542163079472950000005172559492870636445_)"
    },
    cx: 1251.427,
    cy: 610.196,
    r: 114.16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047770809588729197800000003399058403859932084_",
    gradientUnits: "userSpaceOnUse",
    x1: 1326.7091,
    y1: 246.6306,
    x2: 873.9172,
    y2: 930.67,
    gradientTransform: "matrix(0.994 0.1094 -0.1094 0.994 56.38 103.7446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000047770809588729197800000003399058403859932084_)"
    },
    cx: 1251.427,
    cy: 610.196,
    r: 110.364
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M1165.983,557.255c-0.484,0-0.974-0.136-1.41-0.419 c-1.198-0.78-1.537-2.383-0.757-3.581c21.659-33.268,59.608-51.237,99.043-46.897c6.293,0.693,12.532,1.954,18.544,3.748 c1.37,0.409,2.149,1.85,1.74,3.22c-0.409,1.369-1.854,2.147-3.22,1.74c-5.715-1.705-11.647-2.904-17.631-3.563 c-37.477-4.126-73.552,12.955-94.139,44.577C1167.658,556.841,1166.829,557.255,1165.983,557.255z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3209 -0.9471 0.9471 0.3209 270.9015 1603.4934)",
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    cx: 1253.554,
    cy: 612.849,
    rx: 93.41,
    ry: 93.41
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098200491279684380520000002368824252342647938_",
    gradientUnits: "userSpaceOnUse",
    x1: 1313.2029,
    y1: 266.2285,
    x2: 1072.0961,
    y2: 671.007,
    gradientTransform: "matrix(0.994 0.1094 -0.1094 0.994 56.38 103.7446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098200491279684380520000002368824252342647938_)"
    },
    d: "M1236.843,680.871l1.112-10.102 c-10.484-1.581-20.626-5.213-27.667-9.266c-2.514-1.447-3.534-4.56-2.469-7.259l3.602-9.127 c1.321-3.348,5.272-4.72,8.419-2.974c7,3.884,15.793,7.316,25.563,8.392c10.143,1.117,18.085-1.489,18.861-8.538 c0.7-6.36-4.728-10.785-18.408-16.119c-19.508-7.716-32.983-18.073-31.034-35.78c1.76-15.988,14.795-26.907,35.439-27.939 l1.112-10.103c0.358-3.25,3.283-5.596,6.534-5.238l5.935,0.654c3.251,0.358,5.596,3.283,5.238,6.534l-0.999,9.07 c9.701,1.463,16.611,3.91,22.022,6.508c2.772,1.331,4.006,4.611,2.881,7.473l-3.318,8.442 c-1.279,3.255-5.068,4.699-8.185,3.111c-4.967-2.53-12.069-5.378-21.594-6.426c-12.034-1.325-16.02,3.282-16.512,7.751 c-0.606,5.501,6.198,10.078,21.312,16.614c21.61,9.165,29.871,19.47,28.035,36.145c-1.684,15.3-14.544,27.804-36.927,28.82 l-1.245,11.305c-0.358,3.251-3.283,5.596-6.534,5.238l-5.936-0.654C1238.83,687.047,1236.485,684.121,1236.843,680.871z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064324020061384203560000012829847280567080086_",
    gradientUnits: "userSpaceOnUse",
    x1: 1275.2755,
    y1: 350.0244,
    x2: 1387.4684,
    y2: 219.8007,
    gradientTransform: "matrix(0.994 0.1094 -0.1094 0.994 56.38 103.7446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000064324020061384203560000012829847280567080086_)"
    },
    cx: 1414.018,
    cy: 471.649,
    r: 83.644
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080909218337547596690000013367705949596950941_",
    gradientUnits: "userSpaceOnUse",
    x1: 1450.8646,
    y1: 124.8203,
    x2: 1119.1074,
    y2: 626.0107,
    gradientTransform: "matrix(0.994 0.1094 -0.1094 0.994 56.38 103.7446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000080909218337547596690000013367705949596950941_)"
    },
    cx: 1414.018,
    cy: 471.649,
    r: 80.863
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M1351.413,433.551c-0.484,0-0.974-0.136-1.41-0.419 c-1.198-0.78-1.537-2.383-0.757-3.581c16.014-24.596,44.076-37.878,73.223-34.671c4.652,0.512,9.265,1.444,13.709,2.77 c1.37,0.409,2.149,1.85,1.74,3.22c-0.409,1.37-1.851,2.148-3.22,1.74c-4.147-1.237-8.453-2.107-12.796-2.585 c-27.198-2.99-53.377,9.401-68.319,32.351C1353.089,433.137,1352.26,433.551,1351.413,433.551z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 79.7318 1139.6757)",
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    cx: 1415.576,
    cy: 473.593,
    rx: 68.44,
    ry: 68.44
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024698950500949862580000007434911538272442505_",
    gradientUnits: "userSpaceOnUse",
    x1: 1440.9688,
    y1: 139.1794,
    x2: 1264.3115,
    y2: 435.7577,
    gradientTransform: "matrix(0.994 0.1094 -0.1094 0.994 56.38 103.7446)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024698950500949862580000007434911538272442505_)"
    },
    d: "M1403.332,523.432l0.815-7.401 c-7.682-1.158-15.113-3.819-20.272-6.789c-1.842-1.06-2.589-3.341-1.809-5.318l2.639-6.687 c0.968-2.453,3.863-3.458,6.169-2.179c5.129,2.846,11.571,5.36,18.73,6.148c7.431,0.818,13.251-1.091,13.819-6.256 c0.513-4.66-3.464-7.902-13.488-11.81c-14.293-5.653-24.166-13.242-22.738-26.216c1.29-11.715,10.84-19.714,25.966-20.47 l0.815-7.402c0.262-2.382,2.405-4.1,4.787-3.838l4.348,0.479c2.382,0.262,4.1,2.406,3.838,4.788l-0.732,6.646 c7.108,1.072,12.17,2.865,16.135,4.768c2.031,0.975,2.935,3.379,2.111,5.475l-2.431,6.186 c-0.937,2.385-3.713,3.443-5.997,2.279c-3.639-1.854-8.843-3.94-15.822-4.708c-8.817-0.971-11.738,2.404-12.099,5.679 c-0.444,4.03,4.541,7.384,15.615,12.173c15.833,6.715,21.886,14.265,20.541,26.483c-1.234,11.21-10.656,20.372-27.056,21.116 l-0.912,8.283c-0.262,2.381-2.405,4.1-4.787,3.838l-4.349-0.479C1404.788,527.957,1403.07,525.813,1403.332,523.432z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107578647983322316280000004100157329038439583_",
    gradientUnits: "userSpaceOnUse",
    x1: 814.8781,
    y1: 430.1736,
    x2: 819.6152,
    y2: 430.1736
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107578647983322316280000004100157329038439583_)"
    },
    d: "M818.658,431.681l-3.423-1.832 c-0.327-0.172-0.452-0.576-0.28-0.903c0.172-0.327,0.576-0.452,0.903-0.28l0.01,0.006l3.411,1.873 c0.314,0.172,0.428,0.566,0.256,0.879C819.364,431.736,818.97,431.848,818.658,431.681z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092441166560773850700000015615072199739776403_",
    gradientUnits: "userSpaceOnUse",
    x1: 803.3241,
    y1: 424.1319,
    x2: 808.2428,
    y2: 424.1319
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092441166560773850700000015615072199739776403_)"
    },
    d: "M807.198,425.667l-3.464-1.751 l-0.005-0.002c-0.364-0.184-0.509-0.628-0.326-0.991c0.184-0.363,0.627-0.509,0.991-0.326l0.007,0.004l3.455,1.793 c0.351,0.182,0.488,0.615,0.306,0.966c-0.181,0.349-0.609,0.487-0.959,0.31L807.198,425.667z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055685642515423494020000012312455452415784368_",
    gradientUnits: "userSpaceOnUse",
    x1: 791.631,
    y1: 418.3625,
    x2: 796.73,
    y2: 418.3625
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055685642515423494020000012312455452415784368_)"
    },
    d: "M795.601,419.926l-3.504-1.668 l-0.005-0.003c-0.402-0.192-0.573-0.673-0.382-1.075c0.192-0.402,0.673-0.573,1.075-0.382l0.008,0.004l3.497,1.71 c0.39,0.191,0.552,0.661,0.361,1.051c-0.189,0.387-0.655,0.549-1.043,0.365L795.601,419.926z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160160406771454032540000013544597652516343991_",
    gradientUnits: "userSpaceOnUse",
    x1: 779.804,
    y1: 412.8727,
    x2: 785.0817,
    y2: 412.8727
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160160406771454032540000013544597652516343991_)"
    },
    d: "M783.872,414.465l-3.543-1.582 l-0.006-0.002c-0.442-0.197-0.64-0.716-0.443-1.157c0.197-0.442,0.715-0.64,1.157-0.443l0.009,0.004l3.537,1.625 c0.429,0.197,0.617,0.705,0.42,1.134c-0.196,0.426-0.698,0.615-1.125,0.424L783.872,414.465z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052822573900696456000000009197638211519020723_",
    gradientUnits: "userSpaceOnUse",
    x1: 767.8482,
    y1: 407.6692,
    x2: 773.3031,
    y2: 407.6692
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052822573900696456000000009197638211519020723_)"
    },
    d: "M772.016,409.29l-3.58-1.495 l-0.006-0.003c-0.482-0.201-0.709-0.755-0.508-1.237c0.201-0.482,0.755-0.709,1.237-0.508l0.009,0.004l3.577,1.539 c0.469,0.202,0.685,0.746,0.484,1.215c-0.2,0.465-0.738,0.682-1.205,0.488L772.016,409.29z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111155022406050367170000001361791281612193462_",
    gradientUnits: "userSpaceOnUse",
    x1: 755.7859,
    y1: 402.7616,
    x2: 761.3909,
    y2: 402.7616
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111155022406050367170000001361791281612193462_)"
    },
    d: "M760.042,404.399l-3.613-1.411 l-0.007-0.003c-0.514-0.201-0.768-0.78-0.567-1.294c0.201-0.514,0.78-0.768,1.294-0.567l0.007,0.003l3.616,1.446 c0.504,0.202,0.75,0.774,0.548,1.278c-0.201,0.502-0.768,0.747-1.271,0.551L760.042,404.399z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118376202486798151980000007549358227996946064_",
    gradientUnits: "userSpaceOnUse",
    x1: 743.6076,
    y1: 398.1505,
    x2: 749.351,
    y2: 398.1505
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118376202486798151980000007549358227996946064_)"
    },
    d: "M747.956,399.799l-3.647-1.32 l-0.007-0.003c-0.546-0.198-0.828-0.8-0.63-1.346c0.198-0.546,0.8-0.828,1.346-0.63l0.008,0.003l3.651,1.355 c0.536,0.199,0.809,0.795,0.611,1.331c-0.198,0.533-0.789,0.807-1.323,0.614L747.956,399.799z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121260170220780351170000009667124528666211763_",
    gradientUnits: "userSpaceOnUse",
    x1: 731.318,
    y1: 393.8458,
    x2: 737.1978,
    y2: 393.8458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121260170220780351170000009667124528666211763_)"
    },
    d: "M735.759,395.505l-3.679-1.227 l-0.008-0.003c-0.577-0.193-0.889-0.817-0.697-1.395c0.193-0.578,0.817-0.89,1.395-0.697l0.008,0.003l3.685,1.262 c0.568,0.194,0.871,0.813,0.676,1.38c-0.193,0.565-0.806,0.868-1.372,0.679L735.759,395.505z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162344955314773931790000014733471268305333644_",
    gradientUnits: "userSpaceOnUse",
    x1: 718.9235,
    y1: 389.8547,
    x2: 724.9378,
    y2: 389.8547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162344955314773931790000014733471268305333644_)"
    },
    d: "M723.458,391.525l-3.709-1.132 l-0.009-0.003c-0.609-0.186-0.953-0.831-0.767-1.44c0.186-0.61,0.831-0.953,1.44-0.767l0.009,0.003l3.717,1.167 c0.6,0.188,0.934,0.827,0.745,1.427c-0.187,0.597-0.821,0.93-1.418,0.748L723.458,391.525z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006690618407108420990000012468164459243420810_",
    gradientUnits: "userSpaceOnUse",
    x1: 706.4309,
    y1: 386.1844,
    x2: 712.5777,
    y2: 386.1844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006690618407108420990000012468164459243420810_)"
    },
    d: "M711.061,387.864l-3.737-1.035 l-0.009-0.003c-0.642-0.177-1.018-0.842-0.84-1.483c0.178-0.642,0.842-1.018,1.484-0.84l0.009,0.002l3.746,1.07 c0.632,0.18,0.998,0.839,0.818,1.471c-0.18,0.629-0.832,0.994-1.461,0.82L711.061,387.864z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137103231310910184390000009609083790678785422_",
    gradientUnits: "userSpaceOnUse",
    x1: 693.8473,
    y1: 382.8423,
    x2: 700.1244,
    y2: 382.8423
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137103231310910184390000009609083790678785422_)"
    },
    d: "M698.573,384.53l-3.762-0.935 l-0.01-0.003c-0.674-0.168-1.084-0.849-0.917-1.523c0.167-0.674,0.849-1.084,1.523-0.917l0.01,0.002l3.774,0.97 c0.664,0.171,1.064,0.848,0.893,1.512c-0.17,0.661-0.841,1.06-1.501,0.896L698.573,384.53z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137825068711645745720000003938222864465398401_",
    gradientUnits: "userSpaceOnUse",
    x1: 681.1801,
    y1: 379.8359,
    x2: 687.5853,
    y2: 379.8359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137825068711645745720000003938222864465398401_)"
    },
    d: "M686.003,381.531l-3.785-0.833 l-0.01-0.002c-0.706-0.156-1.152-0.854-0.997-1.56c0.155-0.706,0.854-1.152,1.56-0.997l0.01,0.003l3.799,0.868 c0.696,0.159,1.132,0.853,0.973,1.549c-0.158,0.693-0.846,1.127-1.538,0.975L686.003,381.531z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067218031601836843340000012242326358470456739_",
    gradientUnits: "userSpaceOnUse",
    x1: 668.4371,
    y1: 377.1733,
    x2: 674.968,
    y2: 377.1733
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067218031601836843340000012242326358470456739_)"
    },
    d: "M673.359,378.874l-3.806-0.729 l-0.011-0.002c-0.738-0.141-1.221-0.854-1.08-1.592c0.141-0.738,0.854-1.221,1.592-1.08l0.011,0.002l3.822,0.764 c0.728,0.146,1.201,0.854,1.055,1.582c-0.145,0.725-0.847,1.196-1.571,1.058L673.359,378.874z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002353218396359353330000005541590481540198797_",
    gradientUnits: "userSpaceOnUse",
    x1: 655.6269,
    y1: 374.8624,
    x2: 662.2808,
    y2: 374.8624
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002353218396359353330000005541590481540198797_)"
    },
    d: "M660.648,376.567l-3.824-0.622 l-0.012-0.002c-0.77-0.125-1.292-0.851-1.167-1.62c0.125-0.77,0.851-1.292,1.62-1.167l0.011,0.002l3.843,0.657 c0.76,0.13,1.271,0.852,1.141,1.612c-0.129,0.756-0.844,1.266-1.6,1.143L660.648,376.567z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067209666084744716370000001062994981270317959_",
    gradientUnits: "userSpaceOnUse",
    x1: 642.7579,
    y1: 372.9116,
    x2: 649.5323,
    y2: 372.9116
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067209666084744716370000001062994981270317959_)"
    },
    d: "M647.88,374.619l-3.84-0.513 l-0.013-0.002c-0.801-0.107-1.364-0.844-1.257-1.645c0.107-0.801,0.844-1.364,1.645-1.257l0.011,0.001l3.86,0.547 c0.792,0.112,1.343,0.845,1.23,1.637c-0.112,0.788-0.838,1.337-1.625,1.232L647.88,374.619z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032636043129733057720000005585184906962545042_",
    gradientUnits: "userSpaceOnUse",
    x1: 629.84,
    y1: 371.3292,
    x2: 636.7321,
    y2: 371.3292
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032636043129733057720000005585184906962545042_)"
    },
    d: "M635.064,373.037l-3.852-0.402 l-0.013-0.001c-0.832-0.087-1.437-0.832-1.35-1.664c0.087-0.832,0.832-1.437,1.664-1.35l0.012,0.001l3.875,0.435 c0.823,0.092,1.415,0.834,1.323,1.657c-0.092,0.819-0.827,1.409-1.645,1.324L635.064,373.037z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011747174744592090900000011641731640357972903_",
    gradientUnits: "userSpaceOnUse",
    x1: 616.8829,
    y1: 370.1242,
    x2: 623.8895,
    y2: 370.1242
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011747174744592090900000011641731640357972903_)"
    },
    d: "M622.209,371.831l-3.862-0.288 l-0.014-0.001c-0.863-0.065-1.51-0.816-1.446-1.679c0.064-0.863,0.816-1.51,1.679-1.446l0.012,0.001l3.887,0.321 c0.854,0.07,1.489,0.819,1.419,1.673c-0.07,0.849-0.812,1.482-1.66,1.419L622.209,371.831z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127013296145553504350000006900265870668741780_",
    gradientUnits: "userSpaceOnUse",
    x1: 603.8973,
    y1: 369.3055,
    x2: 611.0152,
    y2: 369.3055
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127013296145553504350000006900265870668741780_)"
    },
    d: "M609.327,371.008l-3.868-0.171l-0.015,0 c-0.893-0.039-1.585-0.795-1.545-1.688c0.039-0.893,0.795-1.585,1.688-1.545l0.013,0l3.896,0.203 c0.884,0.046,1.563,0.8,1.517,1.684c-0.046,0.879-0.792,1.556-1.67,1.518L609.327,371.008z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047048537493563362280000012709445551152984745_",
    gradientUnits: "userSpaceOnUse",
    x1: 590.913,
    y1: 368.8854,
    x2: 598.1134,
    y2: 368.8854
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047048537493563362280000012709445551152984745_)"
    },
    d: "M596.429,370.568l-3.871-0.057l-0.015,0 c-0.914-0.013-1.643-0.765-1.63-1.678c0.013-0.914,0.765-1.643,1.678-1.63l0.008,0l3.901,0.076 c0.908,0.018,1.63,0.768,1.612,1.677c-0.018,0.908-0.768,1.63-1.677,1.612L596.429,370.568z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047048704525814133170000001692117780919869851_",
    gradientUnits: "userSpaceOnUse",
    x1: 577.926,
    y1: 368.8768,
    x2: 585.1901,
    y2: 368.8768
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047048704525814133170000001692117780919869851_)"
    },
    d: "M583.526,370.52l-3.87,0.065l-0.016,0 c-0.931,0.016-1.698-0.726-1.714-1.657c-0.016-0.931,0.726-1.698,1.657-1.714l0.008,0l3.902-0.047 c0.926-0.011,1.685,0.73,1.696,1.656c0.011,0.926-0.73,1.685-1.656,1.696L583.526,370.52z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119811224209266058180000010179572779081009067_",
    gradientUnits: "userSpaceOnUse",
    x1: 564.9469,
    y1: 369.2732,
    x2: 572.271,
    y2: 369.2732
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119811224209266058180000010179572779081009067_)"
    },
    d: "M570.63,370.884l-3.865,0.191 l-0.017,0.001c-0.947,0.047-1.753-0.683-1.8-1.631c-0.047-0.947,0.683-1.753,1.631-1.8l0.008-0.001l3.899-0.173 c0.942-0.042,1.74,0.688,1.782,1.63c0.042,0.942-0.688,1.74-1.63,1.782L570.63,370.884z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131336245796557889110000015461651568974378667_",
    gradientUnits: "userSpaceOnUse",
    x1: 551.9904,
    y1: 370.0939,
    x2: 559.3699,
    y2: 370.0939
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131336245796557889110000015461651568974378667_)"
    },
    d: "M557.756,371.668l-3.856,0.319 l-0.018,0.001c-0.963,0.08-1.807-0.636-1.887-1.599c-0.08-0.962,0.636-1.807,1.599-1.887l0.008-0.001l3.892-0.303 c0.958-0.075,1.794,0.642,1.869,1.599c0.075,0.958-0.641,1.795-1.599,1.869L557.756,371.668z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038395322237862168120000016472048476180445871_",
    gradientUnits: "userSpaceOnUse",
    x1: 539.071,
    y1: 371.3488,
    x2: 546.5018,
    y2: 371.3488
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038395322237862168120000016472048476180445871_)"
    },
    d: "M544.919,372.883l-3.842,0.45 l-0.018,0.002c-0.977,0.115-1.861-0.585-1.975-1.561c-0.114-0.977,0.585-1.861,1.561-1.975l0.009-0.001l3.88-0.435 c0.972-0.109,1.848,0.591,1.957,1.563c0.109,0.972-0.59,1.848-1.562,1.957L544.919,372.883z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011709854096962337160000017387135285570695342_",
    gradientUnits: "userSpaceOnUse",
    x1: 526.2056,
    y1: 373.0479,
    x2: 533.6824,
    y2: 373.0479
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011709854096962337160000017387135285570695342_)"
    },
    d: "M532.133,374.538l-3.823,0.583 l-0.019,0.003c-0.989,0.151-1.914-0.528-2.065-1.518c-0.151-0.989,0.528-1.914,1.518-2.065l0.009-0.001l3.864-0.571 c0.985-0.146,1.901,0.535,2.046,1.52c0.145,0.985-0.535,1.901-1.52,2.046L532.133,374.538z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098931112082329414470000003026782885632356522_",
    gradientUnits: "userSpaceOnUse",
    x1: 513.4111,
    y1: 375.2005,
    x2: 520.9288,
    y2: 375.2005
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098931112082329414470000003026782885632356522_)"
    },
    d: "M519.417,376.642l-3.798,0.72 l-0.02,0.004c-1,0.19-1.965-0.467-2.155-1.468c-0.19-1,0.467-1.965,1.468-2.154l0.009-0.002l3.841-0.709 c0.996-0.184,1.953,0.475,2.136,1.47c0.184,0.996-0.475,1.952-1.471,2.137L519.417,376.642z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031914597731102407030000001646655443870267811_",
    gradientUnits: "userSpaceOnUse",
    x1: 500.7066,
    y1: 377.8164,
    x2: 508.2591,
    y2: 377.8164
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031914597731102407030000001646655443870267811_)"
    },
    d: "M506.788,379.205l-3.768,0.86 l-0.021,0.005c-1.009,0.23-2.015-0.401-2.245-1.411c-0.23-1.01,0.401-2.015,1.411-2.245l0.009-0.002l3.814-0.85 c1.005-0.224,2.003,0.409,2.227,1.415c0.224,1.006-0.409,2.003-1.415,2.227L506.788,379.205z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119813325504850091990000001192589279751567238_",
    gradientUnits: "userSpaceOnUse",
    x1: 488.1122,
    y1: 380.9047,
    x2: 495.6934,
    y2: 380.9047
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119813325504850091990000001192589279751567238_)"
    },
    d: "M494.267,382.236l-3.732,1.002 l-0.021,0.006c-1.017,0.273-2.063-0.33-2.335-1.347c-0.273-1.017,0.33-2.063,1.347-2.336l0.009-0.002l3.779-0.994 c1.013-0.267,2.051,0.338,2.317,1.352c0.267,1.013-0.339,2.051-1.352,2.317L494.267,382.236z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062158573529679621900000015964269782115011717_",
    gradientUnits: "userSpaceOnUse",
    x1: 475.649,
    y1: 384.4739,
    x2: 483.2524,
    y2: 384.4739
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062158573529679621900000015964269782115011717_)"
    },
    d: "M481.874,385.742l-3.689,1.146 l-0.022,0.007c-1.022,0.317-2.108-0.254-2.426-1.276c-0.317-1.022,0.254-2.108,1.276-2.426l0.009-0.003l3.739-1.141 c1.019-0.311,2.097,0.263,2.408,1.281c0.311,1.019-0.263,2.096-1.281,2.408L481.874,385.742z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026129708911327699710000017360866433838328718_",
    gradientUnits: "userSpaceOnUse",
    x1: 463.3405,
    y1: 388.532,
    x2: 470.9588,
    y2: 388.532
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026129708911327699710000017360866433838328718_)"
    },
    d: "M469.632,389.733l-3.639,1.292 l-0.023,0.008c-1.025,0.364-2.151-0.172-2.515-1.197c-0.364-1.025,0.172-2.151,1.197-2.515l0.009-0.003l3.691-1.29 c1.022-0.357,2.14,0.181,2.497,1.203c0.357,1.022-0.181,2.14-1.203,2.497L469.632,389.733z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121959772499197538400000004219985174653207171_",
    gradientUnits: "userSpaceOnUse",
    x1: 451.2105,
    y1: 393.0856,
    x2: 458.8363,
    y2: 393.0856
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121959772499197538400000004219985174653207171_)"
    },
    d: "M457.564,394.213l-3.582,1.44 l-0.023,0.009c-1.025,0.412-2.191-0.085-2.603-1.11c-0.412-1.025,0.085-2.191,1.11-2.603l0.009-0.004l3.636-1.441 c1.022-0.405,2.18,0.095,2.585,1.117c0.405,1.022-0.095,2.18-1.117,2.586L457.564,394.213z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183235765597715770460000006505174112099351707_",
    gradientUnits: "userSpaceOnUse",
    x1: 439.2851,
    y1: 398.1406,
    x2: 446.9103,
    y2: 398.1406
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183235765597715770460000006505174112099351707_)"
    },
    d: "M445.696,399.189l-3.517,1.59 l-0.024,0.011c-1.023,0.462-2.227,0.008-2.689-1.015c-0.462-1.023-0.008-2.227,1.015-2.689l0.009-0.004l3.573-1.594 c1.02-0.455,2.216,0.003,2.672,1.023c0.455,1.02-0.003,2.217-1.023,2.672L445.696,399.189z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027583331759240986210000008408964522322191512_",
    gradientUnits: "userSpaceOnUse",
    x1: 427.5909,
    y1: 403.7008,
    x2: 435.2073,
    y2: 403.7008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027583331759240986210000008408964522322191512_)"
    },
    d: "M434.055,404.664l-3.444,1.74 l-0.024,0.012c-1.017,0.514-2.259,0.106-2.773-0.911c-0.514-1.018-0.106-2.259,0.911-2.773l0.009-0.004l3.501-1.748 c1.015-0.507,2.249-0.095,2.756,0.921c0.507,1.015,0.095,2.249-0.921,2.756L434.055,404.664z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033349542004087491510000012021961780063125642_",
    gradientUnits: "userSpaceOnUse",
    x1: 416.1563,
    y1: 409.7683,
    x2: 423.7552,
    y2: 409.7683
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033349542004087491510000012021961780063125642_)"
    },
    d: "M422.667,410.641l-3.363,1.891 l-0.025,0.014c-1.009,0.567-2.286,0.209-2.854-0.8c-0.567-1.009-0.209-2.286,0.799-2.854l0.009-0.005l3.421-1.902 c1.007-0.56,2.277-0.197,2.837,0.81c0.56,1.007,0.197,2.277-0.81,2.837L422.667,410.641z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082333333293477324380000005830659966642587046_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.0099,
    y1: 416.3431,
    x2: 412.5822,
    y2: 416.3431
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082333333293477324380000005830659966642587046_)"
    },
    d: "M411.56,417.119l-3.273,2.041 l-0.025,0.016c-0.997,0.622-2.309,0.317-2.93-0.68c-0.622-0.997-0.318-2.309,0.679-2.93l0.009-0.005l3.332-2.056 c0.995-0.614,2.3-0.305,2.914,0.69s0.305,2.3-0.69,2.914L411.56,417.119z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116922294799760876870000010950314357981959304_",
    gradientUnits: "userSpaceOnUse",
    x1: 394.1813,
    y1: 423.4226,
    x2: 401.7183,
    y2: 423.4226
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116922294799760876870000010950314357981959304_)"
    },
    d: "M400.764,424.096l-3.174,2.19 l-0.025,0.017c-0.981,0.677-2.326,0.43-3.003-0.551c-0.677-0.981-0.43-2.326,0.551-3.003l0.009-0.006l3.234-2.208 c0.98-0.669,2.317-0.417,2.987,0.563c0.669,0.98,0.417,2.317-0.563,2.987L400.764,424.096z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144328856942096103070000018253400910833434261_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.6957,
    y1: 431.0045,
    x2: 391.1886,
    y2: 431.0045
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144328856942096103070000018253400910833434261_)"
    },
    d: "M390.305,431.569l-3.066,2.337 l-0.025,0.019c-0.962,0.733-2.336,0.548-3.07-0.415c-0.733-0.962-0.547-2.336,0.415-3.07l0.008-0.006l3.128-2.359 c0.961-0.725,2.329-0.534,3.054,0.428c0.725,0.961,0.534,2.329-0.428,3.054L390.305,431.569z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029022816163332113990000006230925836960649642_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.594,
    y1: 439.0725,
    x2: 381.0319,
    y2: 439.0725
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029022816163332113990000006230925836960649642_)"
    },
    d: "M380.219,439.525l-2.949,2.479 l-0.025,0.021c-0.939,0.789-2.341,0.668-3.13-0.271c-0.79-0.939-0.668-2.341,0.271-3.13l0.008-0.007l3.01-2.506 c0.939-0.782,2.334-0.654,3.115,0.285c0.782,0.939,0.654,2.334-0.285,3.116L380.219,439.525z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127759847687167564520000015157086229614802872_",
    gradientUnits: "userSpaceOnUse",
    x1: 363.8958,
    y1: 447.6198,
    x2: 371.2729,
    y2: 447.6198
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127759847687167564520000015157086229614802872_)"
    },
    d: "M370.53,447.954l-2.826,2.62 l-0.024,0.022c-0.913,0.846-2.338,0.792-3.184-0.121c-0.846-0.913-0.792-2.338,0.12-3.184l0.008-0.008l2.887-2.65 c0.913-0.838,2.332-0.777,3.17,0.135c0.838,0.913,0.777,2.332-0.135,3.17L370.53,447.954z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170959907897154998300000004725101303139687078_",
    gradientUnits: "userSpaceOnUse",
    x1: 354.7758,
    y1: 456.744,
    x2: 362.0269,
    y2: 456.744
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170959907897154998300000004725101303139687078_)"
    },
    d: "M361.385,456.903l-2.64,2.801 l-0.022,0.023c-0.865,0.918-2.311,0.961-3.23,0.096c-0.918-0.865-0.961-2.311-0.096-3.23l0.008-0.008l2.698-2.835 c0.866-0.91,2.306-0.946,3.216-0.08c0.91,0.866,0.946,2.306,0.08,3.216L361.385,456.903z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083774684775963015060000011228224255314481331_",
    gradientUnits: "userSpaceOnUse",
    x1: 346.1212,
    y1: 466.33,
    x2: 353.3021,
    y2: 466.33
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083774684775963015060000011228224255314481331_)"
    },
    d: "M352.719,466.386l-2.529,2.912 l-0.018,0.02c-0.836,0.963-2.294,1.065-3.257,0.229c-0.963-0.836-1.065-2.295-0.229-3.257l0.002-0.003l2.569-2.948 c0.837-0.96,2.293-1.06,3.253-0.224c0.96,0.837,1.06,2.293,0.224,3.253L352.719,466.386z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007416352518560198600000002221103727551905679_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.8585,
    y1: 476.2555,
    x2: 344.9461,
    y2: 476.2555
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007416352518560198600000002221103727551905679_)"
    },
    d: "M344.418,476.204l-2.418,3.005 l-0.016,0.02c-0.803,0.998-2.263,1.156-3.261,0.353c-0.998-0.803-1.156-2.263-0.353-3.261l0.002-0.003l2.455-3.04 c0.804-0.995,2.262-1.151,3.257-0.348c0.995,0.803,1.151,2.262,0.347,3.257L344.418,476.204z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134949647839652788600000012119372497070764699_",
    gradientUnits: "userSpaceOnUse",
    x1: 329.9657,
    y1: 486.4806,
    x2: 336.9618,
    y2: 486.4806
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134949647839652788600000012119372497070764699_)"
    },
    d: "M336.484,486.326l-2.307,3.091 l-0.015,0.02c-0.77,1.031-2.229,1.243-3.26,0.473c-1.031-0.77-1.243-2.229-0.473-3.26l0.002-0.003l2.342-3.127 c0.77-1.028,2.228-1.238,3.257-0.468c1.028,0.77,1.238,2.229,0.468,3.257L336.484,486.326z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167373891077852992790000014205078925081666957_",
    gradientUnits: "userSpaceOnUse",
    x1: 322.4507,
    y1: 496.9875,
    x2: 329.3538,
    y2: 496.9875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167373891077852992790000014205078925081666957_)"
    },
    d: "M328.924,496.728l-2.194,3.174 l-0.015,0.021c-0.735,1.063-2.192,1.329-3.255,0.595c-1.063-0.735-1.329-2.192-0.595-3.256l0.002-0.003l2.228-3.213 c0.735-1.061,2.191-1.324,3.252-0.589c1.061,0.735,1.324,2.191,0.589,3.252L328.924,496.728z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090999987742289967990000012180325419674773686_",
    gradientUnits: "userSpaceOnUse",
    x1: 315.3306,
    y1: 507.7691,
    x2: 322.1324,
    y2: 507.7691
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090999987742289967990000012180325419674773686_)"
    },
    d: "M321.75,507.404l-2.072,3.252 l-0.014,0.023c-0.698,1.095-2.151,1.417-3.245,0.719c-1.095-0.698-1.417-2.151-0.719-3.245l0.002-0.003l2.106-3.293 c0.698-1.092,2.15-1.411,3.242-0.713c1.092,0.698,1.411,2.15,0.713,3.242L321.75,507.404z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044138394261196257280000007489418692551526826_",
    gradientUnits: "userSpaceOnUse",
    x1: 308.6298,
    y1: 518.8127,
    x2: 315.325,
    y2: 518.8127
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044138394261196257280000007489418692551526826_)"
    },
    d: "M314.989,518.336l-1.945,3.33 l-0.014,0.024c-0.658,1.126-2.103,1.506-3.229,0.848c-1.126-0.658-1.506-2.104-0.848-3.229l0.002-0.003l1.978-3.375 c0.659-1.123,2.103-1.5,3.226-0.841c1.123,0.658,1.5,2.103,0.842,3.226L314.989,518.336z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033365492718849687240000000986017947229737652_",
    gradientUnits: "userSpaceOnUse",
    x1: 302.3741,
    y1: 530.118,
    x2: 308.9533,
    y2: 530.118
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033365492718849687240000000986017947229737652_)"
    },
    d: "M308.663,529.525l-1.808,3.405 l-0.014,0.026c-0.614,1.157-2.05,1.596-3.207,0.982c-1.157-0.614-1.596-2.05-0.982-3.206l0.002-0.003l1.842-3.455 c0.615-1.154,2.05-1.591,3.204-0.976c1.154,0.615,1.591,2.05,0.976,3.204L308.663,529.525z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181063145264216184430000017455574623097050798_",
    gradientUnits: "userSpaceOnUse",
    x1: 296.5987,
    y1: 541.675,
    x2: 303.0496,
    y2: 541.675
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181063145264216184430000017455574623097050798_)"
    },
    d: "M302.803,540.962l-1.66,3.475 l-0.013,0.028c-0.567,1.187-1.989,1.689-3.176,1.123c-1.187-0.567-1.69-1.989-1.123-3.176l0.002-0.003l1.692-3.528 c0.568-1.184,1.989-1.684,3.173-1.116c1.185,0.568,1.684,1.989,1.116,3.173L302.803,540.962z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114069401456577856920000009681802640901084333_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.3376,
    y1: 553.4753,
    x2: 297.6511,
    y2: 553.4753
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114069401456577856920000009681802640901084333_)"
    },
    d: "M297.448,552.634l-1.503,3.545 l-0.013,0.03c-0.516,1.216-1.92,1.785-3.136,1.269c-1.216-0.516-1.785-1.92-1.269-3.136l0.002-0.004l1.534-3.603 c0.517-1.214,1.92-1.779,3.134-1.262c1.214,0.517,1.779,1.92,1.262,3.134L297.448,552.634z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078738876768410403410000008406227175940454030_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.6326,
    y1: 565.5056,
    x2: 292.7959,
    y2: 565.5056
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078738876768410403410000008406227175940454030_)"
    },
    d: "M292.635,564.53l-1.333,3.611 l-0.012,0.033c-0.46,1.245-1.841,1.882-3.086,1.422c-1.245-0.459-1.882-1.841-1.422-3.086l0.001-0.004l1.363-3.674 c0.461-1.243,1.842-1.876,3.084-1.415c1.242,0.461,1.876,1.842,1.415,3.084L292.635,564.53z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090296103373525613130000012022096613803727781_",
    gradientUnits: "userSpaceOnUse",
    x1: 282.5235,
    y1: 577.7558,
    x2: 288.5233,
    y2: 577.7558
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090296103373525613130000012022096613803727781_)"
    },
    d: "M288.401,576.639l-1.15,3.672 l-0.011,0.036c-0.399,1.271-1.753,1.979-3.024,1.581c-1.272-0.398-1.98-1.752-1.581-3.024l0.001-0.004l1.178-3.74 c0.4-1.27,1.754-1.974,3.023-1.574c1.269,0.4,1.974,1.753,1.574,3.023L288.401,576.639z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087392998120068470210000015953560171235111335_",
    gradientUnits: "userSpaceOnUse",
    x1: 279.0545,
    y1: 590.2061,
    x2: 284.8771,
    y2: 590.2061
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087392998120068470210000015953560171235111335_)"
    },
    d: "M284.791,588.943l-0.955,3.725 l-0.01,0.038c-0.332,1.297-1.653,2.078-2.949,1.746c-1.296-0.332-2.078-1.653-1.746-2.949l0.001-0.004l0.981-3.8 c0.334-1.294,1.654-2.073,2.948-1.738c1.294,0.334,2.073,1.654,1.739,2.948L284.791,588.943z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103229891281449688850000009396646591364040371_",
    gradientUnits: "userSpaceOnUse",
    x1: 276.2692,
    y1: 602.8311,
    x2: 281.9011,
    y2: 602.8311
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103229891281449688850000009396646591364040371_)"
    },
    d: "M281.846,601.417l-0.747,3.771 l-0.008,0.041c-0.261,1.318-1.542,2.175-2.861,1.914c-1.319-0.261-2.176-1.542-1.914-2.86l0.001-0.004l0.77-3.851 c0.263-1.316,1.544-2.17,2.86-1.907c1.316,0.263,2.17,1.543,1.907,2.86L281.846,601.417z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141433034015275131170000003989867007527700641_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.2099,
    y1: 615.5996,
    x2: 279.6382,
    y2: 615.5996
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141433034015275131170000003989867007527700641_)"
    },
    d: "M279.609,614.03l-0.527,3.806 l-0.006,0.043c-0.185,1.337-1.42,2.271-2.757,2.085c-1.337-0.185-2.271-1.419-2.086-2.757l0-0.004l0.546-3.891 c0.187-1.335,1.421-2.266,2.756-2.078c1.335,0.187,2.266,1.421,2.078,2.756L279.609,614.03z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125568217234823363790000013757030152350235273_",
    gradientUnits: "userSpaceOnUse",
    x1: 272.9143,
    y1: 628.4739,
    x2: 278.1281,
    y2: 628.4739
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125568217234823363790000013757030152350235273_)"
    },
    d: "M278.117,626.747l-0.297,3.829 l-0.004,0.045c-0.105,1.352-1.285,2.362-2.637,2.258c-1.352-0.105-2.362-1.286-2.257-2.637l0-0.004l0.31-3.919 c0.107-1.35,1.288-2.357,2.638-2.25c1.35,0.107,2.357,1.288,2.25,2.637L278.117,626.747z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114044803481853815440000006090172457951224498_",
    gradientUnits: "userSpaceOnUse",
    x1: 272.4143,
    y1: 641.4081,
    x2: 277.4043,
    y2: 641.4081
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114044803481853815440000006090172457951224498_)"
    },
    d: "M277.403,639.527l-0.058,3.835 l-0.001,0.047c-0.021,1.361-1.141,2.448-2.502,2.427c-1.361-0.021-2.448-1.141-2.427-2.502l0-0.004l0.066-3.928 c0.023-1.36,1.144-2.443,2.503-2.42c1.36,0.023,2.443,1.143,2.42,2.503L277.403,639.527z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043431580191568243950000002465210557453735818_",
    gradientUnits: "userSpaceOnUse",
    x1: 272.5484,
    y1: 654.3544,
    x2: 277.6837,
    y2: 654.3544
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043431580191568243950000002465210557453735818_)"
    },
    d: "M277.493,652.317l0.186,3.831 l0.002,0.048c0.066,1.365-0.987,2.526-2.353,2.592c-1.366,0.066-2.526-0.987-2.592-2.353l0-0.004l-0.184-3.927 c-0.064-1.364,0.99-2.521,2.354-2.585c1.364-0.064,2.522,0.99,2.586,2.354L277.493,652.317z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156577368017942804660000002637255973625247626_",
    gradientUnits: "userSpaceOnUse",
    x1: 273.4439,
    y1: 667.2599,
    x2: 278.8532,
    y2: 667.2599
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156577368017942804660000002637255973625247626_)"
    },
    d: "M278.399,665.072l0.432,3.813 l0.005,0.048c0.155,1.364-0.826,2.596-2.19,2.75c-1.364,0.155-2.596-0.826-2.75-2.19l-0.001-0.004l-0.437-3.909 c-0.152-1.362,0.829-2.591,2.192-2.743c1.363-0.152,2.591,0.829,2.743,2.192L278.399,665.072z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114765164342387932260000004901509710797315749_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.1718,
    y1: 680.0755,
    x2: 280.8542,
    y2: 680.0755
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114765164342387932260000004901509710797315749_)"
    },
    d: "M280.128,677.745l0.678,3.778 l0.009,0.047c0.243,1.357-0.659,2.654-2.016,2.898c-1.357,0.244-2.655-0.659-2.898-2.016l-0.001-0.004l-0.689-3.874 c-0.241-1.356,0.663-2.65,2.018-2.891c1.356-0.241,2.65,0.663,2.891,2.018L280.128,677.745z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103239952892651995290000003828507761859505338_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.7245,
    y1: 692.7468,
    x2: 283.6765,
    y2: 692.7468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103239952892651995290000003828507761859505338_)"
    },
    d: "M282.671,690.282l0.92,3.726 l0.012,0.047c0.332,1.344-0.489,2.703-1.833,3.035c-1.344,0.332-2.703-0.489-3.035-1.833l-0.001-0.004l-0.937-3.822 c-0.329-1.343,0.493-2.698,1.836-3.028c1.343-0.329,2.698,0.492,3.028,1.835L282.671,690.282z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073680266144533063330000002839918264897321374_",
    gradientUnits: "userSpaceOnUse",
    x1: 281.0932,
    y1: 705.2196,
    x2: 287.3126,
    y2: 705.2196
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073680266144533063330000002839918264897321374_)"
    },
    d: "M286.019,702.629l1.16,3.658 l0.015,0.047c0.42,1.325-0.313,2.74-1.638,3.16c-1.325,0.42-2.74-0.313-3.16-1.639l-0.001-0.004l-1.184-3.753 c-0.418-1.324,0.317-2.736,1.642-3.154c1.324-0.418,2.736,0.317,3.154,1.641L286.019,702.629z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124847089990642054180000014511920834810915228_",
    gradientUnits: "userSpaceOnUse",
    x1: 285.2677,
    y1: 717.437,
    x2: 291.7491,
    y2: 717.437
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124847089990642054180000014511920834810915228_)"
    },
    d: "M290.163,714.73l1.395,3.575 l0.018,0.046c0.508,1.301-0.135,2.766-1.436,3.274c-1.3,0.508-2.766-0.135-3.274-1.436l-0.001-0.004l-1.425-3.668 c-0.505-1.3,0.139-2.763,1.439-3.267c1.3-0.505,2.762,0.139,3.267,1.439L290.163,714.73z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130637118485417539800000017074562940631683755_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.2275,
    y1: 729.3493,
    x2: 296.9623,
    y2: 729.3493
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130637118485417539800000017074562940631683755_)"
    },
    d: "M295.081,726.536l1.622,3.478 l0.02,0.044c0.593,1.27,0.043,2.781-1.227,3.373c-1.27,0.593-2.78,0.043-3.373-1.227l-0.002-0.004l-1.658-3.569 c-0.59-1.27-0.039-2.777,1.231-3.367c1.27-0.59,2.777-0.039,3.367,1.231L295.081,726.536z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067234233233485977650000003790460005381661576_",
    gradientUnits: "userSpaceOnUse",
    x1: 295.9416,
    y1: 740.913,
    x2: 302.918,
    y2: 740.913
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067234233233485977650000003790460005381661576_)"
    },
    d: "M300.745,738.007l1.839,3.369 l0.023,0.042c0.674,1.235,0.219,2.784-1.016,3.458c-1.236,0.674-2.784,0.219-3.458-1.016l-0.002-0.004l-1.879-3.456 c-0.671-1.235-0.214-2.78,1.021-3.452c1.235-0.671,2.781-0.215,3.452,1.021L300.745,738.007z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054952213902041272050000005629715728500212127_",
    gradientUnits: "userSpaceOnUse",
    x1: 302.3702,
    y1: 752.091,
    x2: 309.5746,
    y2: 752.091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054952213902041272050000005629715728500212127_)"
    },
    d: "M307.115,749.103l2.042,3.252 l0.025,0.039c0.752,1.197,0.391,2.776-0.806,3.528c-1.197,0.752-2.776,0.391-3.528-0.806l-0.002-0.003l-2.086-3.333 c-0.749-1.197-0.386-2.774,0.811-3.523c1.196-0.749,2.773-0.386,3.522,0.811L307.115,749.103z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054983789139440128340000017233892169458829468_",
    gradientUnits: "userSpaceOnUse",
    x1: 309.4673,
    y1: 762.8549,
    x2: 316.8845,
    y2: 762.8549
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054983789139440128340000017233892169458829468_)"
    },
    d: "M314.148,759.798l2.232,3.126 l0.026,0.036c0.824,1.155,0.557,2.76-0.598,3.584c-1.155,0.824-2.76,0.556-3.584-0.598l-0.003-0.004l-2.279-3.203 c-0.822-1.155-0.551-2.757,0.604-3.579c1.155-0.821,2.757-0.551,3.579,0.603L314.148,759.798z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092450600316439283830000008911630938116259996_",
    gradientUnits: "userSpaceOnUse",
    x1: 317.1831,
    y1: 773.1837,
    x2: 324.7975,
    y2: 773.1837
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092450600316439283830000008911630938116259996_)"
    },
    d: "M321.796,770.07l2.406,2.996 l0.027,0.033c0.892,1.111,0.715,2.735-0.396,3.627c-1.111,0.892-2.735,0.715-3.627-0.396l-0.003-0.003l-2.455-3.067 c-0.889-1.111-0.71-2.732,0.401-3.622c1.111-0.889,2.733-0.709,3.622,0.401L321.796,770.07z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164515176482675311020000004871061166249534112_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.4665,
    y1: 783.0641,
    x2: 333.2624,
    y2: 783.0641
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164515176482675311020000004871061166249534112_)"
    },
    d: "M330.008,779.903l2.566,2.863 l0.027,0.031c0.955,1.065,0.865,2.703-0.2,3.658c-1.065,0.955-2.703,0.865-3.658-0.2l-0.003-0.003l-2.616-2.928 c-0.952-1.066-0.86-2.701,0.206-3.653c1.065-0.952,2.701-0.86,3.653,0.206L330.008,779.903z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103976834889847829690000009149616389708753338_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.2667,
    y1: 792.4893,
    x2: 342.229,
    y2: 792.4893
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103976834889847829690000009149616389708753338_)"
    },
    d: "M338.735,789.291l2.711,2.729 l0.027,0.028c1.012,1.019,1.007,2.666-0.012,3.678c-1.019,1.012-2.666,1.007-3.678-0.012l-0.003-0.003l-2.762-2.789 c-1.009-1.019-1.001-2.664,0.018-3.673c1.019-1.009,2.664-1.002,3.673,0.018L338.735,789.291z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162346804212992877130000010533343196398159497_",
    gradientUnits: "userSpaceOnUse",
    x1: 343.5348,
    y1: 801.458,
    x2: 351.6494,
    y2: 801.458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162346804212992877130000010533343196398159497_)"
    },
    d: "M347.929,798.232l2.842,2.595 l0.028,0.025c1.065,0.972,1.14,2.624,0.168,3.689c-0.972,1.065-2.624,1.14-3.689,0.168l-0.003-0.003l-2.893-2.65 c-1.062-0.973-1.135-2.623-0.162-3.685c0.973-1.062,2.623-1.135,3.685-0.162L347.929,798.232z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172434519662855529900000009135903713889104568_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.2327,
    y1: 809.9687,
    x2: 361.4609,
    y2: 809.9687
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172434519662855529900000009135903713889104568_)"
    },
    d: "M357.539,806.734l2.958,2.466 l0.027,0.023c1.106,0.922,1.255,2.565,0.333,3.671c-0.922,1.106-2.564,1.257-3.669,0.335l-3.014-2.508 c-1.107-0.921-1.258-2.566-0.337-3.673c0.921-1.107,2.566-1.258,3.673-0.337l0.002,0.001L357.539,806.734z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029017640765689328480000015081749439882921401_",
    gradientUnits: "userSpaceOnUse",
    x1: 363.3191,
    y1: 818.0353,
    x2: 371.6413,
    y2: 818.0353
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029017640765689328480000015081749439882921401_)"
    },
    d: "M367.525,814.799l3.065,2.335 l0.026,0.02c1.143,0.871,1.363,2.502,0.493,3.645c-0.871,1.142-2.5,1.365-3.643,0.494l-3.12-2.372 c-1.144-0.87-1.366-2.503-0.496-3.647c0.87-1.144,2.503-1.366,3.647-0.497l0.002,0.001L367.525,814.799z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049210663501981678330000003534791586265029030_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.7467,
    y1: 825.6614,
    x2: 382.152,
    y2: 825.6614
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049210663501981678330000003534791586265029030_)"
    },
    d: "M377.855,822.43l3.161,2.206 l0.026,0.018c1.175,0.82,1.463,2.438,0.643,3.613c-0.82,1.175-2.436,1.464-3.611,0.644l-3.215-2.239 c-1.177-0.82-1.466-2.438-0.647-3.615c0.82-1.177,2.438-1.466,3.615-0.646l0.002,0.001L377.855,822.43z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168831110603797644870000010788076202248008848_",
    gradientUnits: "userSpaceOnUse",
    x1: 384.4807,
    y1: 832.8558,
    x2: 392.9594,
    y2: 832.8558
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168831110603797644870000010788076202248008848_)"
    },
    d: "M388.494,829.636l3.247,2.08 l0.025,0.016c1.204,0.771,1.555,2.372,0.784,3.576c-0.771,1.204-2.37,1.556-3.574,0.785l-3.3-2.109 c-1.206-0.771-1.558-2.373-0.788-3.578c0.771-1.205,2.373-1.558,3.578-0.787l0.002,0.001L388.494,829.636z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085217078903788476620000000737482343143418514_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.4899,
    y1: 839.6277,
    x2: 404.0334,
    y2: 839.6277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085217078903788476620000000737482343143418514_)"
    },
    d: "M399.41,836.423l3.325,1.956 l0.025,0.015c1.229,0.723,1.64,2.306,0.917,3.536c-0.723,1.229-2.305,1.641-3.534,0.917l-3.376-1.982 c-1.231-0.723-1.643-2.306-0.92-3.538c0.723-1.231,2.306-1.643,3.538-0.92l0.002,0.001L399.41,836.423z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001636106509787365050000011121411762652599224_",
    gradientUnits: "userSpaceOnUse",
    x1: 406.7466,
    y1: 845.986,
    x2: 415.3472,
    y2: 845.986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001636106509787365050000011121411762652599224_)"
    },
    d: "M410.576,842.801l3.395,1.835 l0.024,0.013c1.252,0.677,1.719,2.24,1.042,3.492c-0.677,1.252-2.238,1.72-3.49,1.043l-3.445-1.858 c-1.254-0.676-1.722-2.24-1.046-3.494c0.676-1.254,2.24-1.722,3.494-1.046l0.002,0.001L410.576,842.801z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090293623227190752670000002887913942891303352_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.2263,
    y1: 851.9388,
    x2: 426.8772,
    y2: 851.9388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090293623227190752670000002887913942891303352_)"
    },
    d: "M421.967,848.778l3.457,1.715 l0.024,0.012c1.272,0.631,1.792,2.174,1.16,3.446c-0.631,1.272-2.172,1.792-3.444,1.161l-3.507-1.736 c-1.273-0.63-1.795-2.173-1.164-3.447c0.63-1.273,2.174-1.795,3.447-1.164l0.002,0.001L421.967,848.778z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135653227271590998930000003548993285433707189_",
    gradientUnits: "userSpaceOnUse",
    x1: 429.9071,
    y1: 857.4933,
    x2: 438.6021,
    y2: 857.4933
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135653227271590998930000003548993285433707189_)"
    },
    d: "M433.561,854.359l3.514,1.598 l0.023,0.011c1.289,0.586,1.86,2.107,1.273,3.397c-0.586,1.29-2.105,1.861-3.395,1.274l-3.563-1.616 c-1.291-0.586-1.863-2.107-1.277-3.398c0.586-1.291,2.107-1.863,3.398-1.277l0.002,0.001L433.561,854.359z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003827004121943518700000002787789964733419395_",
    gradientUnits: "userSpaceOnUse",
    x1: 441.7694,
    y1: 862.655,
    x2: 450.5035,
    y2: 862.655
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003827004121943518700000002787789964733419395_)"
    },
    d: "M445.337,859.55l3.566,1.482l0.023,0.01 c1.305,0.542,1.923,2.04,1.381,3.345c-0.542,1.305-2.038,1.925-3.343,1.382l-3.613-1.498c-1.307-0.542-1.927-2.04-1.385-3.346 c0.542-1.307,2.04-1.927,3.346-1.385l0.002,0.001L445.337,859.55z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031187297214033738830000006665269705126453643_",
    gradientUnits: "userSpaceOnUse",
    x1: 453.7964,
    y1: 867.4277,
    x2: 462.5645,
    y2: 867.4277
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031187297214033738830000006665269705126453643_)"
    },
    d: "M457.279,864.356l3.612,1.366 l0.023,0.009c1.319,0.499,1.984,1.973,1.485,3.292c-0.499,1.319-1.971,1.984-3.289,1.485l-3.659-1.38 c-1.32-0.498-1.987-1.972-1.489-3.292c0.498-1.32,1.972-1.987,3.292-1.489l0.002,0.001L457.279,864.356z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011727316695947994020000018087784620364051333_",
    gradientUnits: "userSpaceOnUse",
    x1: 465.9723,
    y1: 871.8128,
    x2: 474.7706,
    y2: 871.8128
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011727316695947994020000018087784620364051333_)"
    },
    d: "M469.371,868.777l3.654,1.251 l0.023,0.008c1.331,0.456,2.041,1.904,1.585,3.235c-0.456,1.331-1.902,2.042-3.233,1.586l-3.701-1.264 c-1.332-0.454-2.044-1.904-1.589-3.236c0.455-1.332,1.904-2.044,3.236-1.589l0.002,0.001L469.371,868.777z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056402803852194498920000003441166696800766342_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.2835,
    y1: 875.8093,
    x2: 487.1081,
    y2: 875.8093
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056402803852194498920000003441166696800766342_)"
    },
    d: "M481.598,872.812l3.692,1.135 l0.023,0.007c1.342,0.412,2.095,1.834,1.683,3.176c-0.412,1.342-1.832,2.096-3.174,1.683l-3.739-1.146 c-1.343-0.411-2.098-1.834-1.687-3.177c0.411-1.343,1.834-2.098,3.177-1.687l0.002,0.001L481.598,872.812z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110433562340431393240000011787234208701979024_",
    gradientUnits: "userSpaceOnUse",
    x1: 490.7174,
    y1: 879.4128,
    x2: 499.5649,
    y2: 879.4128
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110433562340431393240000011787234208701979024_)"
    },
    d: "M493.947,876.458l3.726,1.017 l0.024,0.007c1.351,0.368,2.147,1.762,1.779,3.113c-0.369,1.351-1.76,2.148-3.111,1.779l-3.774-1.026 c-1.352-0.368-2.15-1.762-1.783-3.114c0.368-1.352,1.762-2.15,3.114-1.783l0.002,0L493.947,876.458z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132060066333892921660000016395800821105914030_",
    gradientUnits: "userSpaceOnUse",
    x1: 503.2621,
    y1: 882.6154,
    x2: 512.1295,
    y2: 882.6154
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132060066333892921660000016395800821105914030_)"
    },
    d: "M506.405,879.707l3.757,0.895 l0.024,0.006c1.359,0.324,2.198,1.688,1.874,3.047c-0.324,1.359-1.686,2.198-3.045,1.875l-3.806-0.903 c-1.36-0.323-2.201-1.687-1.878-3.048c0.323-1.36,1.687-2.201,3.048-1.878l0.002,0L506.405,879.707z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060004197895035399970000008539308625102036107_",
    gradientUnits: "userSpaceOnUse",
    x1: 515.9066,
    y1: 885.4042,
    x2: 524.7906,
    y2: 885.4042
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060004197895035399970000008539308625102036107_)"
    },
    d: "M518.961,882.546l3.784,0.769 l0.025,0.005c1.366,0.278,2.248,1.61,1.97,2.976c-0.278,1.366-1.608,2.248-2.974,1.97l-3.835-0.776 c-1.367-0.277-2.251-1.609-1.974-2.976c0.277-1.367,1.609-2.251,2.976-1.974l0.002,0L518.961,882.546z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156551319382127694170000006367803998036894618_",
    gradientUnits: "userSpaceOnUse",
    x1: 528.6395,
    y1: 887.7603,
    x2: 537.5376,
    y2: 887.7603
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156551319382127694170000006367803998036894618_)"
    },
    d: "M531.602,884.959l3.806,0.637 l0.027,0.005c1.371,0.23,2.297,1.527,2.068,2.898c-0.229,1.372-1.525,2.298-2.896,2.068l-3.86-0.642 c-1.373-0.228-2.3-1.526-2.072-2.899c0.228-1.373,1.526-2.3,2.899-2.072l0.002,0.001L531.602,884.959z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068641279863778466870000015203650641453965713_",
    gradientUnits: "userSpaceOnUse",
    x1: 541.449,
    y1: 889.6571,
    x2: 550.3579,
    y2: 889.6571
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000068641279863778466870000015203650641453965713_)"
    },
    d: "M544.314,886.919l3.825,0.495 l0.029,0.004c1.376,0.178,2.347,1.438,2.169,2.813c-0.178,1.376-1.435,2.347-2.811,2.169l-3.883-0.498 c-1.377-0.177-2.35-1.436-2.173-2.813c0.177-1.377,1.436-2.35,2.813-2.173l0.002,0L544.314,886.919z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058584217810908542480000016547630170156096673_",
    gradientUnits: "userSpaceOnUse",
    x1: 554.3238,
    y1: 891.0598,
    x2: 563.238,
    y2: 891.0598
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058584217810908542480000016547630170156096673_)"
    },
    d: "M557.084,888.392l3.843,0.345 l0.029,0.002c1.378,0.124,2.396,1.341,2.272,2.72c-0.124,1.378-1.339,2.396-2.717,2.272l-3.901-0.346 c-1.38-0.122-2.398-1.34-2.276-2.719c0.122-1.379,1.34-2.398,2.719-2.276l0.002,0L557.084,888.392z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141451596671046944450000013753611941335663232_",
    gradientUnits: "userSpaceOnUse",
    x1: 567.2467,
    y1: 891.9637,
    x2: 576.1596,
    y2: 891.9637
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141451596671046944450000013753611941335663232_)"
    },
    d: "M569.905,889.369l3.853,0.197 l0.029,0.001c1.379,0.07,2.44,1.245,2.369,2.624c-0.07,1.379-1.243,2.44-2.622,2.369l-3.911-0.196 c-1.38-0.069-2.443-1.244-2.373-2.624c0.069-1.38,1.244-2.442,2.624-2.373h0.002L569.905,889.369z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166656062115276143710000013487348415298194342_",
    gradientUnits: "userSpaceOnUse",
    x1: 580.1976,
    y1: 892.3654,
    x2: 589.1034,
    y2: 892.3654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166656062115276143710000013487348415298194342_)"
    },
    d: "M582.753,889.849l3.857,0.046l0.03,0 c1.377,0.016,2.48,1.146,2.464,2.523c-0.016,1.377-1.144,2.481-2.521,2.464l-3.916-0.043c-1.378-0.015-2.483-1.144-2.468-2.523 c0.015-1.378,1.145-2.483,2.523-2.468h0.002L582.753,889.849z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007418658137417117040000008981601844969908152_",
    gradientUnits: "userSpaceOnUse",
    x1: 593.1614,
    y1: 892.2586,
    x2: 602.0541,
    y2: 892.2586
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007418658137417117040000008981601844969908152_)"
    },
    d: "M595.612,889.823l3.855-0.107 l0.03-0.001c1.374-0.038,2.518,1.044,2.556,2.418c0.038,1.374-1.042,2.518-2.416,2.556l-3.915,0.112 c-1.375,0.04-2.521-1.043-2.56-2.417c-0.039-1.375,1.043-2.521,2.417-2.56h0.002L595.612,889.823z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172404485252366084700000000741819371844428688_",
    gradientUnits: "userSpaceOnUse",
    x1: 606.1126,
    y1: 891.6353,
    x2: 614.9859,
    y2: 891.6353
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172404485252366084700000000741819371844428688_)"
    },
    d: "M608.458,889.287l3.848-0.26l0.03-0.002 c1.368-0.092,2.551,0.941,2.644,2.309c0.093,1.368-0.939,2.551-2.307,2.644l-3.907,0.268c-1.369,0.094-2.554-0.939-2.648-2.308 c-0.094-1.369,0.939-2.554,2.308-2.648h0.002L608.458,889.287z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158739985215628661640000010374563054801480844_",
    gradientUnits: "userSpaceOnUse",
    x1: 619.0309,
    y1: 890.4973,
    x2: 627.8785,
    y2: 890.4973
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158739985215628661640000010374563054801480844_)"
    },
    d: "M621.273,888.24l3.835-0.413 l0.029-0.003c1.36-0.147,2.581,0.837,2.727,2.196c0.147,1.36-0.835,2.58-2.194,2.727l-3.893,0.423 c-1.361,0.148-2.583-0.835-2.731-2.195c-0.148-1.361,0.835-2.583,2.195-2.731l0.002,0L621.273,888.24z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112630040353752421810000012327358340958608520_",
    gradientUnits: "userSpaceOnUse",
    x1: 631.8963,
    y1: 888.8488,
    x2: 640.7122,
    y2: 888.8488
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112630040353752421810000012327358340958608520_)"
    },
    d: "M634.036,886.686l3.816-0.565 l0.029-0.004c1.35-0.2,2.605,0.733,2.805,2.082c0.2,1.35-0.73,2.605-2.08,2.805l-3.873,0.576 c-1.35,0.201-2.608-0.731-2.809-2.081c-0.201-1.35,0.731-2.608,2.081-2.809l0.002,0L634.036,886.686z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121245217357493863650000011664041903665402501_",
    gradientUnits: "userSpaceOnUse",
    x1: 644.6895,
    y1: 886.6987,
    x2: 653.4678,
    y2: 886.6987
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121245217357493863650000011664041903665402501_)"
    },
    d: "M646.729,884.631l3.792-0.712 l0.028-0.005c1.338-0.251,2.625,0.629,2.877,1.967c0.251,1.338-0.627,2.625-1.965,2.876l-3.847,0.726 c-1.338,0.253-2.628-0.628-2.881-1.966c-0.253-1.338,0.627-2.628,1.966-2.881l0.002,0L646.729,884.631z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154415346175172878840000014093438361634979976_",
    gradientUnits: "userSpaceOnUse",
    x1: 657.3929,
    y1: 884.0595,
    x2: 666.1285,
    y2: 884.0595
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154415346175172878840000014093438361634979976_)"
    },
    d: "M659.335,882.089l3.762-0.856 l0.027-0.006c1.324-0.301,2.641,0.528,2.942,1.852c0.301,1.324-0.526,2.641-1.85,2.942l-3.815,0.871 c-1.325,0.303-2.644-0.526-2.946-1.851c-0.302-1.324,0.526-2.643,1.851-2.946l0.002,0L659.335,882.089z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128476005959549851280000001310996545004707473_",
    gradientUnits: "userSpaceOnUse",
    x1: 669.9908,
    y1: 880.9479,
    x2: 678.6791,
    y2: 880.9479
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000128476005959549851280000001310996545004707473_)"
    },
    d: "M671.839,879.073l3.729-0.994 l0.026-0.007c1.309-0.349,2.652,0.43,3.001,1.738c0.349,1.309-0.427,2.652-1.736,3.001l-3.78,1.011 c-1.309,0.35-2.655-0.427-3.005-1.737c-0.35-1.309,0.427-2.655,1.737-3.005l0.002-0.001L671.839,879.073z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125582453092501282930000004177291243791418275_",
    gradientUnits: "userSpaceOnUse",
    x1: 682.4695,
    y1: 877.3838,
    x2: 691.1067,
    y2: 877.3838
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125582453092501282930000004177291243791418275_)"
    },
    d: "M684.229,875.605l3.693-1.126 l0.024-0.007c1.292-0.394,2.66,0.334,3.054,1.626c0.394,1.292-0.332,2.659-1.625,3.053l-3.74,1.144 c-1.293,0.396-2.662-0.332-3.057-1.625c-0.396-1.293,0.332-2.662,1.625-3.057l0.002-0.001L684.229,875.605z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129193548459391383430000015683281908172847520_",
    gradientUnits: "userSpaceOnUse",
    x1: 694.8183,
    y1: 873.3893,
    x2: 703.4016,
    y2: 873.3893
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129193548459391383430000015683281908172847520_)"
    },
    d: "M696.493,871.704l3.654-1.251 l0.023-0.008c1.275-0.436,2.663,0.243,3.099,1.519c0.437,1.275-0.241,2.662-1.516,3.099l-3.698,1.27 c-1.276,0.438-2.665-0.241-3.103-1.517c-0.438-1.276,0.241-2.665,1.517-3.103l0.002-0.001L696.493,871.704z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047055832482148514900000000339004313664690110_",
    gradientUnits: "userSpaceOnUse",
    x1: 707.029,
    y1: 868.9893,
    x2: 715.5565,
    y2: 868.9893
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047055832482148514900000000339004313664690110_)"
    },
    d: "M708.625,867.395l3.612-1.369 l0.021-0.008c1.257-0.476,2.663,0.157,3.139,1.414c0.476,1.257-0.155,2.662-1.412,3.139l-3.654,1.388 c-1.258,0.478-2.665-0.154-3.143-1.412c-0.478-1.258,0.155-2.665,1.412-3.143l0.002-0.001L708.625,867.395z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101818174174968329000000012229590534119332522_",
    gradientUnits: "userSpaceOnUse",
    x1: 719.0965,
    y1: 864.2097,
    x2: 727.5668,
    y2: 864.2097
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101818174174968329000000012229590534119332522_)"
    },
    d: "M720.618,862.703l3.571-1.478 l0.02-0.008c1.239-0.513,2.66,0.075,3.173,1.315c0.513,1.239-0.074,2.659-1.313,3.172l-3.609,1.498 c-1.24,0.515-2.662-0.073-3.177-1.313c-0.515-1.24,0.073-2.662,1.313-3.177l0.002-0.001L720.618,862.703z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137850125254204354170000009248325019217083830_",
    gradientUnits: "userSpaceOnUse",
    x1: 731.0181,
    y1: 859.0776,
    x2: 739.4312,
    y2: 859.0776
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137850125254204354170000009248325019217083830_)"
    },
    d: "M732.471,857.655l3.528-1.58 l0.018-0.008c1.221-0.547,2.655,0,3.201,1.221c0.547,1.221,0.002,2.654-1.219,3.2l-3.563,1.6 c-1.222,0.548-2.656,0.003-3.205-1.219c-0.548-1.221-0.003-2.657,1.219-3.205l0.002-0.001L732.471,857.655z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124143220896112552000000000578401389296368524_",
    gradientUnits: "userSpaceOnUse",
    x1: 742.7939,
    y1: 853.6205,
    x2: 751.1501,
    y2: 853.6205
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124143220896112552000000000578401389296368524_)"
    },
    d: "M744.183,852.277l3.487-1.673 l0.017-0.008c1.203-0.578,2.647-0.07,3.225,1.133c0.578,1.203,0.072,2.646-1.131,3.224l-3.518,1.693 c-1.204,0.579-2.649,0.073-3.228-1.131c-0.579-1.204-0.073-2.649,1.131-3.228l0.002-0.001L744.183,852.277z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156553441577444053630000003902726257684234412_",
    gradientUnits: "userSpaceOnUse",
    x1: 754.4265,
    y1: 847.8663,
    x2: 762.7271,
    y2: 847.8663
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156553441577444053630000003902726257684234412_)"
    },
    d: "M755.758,846.597l3.446-1.759 l0.015-0.008c1.186-0.606,2.638-0.135,3.243,1.051c0.605,1.186,0.136,2.637-1.049,3.242l-3.475,1.777 c-1.186,0.607-2.64,0.137-3.247-1.049c-0.607-1.186-0.137-2.64,1.049-3.247l0.002-0.001L755.758,846.597z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116236240045382318310000011147690538033730999_",
    gradientUnits: "userSpaceOnUse",
    x1: 765.9205,
    y1: 841.8422,
    x2: 774.1672,
    y2: 841.8422
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116236240045382318310000011147690538033730999_)"
    },
    d: "M767.2,840.641l3.407-1.836l0.013-0.007 c1.169-0.63,2.628-0.193,3.258,0.976c0.63,1.169,0.195,2.627-0.974,3.257l-3.433,1.854c-1.17,0.632-2.63,0.196-3.261-0.974 c-0.632-1.17-0.196-2.63,0.974-3.262l0.002-0.001L767.2,840.641z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054967429106188971390000017328593441307616439_",
    gradientUnits: "userSpaceOnUse",
    x1: 777.2826,
    y1: 835.5756,
    x2: 785.4778,
    y2: 835.5756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054967429106188971390000017328593441307616439_)"
    },
    d: "M778.514,834.438l3.371-1.906 l0.012-0.007c1.153-0.652,2.617-0.245,3.269,0.908c0.652,1.154,0.247,2.616-0.906,3.268l-3.393,1.922 c-1.154,0.654-2.619,0.248-3.272-0.906c-0.654-1.154-0.248-2.619,0.906-3.272l0.002-0.001L778.514,834.438z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088839263839200803850000004523896655129991835_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.5209,
    y1: 829.0927,
    x2: 796.6676,
    y2: 829.0927
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088839263839200803850000004523896655129991835_)"
    },
    d: "M789.711,828.013l3.337-1.967 l0.01-0.006c1.139-0.671,2.606-0.292,3.277,0.846c0.671,1.139,0.294,2.605-0.845,3.276l-3.357,1.983 c-1.139,0.673-2.607,0.295-3.28-0.844c-0.673-1.139-0.295-2.607,0.844-3.28l0.002-0.001L789.711,828.013z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158014345019198808180000013241921682097485217_",
    gradientUnits: "userSpaceOnUse",
    x1: 799.6457,
    y1: 822.4197,
    x2: 807.7471,
    y2: 822.4197
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158014345019198808180000013241921682097485217_)"
    },
    d: "M800.799,821.391l3.307-2.021 l0.009-0.006c1.125-0.688,2.594-0.333,3.282,0.792s0.335,2.593-0.79,3.281l-3.323,2.035c-1.125,0.689-2.596,0.335-3.285-0.79 c-0.689-1.125-0.336-2.596,0.79-3.285l0.002-0.001L800.799,821.391z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124873634554411958740000008284555482488808871_",
    gradientUnits: "userSpaceOnUse",
    x1: 810.6682,
    y1: 815.5819,
    x2: 818.7289,
    y2: 815.5819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124873634554411958740000008284555482488808871_)"
    },
    d: "M811.789,814.599l3.281-2.068 l0.008-0.005c1.113-0.701,2.583-0.368,3.284,0.745c0.701,1.112,0.37,2.582-0.743,3.283l-3.294,2.081 c-1.113,0.703-2.585,0.37-3.287-0.742c-0.703-1.113-0.37-2.585,0.742-3.287l0.002-0.001L811.789,814.599z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158026956758948819730000001920810124653366945_",
    gradientUnits: "userSpaceOnUse",
    x1: 821.594,
    y1: 808.5943,
    x2: 829.6102,
    y2: 808.5943
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158026956758948819730000001920810124653366945_)"
    },
    d: "M822.684,807.658l3.245-2.113 l0.009-0.006c1.099-0.716,2.571-0.405,3.287,0.695c0.716,1.099,0.407,2.569-0.693,3.285l-3.262,2.128 c-1.099,0.718-2.572,0.408-3.29-0.692c-0.717-1.1-0.408-2.573,0.692-3.29l0.002-0.001L822.684,807.658z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026157200011394086330000016233570175508855480_",
    gradientUnits: "userSpaceOnUse",
    x1: 832.412,
    y1: 801.44,
    x2: 840.3854,
    y2: 801.44
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026157200011394086330000016233570175508855480_)"
    },
    d: "M833.469,800.554l3.215-2.164 l0.009-0.006c1.086-0.73,2.558-0.443,3.289,0.643c0.731,1.086,0.444,2.557-0.641,3.287l-3.231,2.178 c-1.086,0.732-2.56,0.445-3.292-0.641c-0.732-1.086-0.445-2.56,0.641-3.292l0.002-0.001L833.469,800.554z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031910077060880863880000008497060154812518321_",
    gradientUnits: "userSpaceOnUse",
    x1: 843.1246,
    y1: 794.1258,
    x2: 851.0538,
    y2: 794.1258
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031910077060880863880000008497060154812518321_)"
    },
    d: "M844.15,793.288l3.184-2.21l0.008-0.006 c1.072-0.744,2.545-0.479,3.289,0.594c0.744,1.072,0.48,2.544-0.592,3.288l-3.198,2.225c-1.073,0.746-2.547,0.481-3.292-0.592 c-0.746-1.072-0.481-2.546,0.591-3.292l0.002-0.001L844.15,793.288z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125594374968585928460000014036515766459048832_",
    gradientUnits: "userSpaceOnUse",
    x1: 853.7323,
    y1: 786.6614,
    x2: 861.6183,
    y2: 786.6614
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125594374968585928460000014036515766459048832_)"
    },
    d: "M854.728,785.869l3.154-2.254 l0.008-0.006c1.059-0.757,2.532-0.512,3.289,0.547c0.757,1.059,0.514,2.531-0.545,3.288l-3.167,2.268 c-1.059,0.759-2.533,0.515-3.292-0.545c-0.759-1.059-0.515-2.533,0.545-3.292l0.002-0.001L854.728,785.869z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037658548288541759810000017555002640653700480_",
    gradientUnits: "userSpaceOnUse",
    x1: 864.2385,
    y1: 779.0557,
    x2: 872.0823,
    y2: 779.0557
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037658548288541759810000017555002640653700480_)"
    },
    d: "M865.206,778.307l3.125-2.295 l0.007-0.005c1.047-0.769,2.518-0.544,3.287,0.503c0.769,1.047,0.545,2.517-0.501,3.286l-3.137,2.309 c-1.047,0.771-2.52,0.546-3.29-0.5c-0.77-1.047-0.546-2.52,0.5-3.29l0.002-0.001L865.206,778.307z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031193107424636871700000003262870164625865143_",
    gradientUnits: "userSpaceOnUse",
    x1: 874.6466,
    y1: 771.3174,
    x2: 882.4494,
    y2: 771.3174
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031193107424636871700000003262870164625865143_)"
    },
    d: "M875.588,770.61l3.096-2.334 l0.007-0.005c1.035-0.78,2.505-0.573,3.285,0.461c0.78,1.035,0.575,2.504-0.459,3.284l-3.108,2.347 c-1.035,0.781-2.507,0.576-3.288-0.458c-0.781-1.035-0.576-2.507,0.458-3.288l0.002-0.001L875.588,770.61z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119814986649547201990000003358625091100697269_",
    gradientUnits: "userSpaceOnUse",
    x1: 884.9607,
    y1: 763.4554,
    x2: 892.7238,
    y2: 763.4554
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119814986649547201990000003358625091100697269_)"
    },
    d: "M885.878,762.787l3.07-2.37l0.006-0.005 c1.023-0.79,2.492-0.601,3.282,0.422c0.79,1.023,0.603,2.491-0.42,3.281l-3.08,2.383c-1.023,0.791-2.494,0.604-3.285-0.419 c-0.791-1.023-0.604-2.493,0.419-3.285l0.002-0.001L885.878,762.787z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031930165996428282230000006253939106079501473_",
    gradientUnits: "userSpaceOnUse",
    x1: 895.185,
    y1: 755.4781,
    x2: 902.9097,
    y2: 755.4781
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031930165996428282230000006253939106079501473_)"
    },
    d: "M896.079,754.847l3.044-2.404 l0.006-0.004c1.012-0.799,2.479-0.627,3.278,0.385c0.799,1.012,0.628,2.478-0.384,3.277l-3.053,2.415 c-1.012,0.8-2.481,0.629-3.281-0.383c-0.8-1.011-0.629-2.48,0.383-3.281l0.002-0.001L896.079,754.847z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132809928529766777660000015596886924087528085_",
    gradientUnits: "userSpaceOnUse",
    x1: 905.3242,
    y1: 747.3939,
    x2: 913.0118,
    y2: 747.3939
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132809928529766777660000015596886924087528085_)"
    },
    d: "M906.197,746.797l3.02-2.435 l0.005-0.004c1.001-0.807,2.466-0.65,3.273,0.351c0.807,1.001,0.651,2.465-0.349,3.272l-3.028,2.446 c-1.001,0.808-2.468,0.653-3.276-0.348c-0.808-1.001-0.652-2.468,0.348-3.276l0.002-0.002L906.197,746.797z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016033042893547543680000005071240118400263303_",
    gradientUnits: "userSpaceOnUse",
    x1: 915.383,
    y1: 739.2108,
    x2: 923.0352,
    y2: 739.2108
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016033042893547543680000005071240118400263303_)"
    },
    d: "M916.236,738.647l2.997-2.464 l0.005-0.004c0.991-0.814,2.454-0.671,3.268,0.319c0.814,0.991,0.673,2.452-0.318,3.267l-3.005,2.474 c-0.991,0.816-2.455,0.674-3.271-0.316c-0.816-0.991-0.674-2.455,0.317-3.271l0.002-0.001L916.236,738.647z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170269954426369162350000013405561470806962094_",
    gradientUnits: "userSpaceOnUse",
    x1: 925.3665,
    y1: 730.9373,
    x2: 932.9849,
    y2: 730.9373
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170269954426369162350000013405561470806962094_)"
    },
    d: "M926.202,730.404l2.976-2.49 l0.005-0.004c0.981-0.821,2.442-0.691,3.262,0.29c0.821,0.981,0.693,2.44-0.289,3.261l-2.983,2.5 c-0.981,0.822-2.443,0.694-3.265-0.288c-0.822-0.981-0.694-2.443,0.287-3.265l0.002-0.002L926.202,730.404z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061473485345161334080000012860599771542419630_",
    gradientUnits: "userSpaceOnUse",
    x1: 935.2799,
    y1: 722.5808,
    x2: 942.866,
    y2: 722.5808
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061473485345161334080000012860599771542419630_)"
    },
    d: "M936.098,722.076l2.956-2.514 l0.004-0.003c0.972-0.826,2.43-0.708,3.256,0.263c0.826,0.972,0.71,2.429-0.262,3.255l-2.962,2.523 c-0.972,0.828-2.431,0.711-3.259-0.261s-0.711-2.431,0.261-3.259l0.002-0.001L936.098,722.076z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142161434766776661490000017087048709443099526_",
    gradientUnits: "userSpaceOnUse",
    x1: 945.1277,
    y1: 714.1527,
    x2: 952.6768,
    y2: 714.1527
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142161434766776661490000017087048709443099526_)"
    },
    d: "M945.932,713.671l2.936-2.531 c0.961-0.832,2.415-0.727,3.247,0.234c0.832,0.961,0.727,2.415-0.234,3.247l-2.938,2.543c-0.963,0.833-2.419,0.728-3.253-0.235 c-0.833-0.963-0.728-2.419,0.235-3.253L945.932,713.671z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149378189452028675740000011097899188108265383_",
    gradientUnits: "userSpaceOnUse",
    x1: 954.9234,
    y1: 705.658,
    x2: 962.4229,
    y2: 705.658
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149378189452028675740000011097899188108265383_)"
    },
    d: "M955.711,705.207l2.922-2.55 c0.949-0.831,2.392-0.736,3.223,0.213c0.831,0.949,0.737,2.391-0.212,3.222l-2.921,2.563c-0.95,0.834-2.397,0.74-3.231-0.211 c-0.834-0.95-0.74-2.397,0.211-3.231L955.711,705.207z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052807903828635083890000003748693766828289450_",
    gradientUnits: "userSpaceOnUse",
    x1: 964.669,
    y1: 697.1008,
    x2: 972.1185,
    y2: 697.1008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052807903828635083890000003748693766828289450_)"
    },
    d: "M965.44,696.681l2.909-2.568 c0.937-0.83,2.369-0.743,3.199,0.194c0.83,0.937,0.745,2.367-0.192,3.197l-2.907,2.581c-0.938,0.833-2.374,0.748-3.207-0.19 c-0.833-0.938-0.748-2.374,0.19-3.207L965.44,696.681z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031886562810908835770000010889854364360328073_",
    gradientUnits: "userSpaceOnUse",
    x1: 974.3652,
    y1: 688.4926,
    x2: 981.7664,
    y2: 688.4926
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031886562810908835770000010889854364360328073_)"
    },
    d: "M975.121,688.102l2.897-2.584 c0.926-0.828,2.347-0.749,3.175,0.177c0.828,0.925,0.751,2.345-0.174,3.173l-2.894,2.596c-0.927,0.831-2.352,0.754-3.183-0.173 c-0.831-0.927-0.754-2.352,0.173-3.183L975.121,688.102z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050627532156715353170000015872682286921924778_",
    gradientUnits: "userSpaceOnUse",
    x1: 984.0225,
    y1: 679.8362,
    x2: 991.3771,
    y2: 679.8362
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050627532156715353170000015872682286921924778_)"
    },
    d: "M984.765,679.472l2.887-2.598 c0.915-0.825,2.325-0.752,3.15,0.162c0.825,0.914,0.755,2.323-0.16,3.148l-2.883,2.609c-0.916,0.829-2.33,0.758-3.158-0.157 c-0.829-0.916-0.758-2.33,0.158-3.158L984.765,679.472z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115515954594055524340000007448095776750147509_",
    gradientUnits: "userSpaceOnUse",
    x1: 993.6467,
    y1: 671.139,
    x2: 1000.9562,
    y2: 671.139
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115515954594055524340000007448095776750147509_)"
    },
    d: "M994.377,670.8l2.878-2.609 c0.904-0.822,2.304-0.754,3.125,0.15c0.822,0.904,0.757,2.301-0.147,3.123l-2.874,2.62c-0.905,0.825-2.308,0.76-3.133-0.145 c-0.825-0.905-0.76-2.308,0.145-3.133L994.377,670.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055673099700891856670000007533792965761599160_",
    gradientUnits: "userSpaceOnUse",
    x1: 1003.2432,
    y1: 662.4081,
    x2: 1010.5096,
    y2: 662.4081
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055673099700891856670000007533792965761599160_)"
    },
    d: "M1003.962,662.091l2.871-2.618 c0.895-0.817,2.283-0.754,3.1,0.14c0.817,0.895,0.758,2.28-0.137,3.098l-2.867,2.629c-0.896,0.821-2.287,0.761-3.108-0.134 c-0.821-0.896-0.761-2.287,0.135-3.108L1003.962,662.091z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175293860908338948670000010462050348231547298_",
    gradientUnits: "userSpaceOnUse",
    x1: 1012.8179,
    y1: 653.6509,
    x2: 1020.0427,
    y2: 653.6509
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175293860908338948670000010462050348231547298_)"
    },
    d: "M1013.527,653.354l2.866-2.625 c0.886-0.813,2.263-0.753,3.075,0.133c0.813,0.886,0.756,2.259-0.13,3.072l-2.861,2.635c-0.886,0.816-2.267,0.76-3.083-0.126 c-0.817-0.887-0.76-2.267,0.127-3.083L1013.527,653.354z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164494691492351666530000011387555805588849582_",
    gradientUnits: "userSpaceOnUse",
    x1: 1022.372,
    y1: 644.8786,
    x2: 1029.557,
    y2: 644.8786
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164494691492351666530000011387555805588849582_)"
    },
    d: "M1023.073,644.6l2.863-2.631 c0.878-0.807,2.243-0.75,3.05,0.128c0.807,0.877,0.754,2.24-0.124,3.047l-2.857,2.639c-0.878,0.811-2.247,0.757-3.058-0.121 c-0.811-0.878-0.757-2.247,0.121-3.058L1023.073,644.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153686110129868592940000012898250958391762077_",
    gradientUnits: "userSpaceOnUse",
    x1: 1031.9152,
    y1: 636.0948,
    x2: 1039.062,
    y2: 636.0948
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153686110129868592940000012898250958391762077_)"
    },
    d: "M1032.608,635.832l2.861-2.633 c0.87-0.801,2.224-0.745,3.025,0.125c0.801,0.87,0.749,2.22-0.121,3.021l-2.854,2.642c-0.87,0.805-2.228,0.753-3.033-0.117 c-0.805-0.87-0.753-2.228,0.117-3.033L1032.608,635.832z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052071999522764459230000004725635317468574378_",
    gradientUnits: "userSpaceOnUse",
    x1: 1041.4531,
    y1: 627.3065,
    x2: 1048.5637,
    y2: 627.3065
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052071999522764459230000004725635317468574378_)"
    },
    d: "M1042.14,627.057l2.861-2.634 c0.863-0.794,2.206-0.738,3,0.124c0.794,0.863,0.743,2.202-0.12,2.996l-2.854,2.642c-0.863,0.798-2.209,0.747-3.008-0.116 c-0.798-0.863-0.747-2.209,0.116-3.008L1042.14,627.057z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041973826245203020540000014084042428939731627_",
    gradientUnits: "userSpaceOnUse",
    x1: 1050.9921,
    y1: 618.5206,
    x2: 1058.0682,
    y2: 618.5206
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041973826245203020540000014084042428939731627_)"
    },
    d: "M1051.674,618.283l2.863-2.632 c0.856-0.787,2.187-0.731,2.974,0.125c0.787,0.856,0.735,2.184-0.121,2.971l-2.855,2.639c-0.856,0.792-2.191,0.74-2.982-0.116 c-0.792-0.856-0.74-2.191,0.116-2.982L1051.674,618.283z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073706034169887219060000006328800492354377107_",
    gradientUnits: "userSpaceOnUse",
    x1: 1060.5381,
    y1: 609.7439,
    x2: 1067.5817,
    y2: 609.7439
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073706034169887219060000006328800492354377107_)"
    },
    d: "M1061.216,609.516l2.866-2.629 c0.849-0.779,2.17-0.722,2.949,0.128c0.779,0.849,0.725,2.167-0.124,2.945l-2.857,2.635c-0.849,0.784-2.173,0.731-2.957-0.118 c-0.784-0.849-0.731-2.173,0.118-2.957L1061.216,609.516z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096752001659620011840000001700639390885655940_",
    gradientUnits: "userSpaceOnUse",
    x1: 1070.1,
    y1: 600.981,
    x2: 1077.1125,
    y2: 600.981
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096752001659620011840000001700639390885655940_)"
    },
    d: "M1070.775,600.76l2.871-2.623 c0.844-0.771,2.152-0.711,2.923,0.132c0.771,0.844,0.715,2.149-0.129,2.92l-2.862,2.629c-0.843,0.776-2.156,0.721-2.931-0.123 c-0.776-0.843-0.721-2.156,0.123-2.931L1070.775,600.76z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174563943619505188020000012646238530952096131_",
    gradientUnits: "userSpaceOnUse",
    x1: 1079.6794,
    y1: 592.2427,
    x2: 1086.6627,
    y2: 592.2427
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174563943619505188020000012646238530952096131_)"
    },
    d: "M1080.353,592.027l2.878-2.615 c0.838-0.762,2.136-0.699,2.897,0.139c0.762,0.838,0.702,2.133-0.136,2.895l-2.868,2.62c-0.838,0.767-2.139,0.709-2.906-0.129 c-0.767-0.838-0.709-2.139,0.129-2.906L1080.353,592.027z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095304274091911356470000014889887714032634778_",
    gradientUnits: "userSpaceOnUse",
    x1: 1089.283,
    y1: 583.5342,
    x2: 1096.238,
    y2: 583.5342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095304274091911356470000014889887714032634778_)"
    },
    d: "M1089.955,583.323l2.885-2.605 c0.834-0.753,2.119-0.687,2.872,0.146c0.753,0.833,0.69,2.117-0.144,2.869l-2.876,2.611c-0.833,0.758-2.122,0.696-2.88-0.137 c-0.758-0.833-0.697-2.122,0.136-2.88L1089.955,583.323z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103947657551939133580000004886450213739142553_",
    gradientUnits: "userSpaceOnUse",
    x1: 1098.9126,
    y1: 574.8547,
    x2: 1105.84,
    y2: 574.8547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103947657551939133580000004886450213739142553_)"
    },
    d: "M1099.584,574.648l2.894-2.597 c0.828-0.743,2.103-0.674,2.846,0.154c0.743,0.828,0.677,2.1-0.151,2.844l-2.884,2.602c-0.828,0.748-2.106,0.684-2.854-0.144 c-0.748-0.828-0.684-2.106,0.144-2.854L1099.584,574.648z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097495965360832411240000001866126948653280950_",
    gradientUnits: "userSpaceOnUse",
    x1: 1108.5702,
    y1: 566.2071,
    x2: 1115.4709,
    y2: 566.2071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097495965360832411240000001866126948653280950_)"
    },
    d: "M1109.241,566.004l2.903-2.586 c0.824-0.734,2.086-0.661,2.82,0.163c0.734,0.823,0.664,2.084-0.16,2.818l-2.893,2.592c-0.823,0.739-2.089,0.671-2.828-0.152 c-0.739-0.823-0.671-2.089,0.152-2.828L1109.241,566.004z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145050333494390052410000004963534610830236852_",
    gradientUnits: "userSpaceOnUse",
    x1: 1118.2595,
    y1: 557.5953,
    x2: 1125.1346,
    y2: 557.5953
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145050333494390052410000004963534610830236852_)"
    },
    d: "M1118.93,557.395l2.913-2.575 c0.819-0.724,2.07-0.647,2.794,0.172c0.724,0.819,0.649,2.068-0.17,2.792l-2.903,2.58c-0.818,0.729-2.073,0.657-2.802-0.161 c-0.729-0.818-0.657-2.073,0.161-2.802L1118.93,557.395z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167360637447959972440000012175222814304702095_",
    gradientUnits: "userSpaceOnUse",
    x1: 1127.984,
    y1: 549.0241,
    x2: 1134.8348,
    y2: 549.0241
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167360637447959972440000012175222814304702095_)"
    },
    d: "M1128.655,548.825l2.925-2.563 c0.815-0.714,2.054-0.632,2.768,0.183c0.714,0.815,0.634,2.052-0.181,2.766l-2.914,2.567c-0.814,0.719-2.057,0.642-2.776-0.172 c-0.719-0.814-0.642-2.057,0.172-2.776L1128.655,548.825z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057858316684478443600000010241927426517567395_",
    gradientUnits: "userSpaceOnUse",
    x1: 1137.7479,
    y1: 540.4985,
    x2: 1144.5757,
    y2: 540.4985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057858316684478443600000010241927426517567395_)"
    },
    d: "M1138.42,540.3l2.938-2.548 c0.811-0.703,2.038-0.616,2.742,0.195c0.703,0.811,0.618,2.037-0.193,2.74l-2.926,2.552c-0.81,0.709-2.041,0.627-2.75-0.183 c-0.709-0.81-0.627-2.041,0.183-2.75L1138.42,540.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032642499079044512880000000945127239053077914_",
    gradientUnits: "userSpaceOnUse",
    x1: 1147.5559,
    y1: 532.0245,
    x2: 1154.3622,
    y2: 532.0245
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032642499079044512880000000945127239053077914_)"
    },
    d: "M1148.23,531.824l2.953-2.532 c0.807-0.692,2.023-0.599,2.715,0.208c0.692,0.807,0.6,2.022-0.207,2.714l-2.94,2.536c-0.806,0.698-2.026,0.61-2.724-0.196 c-0.698-0.806-0.61-2.026,0.196-2.724L1148.23,531.824z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090989742304924872770000007619214642767334050_",
    gradientUnits: "userSpaceOnUse",
    x1: 1157.4131,
    y1: 523.6086,
    x2: 1164.1995,
    y2: 523.6086
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000090989742304924872770000007619214642767334050_)"
    },
    d: "M1158.09,523.405l2.969-2.514 c0.804-0.681,2.008-0.581,2.689,0.223c0.681,0.804,0.582,2.007-0.222,2.688l-2.956,2.517c-0.803,0.687-2.011,0.592-2.697-0.211 c-0.687-0.803-0.592-2.01,0.211-2.697L1158.09,523.405z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098192103776698218380000015709823008940990597_",
    gradientUnits: "userSpaceOnUse",
    x1: 1167.3251,
    y1: 515.2584,
    x2: 1174.0934,
    y2: 515.2584
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098192103776698218380000015709823008940990597_)"
    },
    d: "M1168.006,515.049l2.986-2.493 c0.801-0.669,1.993-0.561,2.662,0.24c0.669,0.801,0.562,1.992-0.239,2.661l-2.973,2.496c-0.8,0.675-1.996,0.573-2.671-0.227 c-0.675-0.8-0.573-1.996,0.227-2.671L1168.006,515.049z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092448930729484366500000016004533913109579169_",
    gradientUnits: "userSpaceOnUse",
    x1: 1177.2981,
    y1: 506.9824,
    x2: 1184.0505,
    y2: 506.9824
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092448930729484366500000016004533913109579169_)"
    },
    d: "M1177.984,506.766l3.007-2.469 c0.799-0.656,1.978-0.54,2.635,0.258c0.656,0.799,0.541,1.978-0.258,2.634l-2.992,2.472c-0.798,0.662-1.981,0.552-2.644-0.245 c-0.662-0.798-0.552-1.981,0.245-2.643L1177.984,506.766z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140724292369602742670000012005902821092159901_",
    gradientUnits: "userSpaceOnUse",
    x1: 1187.3392,
    y1: 498.7889,
    x2: 1194.0817,
    y2: 498.7889
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140724292369602742670000012005902821092159901_)"
    },
    d: "M1188.031,498.564l3.033-2.446 c0.797-0.643,1.964-0.518,2.607,0.279c0.643,0.797,0.518,1.964-0.279,2.607l0,0l-3.018,2.448l-0.004,0.003 c-0.797,0.647-1.968,0.525-2.615-0.272c-0.647-0.798-0.525-1.969,0.273-2.615L1188.031,498.564z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147903122694720637050000000362547906205706380_",
    gradientUnits: "userSpaceOnUse",
    x1: 1197.4596,
    y1: 490.6892,
    x2: 1204.1908,
    y2: 490.6892
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147903122694720637050000000362547906205706380_)"
    },
    d: "M1198.159,490.452l3.057-2.416 c0.796-0.629,1.95-0.493,2.579,0.302c0.629,0.795,0.493,1.95-0.302,2.579l0,0l-3.041,2.417l-0.005,0.004 c-0.796,0.633-1.954,0.5-2.587-0.296c-0.633-0.796-0.5-1.955,0.296-2.587L1198.159,490.452z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073705239452963568420000006066319269047293626_",
    gradientUnits: "userSpaceOnUse",
    x1: 1207.6637,
    y1: 482.6974,
    x2: 1214.3862,
    y2: 482.6974
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073705239452963568420000006066319269047293626_)"
    },
    d: "M1208.373,482.444l3.084-2.381 c0.795-0.614,1.937-0.467,2.55,0.328c0.614,0.795,0.467,1.936-0.328,2.55l-0.001,0.001l-3.067,2.382l-0.005,0.004 c-0.795,0.618-1.941,0.473-2.558-0.322c-0.618-0.795-0.474-1.941,0.322-2.559L1208.373,482.444z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093870098853819042620000004042008359253253530_",
    gradientUnits: "userSpaceOnUse",
    x1: 1217.9604,
    y1: 474.8276,
    x2: 1224.6771,
    y2: 474.8276
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093870098853819042620000004042008359253253530_)"
    },
    d: "M1218.681,474.556l3.114-2.342 c0.794-0.598,1.923-0.438,2.521,0.356c0.598,0.794,0.438,1.923-0.356,2.521l-0.002,0.001l-3.096,2.343l-0.006,0.004 c-0.795,0.602-1.927,0.445-2.529-0.35c-0.602-0.795-0.445-1.927,0.351-2.529L1218.681,474.556z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020389643053506304790000010816223188190241969_",
    gradientUnits: "userSpaceOnUse",
    x1: 1228.3591,
    y1: 467.0961,
    x2: 1235.0729,
    y2: 467.0961
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020389643053506304790000010816223188190241969_)"
    },
    d: "M1229.092,466.801l3.147-2.299 c0.795-0.581,1.91-0.407,2.49,0.388c0.58,0.795,0.407,1.91-0.388,2.49l-0.002,0.002l-3.128,2.298l-0.006,0.005 c-0.796,0.585-1.914,0.413-2.499-0.382c-0.584-0.796-0.413-1.915,0.382-2.499L1229.092,466.801z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121238752601390266880000007493490062502373511_",
    gradientUnits: "userSpaceOnUse",
    x1: 1238.8698,
    y1: 459.5205,
    x2: 1245.5839,
    y2: 459.5205
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121238752601390266880000007493490062502373511_)"
    },
    d: "M1239.618,459.199l3.183-2.249 c0.796-0.562,1.897-0.373,2.459,0.423c0.562,0.796,0.373,1.897-0.423,2.459l-0.003,0.002l-3.162,2.248l-0.007,0.005 c-0.797,0.566-1.901,0.379-2.468-0.417c-0.566-0.797-0.379-1.901,0.417-2.467L1239.618,459.199z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092416092205423766410000007688020727397937303_",
    gradientUnits: "userSpaceOnUse",
    x1: 1249.5027,
    y1: 452.1205,
    x2: 1256.2202,
    y2: 452.1205
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092416092205423766410000007688020727397937303_)"
    },
    d: "M1250.269,451.769l3.222-2.193 c0.797-0.543,1.884-0.336,2.426,0.461c0.543,0.797,0.336,1.884-0.461,2.426l-0.004,0.003l-3.2,2.191l-0.008,0.006 c-0.798,0.546-1.888,0.343-2.435-0.456c-0.547-0.798-0.343-1.888,0.456-2.435L1250.269,451.769z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164496425986964238070000009382577532808836527_",
    gradientUnits: "userSpaceOnUse",
    x1: 1260.2681,
    y1: 444.9182,
    x2: 1266.9921,
    y2: 444.9182
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164496425986964238070000009382577532808836527_)"
    },
    d: "M1261.054,444.531l3.264-2.131 c0.799-0.522,1.87-0.297,2.392,0.503c0.522,0.799,0.297,1.87-0.503,2.392l-0.005,0.003l-3.241,2.128l-0.009,0.006 c-0.8,0.526-1.875,0.303-2.401-0.498c-0.526-0.8-0.303-1.875,0.497-2.401L1261.054,444.531z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067217387074204758000000009174585529446832040_",
    gradientUnits: "userSpaceOnUse",
    x1: 1271.1758,
    y1: 437.9363,
    x2: 1277.9091,
    y2: 437.9363
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000067217387074204758000000009174585529446832040_)"
    },
    d: "M1271.985,437.51l3.31-2.061 c0.802-0.499,1.857-0.254,2.356,0.548c0.499,0.802,0.254,1.857-0.548,2.356l-0.006,0.004l-3.284,2.058l-0.01,0.006 c-0.803,0.503-1.862,0.26-2.365-0.543c-0.503-0.803-0.26-1.862,0.543-2.365L1271.985,437.51z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084525416869322616520000015626707380563401138_",
    gradientUnits: "userSpaceOnUse",
    x1: 1282.2347,
    y1: 431.1996,
    x2: 1288.9797,
    y2: 431.1996
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084525416869322616520000015626707380563401138_)"
    },
    d: "M1283.069,430.729l3.357-1.984 c0.805-0.476,1.843-0.209,2.318,0.596c0.475,0.805,0.209,1.842-0.596,2.318l-0.007,0.004l-3.33,1.98l-0.01,0.006 c-0.806,0.479-1.848,0.214-2.327-0.592c-0.479-0.806-0.214-1.848,0.591-2.327L1283.069,430.729z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046304891334075315640000016565952450257331610_",
    gradientUnits: "userSpaceOnUse",
    x1: 1293.4557,
    y1: 424.7307,
    x2: 1300.2142,
    y2: 424.7307
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046304891334075315640000016565952450257331610_)"
    },
    d: "M1294.318,424.212l3.406-1.899 c0.808-0.45,1.828-0.161,2.278,0.647c0.45,0.808,0.161,1.828-0.647,2.278l-0.007,0.004l-3.378,1.896l-0.011,0.006 c-0.809,0.454-1.833,0.166-2.287-0.643c-0.454-0.809-0.166-1.833,0.643-2.287L1294.318,424.212z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175320336247699189780000010388270713240983191_",
    gradientUnits: "userSpaceOnUse",
    x1: 1304.839,
    y1: 418.5571,
    x2: 1311.6119,
    y2: 418.5571
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175320336247699189780000010388270713240983191_)"
    },
    d: "M1305.731,417.987l3.456-1.807 c0.811-0.424,1.812-0.11,2.236,0.701c0.424,0.811,0.11,1.812-0.7,2.236l-0.008,0.004l-3.427,1.804l-0.012,0.006 c-0.812,0.427-1.817,0.116-2.245-0.697c-0.428-0.812-0.116-1.817,0.697-2.245L1305.731,417.987z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145050831359868779370000010864846206432440740_",
    gradientUnits: "userSpaceOnUse",
    x1: 1316.387,
    y1: 412.7008,
    x2: 1323.1743,
    y2: 412.7008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145050831359868779370000010864846206432440740_)"
    },
    d: "M1317.311,412.077l3.506-1.709 c0.814-0.396,1.795-0.058,2.191,0.755c0.396,0.814,0.058,1.795-0.755,2.191l-0.009,0.004l-3.476,1.706l-0.013,0.006 c-0.815,0.4-1.8,0.063-2.2-0.752c-0.4-0.815-0.064-1.8,0.752-2.2L1317.311,412.077z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181072248289737741980000004743478932169705108_",
    gradientUnits: "userSpaceOnUse",
    x1: 1328.0999,
    y1: 407.183,
    x2: 1334.8922,
    y2: 407.183
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181072248289737741980000004743478932169705108_)"
    },
    d: "M1329.057,406.503l3.556-1.602 c0.813-0.366,1.77-0.004,2.136,0.809c0.366,0.813,0.004,1.77-0.809,2.136l-0.006,0.003l-3.523,1.606l-0.013,0.006 c-0.816,0.372-1.779,0.012-2.151-0.804c-0.372-0.816-0.012-1.779,0.804-2.151L1329.057,406.503z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161606638265295682990000008522619183737658511_",
    gradientUnits: "userSpaceOnUse",
    x1: 1339.9825,
    y1: 402.0129,
    x2: 1346.7626,
    y2: 402.0129
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161606638265295682990000008522619183737658511_)"
    },
    d: "M1340.966,401.287l3.603-1.495 c0.809-0.336,1.737,0.048,2.072,0.857c0.336,0.809-0.048,1.737-0.857,2.072l-0.007,0.003l-3.569,1.5l-0.013,0.005 c-0.812,0.341-1.747-0.04-2.088-0.852s0.04-1.747,0.852-2.088L1340.966,401.287z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114046646535052638710000005143457876901868465_",
    gradientUnits: "userSpaceOnUse",
    x1: 1352.0166,
    y1: 397.2004,
    x2: 1358.7808,
    y2: 397.2004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114046646535052638710000005143457876901868465_)"
    },
    d: "M1353.026,396.431l3.645-1.386 c0.803-0.306,1.702,0.098,2.008,0.901c0.306,0.803-0.098,1.702-0.901,2.008l-0.006,0.002l-3.613,1.393l-0.013,0.005 c-0.807,0.311-1.712-0.091-2.023-0.897c-0.311-0.806,0.091-1.712,0.897-2.023L1353.026,396.431z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121963343720443037190000012944212816346946699_",
    gradientUnits: "userSpaceOnUse",
    x1: 1364.1896,
    y1: 392.7464,
    x2: 1370.9338,
    y2: 392.7464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121963343720443037190000012944212816346946699_)"
    },
    d: "M1365.222,391.935l3.684-1.279 c0.797-0.277,1.667,0.145,1.943,0.942c0.277,0.797-0.145,1.667-0.942,1.943l-0.006,0.002l-3.653,1.287l-0.013,0.004 c-0.8,0.282-1.677-0.138-1.959-0.938c-0.282-0.8,0.138-1.677,0.938-1.959L1365.222,391.935z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181053247246410814610000002168128347506361218_",
    gradientUnits: "userSpaceOnUse",
    x1: 1376.485,
    y1: 388.6456,
    x2: 1383.2025,
    y2: 388.6456
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181053247246410814610000002168128347506361218_)"
    },
    d: "M1377.538,387.796l3.715-1.173 c0.789-0.249,1.63,0.189,1.879,0.977c0.249,0.789-0.188,1.63-0.977,1.879l-0.006,0.002l-3.686,1.182l-0.012,0.004 c-0.792,0.254-1.641-0.182-1.895-0.974c-0.254-0.792,0.182-1.641,0.974-1.895L1377.538,387.796z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178164369693832809910000011524665301386459049_",
    gradientUnits: "userSpaceOnUse",
    x1: 1388.8896,
    y1: 384.8938,
    x2: 1395.5792,
    y2: 384.8938
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178164369693832809910000011524665301386459049_)"
    },
    d: "M1389.962,384.007l3.746-1.067 c0.78-0.222,1.592,0.23,1.814,1.01c0.222,0.78-0.23,1.592-1.01,1.815l-0.005,0.002l-3.717,1.077l-0.012,0.004 c-0.784,0.227-1.603-0.224-1.83-1.008c-0.227-0.783,0.224-1.603,1.008-1.83L1389.962,384.007z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078038049423558844010000013698272887079809416_",
    gradientUnits: "userSpaceOnUse",
    x1: 1401.3981,
    y1: 381.4944,
    x2: 1408.0591,
    y2: 381.4944
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078038049423558844010000013698272887079809416_)"
    },
    d: "M1402.489,380.572l3.776-0.961 c0.77-0.196,1.553,0.27,1.749,1.04c0.196,0.77-0.269,1.553-1.04,1.75l-0.005,0.001l-3.748,0.972l-0.012,0.003 c-0.774,0.201-1.564-0.264-1.765-1.038c-0.201-0.774,0.264-1.564,1.038-1.765L1402.489,380.572z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052097130808421407700000018210831322489501583_",
    gradientUnits: "userSpaceOnUse",
    x1: 1413.9994,
    y1: 378.45,
    x2: 1420.6254,
    y2: 378.45
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052097130808421407700000018210831322489501583_)"
    },
    d: "M1415.107,377.493l3.799-0.854 c0.76-0.171,1.514,0.307,1.684,1.066c0.171,0.759-0.307,1.513-1.066,1.684l-0.005,0.001l-3.772,0.866l-0.012,0.003 c-0.764,0.175-1.525-0.302-1.7-1.065c-0.175-0.763,0.302-1.524,1.065-1.7L1415.107,377.493z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178191190925049231700000017049781070916651414_",
    gradientUnits: "userSpaceOnUse",
    x1: 1426.6824,
    y1: 375.7591,
    x2: 1433.2731,
    y2: 375.7591
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178191190925049231700000017049781070916651414_)"
    },
    d: "M1427.805,374.77l3.823-0.748 c0.748-0.146,1.473,0.341,1.62,1.09c0.146,0.748-0.341,1.473-1.089,1.62l-0.005,0.001l-3.797,0.761l-0.011,0.002 c-0.752,0.151-1.484-0.337-1.635-1.089c-0.151-0.752,0.337-1.484,1.089-1.635L1427.805,374.77z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073709123795209995870000004053745989455566986_",
    gradientUnits: "userSpaceOnUse",
    x1: 1439.4357,
    y1: 373.42,
    x2: 1445.9873,
    y2: 373.42
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073709123795209995870000004053745989455566986_)"
    },
    d: "M1440.571,372.4l3.842-0.642 c0.736-0.123,1.432,0.374,1.555,1.11c0.123,0.736-0.374,1.432-1.109,1.555l-0.005,0.001l-3.817,0.656l-0.011,0.002 c-0.74,0.127-1.443-0.37-1.57-1.11c-0.127-0.74,0.37-1.443,1.11-1.57L1440.571,372.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150079245832574230680000017763149397690183853_",
    gradientUnits: "userSpaceOnUse",
    x1: 1452.2518,
    y1: 371.429,
    x2: 1458.7582,
    y2: 371.429
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150079245832574230680000017763149397690183853_)"
    },
    d: "M1453.399,370.38l3.855-0.538 c0.723-0.101,1.391,0.403,1.491,1.126c0.101,0.723-0.403,1.391-1.126,1.492l-0.005,0.001l-3.832,0.552l-0.01,0.002 c-0.727,0.105-1.402-0.4-1.507-1.127c-0.105-0.727,0.4-1.402,1.127-1.507L1453.399,370.38z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180339109460912694800000009139064443876763777_",
    gradientUnits: "userSpaceOnUse",
    x1: 1465.1169,
    y1: 369.7821,
    x2: 1471.5784,
    y2: 369.7821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180339109460912694800000009139064443876763777_)"
    },
    d: "M1466.273,368.707l3.869-0.435 c0.709-0.08,1.349,0.43,1.428,1.14c0.08,0.709-0.431,1.349-1.14,1.428l-0.004,0.001l-3.847,0.451l-0.01,0.001 c-0.714,0.083-1.36-0.427-1.443-1.141c-0.083-0.714,0.427-1.36,1.141-1.444L1466.273,368.707z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165950043792977442270000007845203200653950857_",
    gradientUnits: "userSpaceOnUse",
    x1: 1478.0242,
    y1: 368.4742,
    x2: 1484.4376,
    y2: 368.4742
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165950043792977442270000007845203200653950857_)"
    },
    d: "M1479.187,367.374l3.88-0.334 c0.695-0.06,1.307,0.455,1.366,1.15c0.06,0.695-0.455,1.307-1.15,1.366l-0.004,0.001l-3.858,0.35l-0.01,0.001 c-0.699,0.064-1.318-0.452-1.381-1.152c-0.063-0.7,0.452-1.318,1.152-1.381L1479.187,367.374z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000930226312105781870000011757425502685978020_",
    gradientUnits: "userSpaceOnUse",
    x1: 1490.9609,
    y1: 367.5004,
    x2: 1497.3232,
    y2: 367.5004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000930226312105781870000011757425502685978020_)"
    },
    d: "M1492.129,366.378l3.887-0.234 c0.68-0.041,1.265,0.477,1.306,1.157c0.041,0.68-0.477,1.264-1.157,1.305l-0.004,0l-3.867,0.251l-0.009,0 c-0.685,0.044-1.276-0.475-1.32-1.159c-0.044-0.685,0.475-1.276,1.159-1.32L1492.129,366.378z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178166678393832248170000001300907830005428135_",
    gradientUnits: "userSpaceOnUse",
    x1: 1503.9213,
    y1: 366.8547,
    x2: 1510.2257,
    y2: 366.8547
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178166678393832248170000001300907830005428135_)"
    },
    d: "M1505.092,365.711l3.888-0.136 c0.665-0.023,1.222,0.497,1.246,1.161c0.023,0.664-0.496,1.222-1.161,1.246l-0.004,0l-3.869,0.153l-0.009,0 c-0.669,0.027-1.234-0.494-1.26-1.164c-0.027-0.669,0.495-1.233,1.164-1.26L1505.092,365.711z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031912981495485468730000009572790980158302348_",
    gradientUnits: "userSpaceOnUse",
    x1: 1516.892,
    y1: 366.5309,
    x2: 1523.141,
    y2: 366.5309
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031912981495485468730000009572790980158302348_)"
    },
    d: "M1518.063,365.368l3.891-0.041 c0.649-0.007,1.18,0.514,1.187,1.162c0.007,0.649-0.514,1.18-1.162,1.187h-0.003l-3.873,0.058h-0.009 c-0.654,0.01-1.191-0.512-1.201-1.166c-0.01-0.654,0.512-1.191,1.166-1.201H1518.063z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018220960413656146210000015414081097755878020_",
    gradientUnits: "userSpaceOnUse",
    x1: 1529.8698,
    y1: 366.5135,
    x2: 1536.0608,
    y2: 366.5135
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018220960413656146210000015414081097755878020_)"
    },
    d: "M1531.04,365.342l3.891,0.053 c0.632,0.008,1.138,0.528,1.13,1.161c-0.009,0.633-0.528,1.138-1.161,1.13h-0.003l-3.875-0.035h-0.008 c-0.637-0.006-1.15-0.527-1.144-1.165c0.006-0.637,0.527-1.149,1.165-1.143H1531.04z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013189668340116011880000010583529663035863169_",
    gradientUnits: "userSpaceOnUse",
    x1: 1542.8425,
    y1: 366.8131,
    x2: 1548.973,
    y2: 366.8131
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013189668340116011880000010583529663035863169_)"
    },
    d: "M1544.009,365.626l3.889,0.145 c0.616,0.023,1.097,0.541,1.074,1.157c-0.023,0.616-0.541,1.097-1.157,1.074h-0.003l-3.874-0.126l-0.008,0 c-0.621-0.02-1.108-0.54-1.088-1.161c0.02-0.621,0.54-1.108,1.161-1.088L1544.009,365.626z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140016562358944095860000004145553906467200914_",
    gradientUnits: "userSpaceOnUse",
    x1: 1555.8079,
    y1: 367.4142,
    x2: 1561.8759,
    y2: 367.4142
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140016562358944095860000004145553906467200914_)"
    },
    d: "M1556.969,366.212l3.885,0.234 c0.599,0.036,1.056,0.551,1.019,1.15c-0.036,0.599-0.551,1.055-1.15,1.02l-0.003,0l-3.871-0.216l-0.007,0 c-0.604-0.034-1.067-0.551-1.033-1.155c0.034-0.604,0.551-1.066,1.155-1.033L1556.969,366.212z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111882561306044242070000003569056663231180223_",
    gradientUnits: "userSpaceOnUse",
    x1: 1568.7588,
    y1: 368.3094,
    x2: 1574.7621,
    y2: 368.3094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111882561306044242070000003569056663231180223_)"
    },
    d: "M1569.913,367.095l3.879,0.321 c0.582,0.048,1.015,0.559,0.966,1.141c-0.048,0.582-0.559,1.015-1.141,0.966h-0.002l-3.866-0.303l-0.007,0 c-0.587-0.046-1.026-0.559-0.98-1.146c0.046-0.587,0.559-1.026,1.146-0.98L1569.913,367.095z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093889583900067310800000008825388292203969941_",
    gradientUnits: "userSpaceOnUse",
    x1: 1581.6887,
    y1: 369.4916,
    x2: 1587.6256,
    y2: 369.4916
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093889583900067310800000008825388292203969941_)"
    },
    d: "M1582.834,368.266l3.871,0.406 c0.565,0.059,0.974,0.565,0.915,1.13c-0.059,0.565-0.565,0.974-1.13,0.915l-0.002,0l-3.859-0.387l-0.007-0.001 c-0.57-0.057-0.985-0.565-0.928-1.135c0.057-0.57,0.566-0.985,1.135-0.928L1582.834,368.266z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001660560507747248820000003105801069376181123_",
    gradientUnits: "userSpaceOnUse",
    x1: 1594.5917,
    y1: 370.9529,
    x2: 1600.4569,
    y2: 370.9529
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001660560507747248820000003105801069376181123_)"
    },
    d: "M1595.726,369.718l3.858,0.489 c0.547,0.069,0.935,0.569,0.865,1.117c-0.069,0.547-0.569,0.935-1.116,0.865l-0.002,0l-3.847-0.47l-0.006-0.001 c-0.552-0.067-0.945-0.57-0.878-1.122c0.068-0.552,0.57-0.945,1.122-0.878L1595.726,369.718z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123429448639076096730000007518815174026110860_",
    gradientUnits: "userSpaceOnUse",
    x1: 1607.4587,
    y1: 372.6858,
    x2: 1613.2552,
    y2: 372.6858
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123429448639076096730000007518815174026110860_)"
    },
    d: "M1608.58,371.442l3.848,0.569 c0.53,0.078,0.895,0.571,0.817,1.101c-0.078,0.53-0.571,0.895-1.101,0.817l-0.001,0l-3.838-0.55l-0.006-0.001 c-0.535-0.077-0.906-0.573-0.83-1.107c0.077-0.535,0.572-0.906,1.107-0.829L1608.58,371.442z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072979609755130178500000007416347079445233052_",
    gradientUnits: "userSpaceOnUse",
    x1: 1620.2865,
    y1: 374.6808,
    x2: 1626.0057,
    y2: 374.6808
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072979609755130178500000007416347079445233052_)"
    },
    d: "M1621.392,373.434l3.835,0.651 c0.509,0.086,0.852,0.569,0.766,1.078c-0.086,0.507-0.565,0.849-1.072,0.767l-0.006-0.001l-3.828-0.625l-0.006-0.001 c-0.516-0.085-0.866-0.571-0.782-1.087c0.084-0.516,0.571-0.866,1.087-0.782L1621.392,373.434z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054968267576318072530000010542180672651368091_",
    gradientUnits: "userSpaceOnUse",
    x1: 1633.0835,
    y1: 376.9343,
    x2: 1638.7109,
    y2: 376.9343
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054968267576318072530000010542180672651368091_)"
    },
    d: "M1634.161,375.691l3.822,0.727 c0.486,0.092,0.805,0.561,0.713,1.047c-0.092,0.484-0.557,0.802-1.042,0.714l-0.005-0.001l-3.816-0.701l-0.005-0.001 c-0.493-0.091-0.819-0.564-0.729-1.057c0.091-0.493,0.564-0.819,1.057-0.728L1634.161,375.691z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074428091772553635740000016044019065772991399_",
    gradientUnits: "userSpaceOnUse",
    x1: 1645.8364,
    y1: 379.4369,
    x2: 1651.3706,
    y2: 379.4369
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000074428091772553635740000016044019065772991399_)"
    },
    d: "M1646.883,378.2l3.807,0.8 c0.463,0.098,0.759,0.551,0.662,1.014c-0.097,0.461-0.553,0.756-1.014,0.662l-3.802-0.775c-0.47-0.093-0.776-0.55-0.683-1.02 c0.093-0.47,0.55-0.776,1.02-0.683L1646.883,378.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083086738068177819290000016805174925228883081_",
    gradientUnits: "userSpaceOnUse",
    x1: 1658.541,
    y1: 382.182,
    x2: 1663.981,
    y2: 382.182
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083086738068177819290000016805174925228883081_)"
    },
    d: "M1659.556,380.951l3.792,0.872 c0.44,0.101,0.714,0.54,0.613,0.979c-0.101,0.438-0.541,0.711-0.979,0.613l-3.788-0.846c-0.447-0.097-0.731-0.539-0.634-0.986 c0.097-0.447,0.539-0.731,0.986-0.634L1659.556,380.951z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093159607474352065090000014167246225631876784_",
    gradientUnits: "userSpaceOnUse",
    x1: 1671.1937,
    y1: 385.1613,
    x2: 1676.5343,
    y2: 385.1613
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093159607474352065090000014167246225631876784_)"
    },
    d: "M1672.174,383.938l3.77,0.94 c0.417,0.104,0.67,0.526,0.566,0.942c-0.104,0.415-0.527,0.667-0.942,0.567l-3.768-0.915c-0.424-0.101-0.686-0.526-0.586-0.95 c0.101-0.424,0.526-0.687,0.95-0.586L1672.174,383.938z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125595618242772851470000006310652992635538618_",
    gradientUnits: "userSpaceOnUse",
    x1: 1683.7872,
    y1: 388.3677,
    x2: 1689.0338,
    y2: 388.3677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125595618242772851470000006310652992635538618_)"
    },
    d: "M1684.732,387.152l3.755,1.008 c0.394,0.105,0.627,0.51,0.522,0.904c-0.105,0.392-0.511,0.625-0.904,0.522l-3.754-0.983c-0.401-0.103-0.643-0.512-0.54-0.913 c0.103-0.401,0.511-0.643,0.913-0.541L1684.732,387.152z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122705538947730275840000007002325778530114438_",
    gradientUnits: "userSpaceOnUse",
    x1: 1696.3229,
    y1: 391.7942,
    x2: 1701.4739,
    y2: 391.7942
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122705538947730275840000007002325778530114438_)"
    },
    d: "M1697.23,390.587l3.738,1.073 c0.371,0.106,0.585,0.494,0.479,0.865c-0.106,0.369-0.494,0.583-0.864,0.479l-3.738-1.048c-0.378-0.104-0.601-0.495-0.497-0.874 c0.104-0.378,0.495-0.601,0.874-0.497L1697.23,390.587z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027564776270738028220000000927750807862873517_",
    gradientUnits: "userSpaceOnUse",
    x1: 1708.802,
    y1: 395.4349,
    x2: 1713.8561,
    y2: 395.4349
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027564776270738028220000000927750807862873517_)"
    },
    d: "M1709.669,394.237l3.72,1.136 c0.348,0.107,0.544,0.475,0.438,0.823c-0.106,0.347-0.475,0.542-0.822,0.438l-3.72-1.111c-0.356-0.104-0.559-0.477-0.455-0.833 c0.104-0.356,0.477-0.56,0.833-0.455L1709.669,394.237z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096745376361275254800000005294928798010781855_",
    gradientUnits: "userSpaceOnUse",
    x1: 2078.5942,
    y1: 840.8711,
    x2: 1666.8984,
    y2: 280.575
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096745376361275254800000005294928798010781855_)"
    },
    d: "M2199.794,431.316 c-1.482-22.899-15.311-43.185-36.039-53.029l-268.557-127.547c-17.199-8.168-37.159-8.168-54.357,0l-268.557,127.547 c-20.728,9.845-34.557,30.13-36.039,53.029c-25.191,389.385,224.478,531.261,306.322,567.099 c16.231,7.108,34.673,7.108,50.904,0C1975.316,962.576,2224.984,820.7,2199.794,431.316z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018237131588334026670000018393775297657433776_",
    gradientUnits: "userSpaceOnUse",
    x1: 1783.5735,
    y1: 285.5941,
    x2: 1853.4465,
    y2: 285.5941
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018237131588334026670000018393775297657433776_)"
    },
    d: "M1786.785,303.872 c-1.2,0-2.351-0.676-2.9-1.832c-0.76-1.601-0.079-3.514,1.521-4.274l63.455-30.138c1.6-0.761,3.514-0.079,4.274,1.522 c0.76,1.6,0.079,3.514-1.521,4.274l-63.455,30.138C1787.715,303.772,1787.246,303.872,1786.785,303.872z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026864058397407868790000007737019322744534673_",
    gradientUnits: "userSpaceOnUse",
    x1: 1553.1595,
    y1: 411.5509,
    x2: 1765.5515,
    y2: 411.5509
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026864058397407868790000007737019322744534673_)"
    },
    d: "M1556.782,514.041 c-1.722,0-3.146-1.366-3.205-3.1c-0.85-25.307-0.404-51.69,1.325-78.418c1.041-16.089,10.774-30.4,25.401-37.348l180.662-85.803 c1.601-0.761,3.514-0.079,4.274,1.522c0.76,1.601,0.079,3.514-1.521,4.274l-180.662,85.803 c-12.526,5.949-20.861,18.198-21.751,31.966c-1.716,26.519-2.158,52.69-1.315,77.788c0.059,1.771-1.328,3.255-3.099,3.314 C1556.855,514.041,1556.819,514.041,1556.782,514.041z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000084501596665437095970000015199706516972298893_",
    gradientUnits: "userSpaceOnUse",
    x1: 1600.1786,
    y1: 624.2708,
    x2: 2135.8608,
    y2: 624.2708
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000084501596665437095970000015199706516972298893_)"
    },
    d: "M2134.852,446.513 c-0.297-5.805-3.753-10.987-9.003-13.481l-251.055-119.236c-4.286-2.036-9.261-2.036-13.548,0l-251.054,119.236 c-5.251,2.494-8.707,7.676-9.003,13.481c-7.424,145.253,26.126,266.447,99.79,360.38 c56.162,71.615,121.86,109.994,160.359,127.899c4.241,1.973,9.122,1.973,13.364,0c38.498-17.905,104.197-56.284,160.359-127.899 C2108.725,712.96,2142.275,591.765,2134.852,446.513z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034063442282900005540000003682258822324514230_",
    gradientUnits: "userSpaceOnUse",
    x1: 2016.0757,
    y1: 192.4231,
    x2: 1784.076,
    y2: 744.4227
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034063442282900005540000003682258822324514230_)"
    },
    d: "M1793.79,602.573h-25.021v-99.712 c0-39.164,29.318-72.26,68.195-76.985l51.159-6.217c22.019-2.676,44.173,4.225,60.779,18.934 c16.605,14.709,26.128,35.867,26.128,58.051v87.05h-25.021v-87.05c0-15.026-6.451-29.358-17.698-39.321 c-11.248-9.963-26.255-14.639-41.169-12.825l-51.159,6.217c-26.334,3.2-46.192,25.618-46.192,52.146V602.573z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042002521478729429540000009940427476751334324_",
    gradientUnits: "userSpaceOnUse",
    x1: 2066.4561,
    y1: 213.599,
    x2: 1834.4561,
    y2: 765.5996
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042002521478729429540000009940427476751334324_)"
    },
    d: "M1761.372,580.187l219.335-12.152 c8.908-0.493,16.403,6.597,16.403,15.519v173.76c0,8.584-6.959,15.543-15.543,15.543h-214.065 c-8.387,0-15.261-6.654-15.535-15.036l-5.27-161.609C1746.422,587.77,1752.938,580.654,1761.372,580.187z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181796788527500080550000014349173249093204635_",
    gradientUnits: "userSpaceOnUse",
    x1: 1901.9797,
    y1: 838.7405,
    x2: 1867.1411,
    y2: 648.2889
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A22B25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C0423C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181796788527500080550000014349173249093204635_)"
    },
    d: "M1907.656,723.08l-13.275-38.167 c-1.596-4.589-0.509-9.719,2.904-13.177c6.803-6.893,10.857-16.505,10.377-27.062c-0.847-18.618-16.056-33.713-34.679-34.428 c-20.61-0.792-37.567,15.681-37.567,36.115c0,11.336,5.221,21.448,13.389,28.073c4.236,3.436,5.977,9.083,4.185,14.234 l-11.97,34.413c-2.911,8.369,3.303,17.11,12.164,17.11h42.308C1904.354,740.19,1910.568,731.449,1907.656,723.08z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankGuarantee);
export default __webpack_public_path__ + "static/media/bank-guarantee.199c5fbfb6d158c9c430b83ca1b9c28d.svg";
export { ForwardRef as ReactComponent };